function resolvePdfUrl(val) {
  if (!val) return "";
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) {
    if (val.length === 0) return "";
    return resolvePdfUrl(val[0]);
  }
  if (typeof val === 'object') {
    return val.url || "";
  }
  return "";
}

const GRAZ_PLZ_LIST = [
  8010, 8020, 8036, 8041, 8042, 8043, 8044, 8045, 8046, 8047,
  8051, 8052, 8053, 8054, 8055, 8061, 8062, 8063, 8071, 8072,
  8073, 8074, 8075, 8076, 8077, 8081, 8101, 8102, 8103, 8111,
  8112, 8113, 8114, 8120, 8121, 8122, 8124, 8130, 8131, 8141,
  8142, 8143, 8144, 8151, 8152, 8153, 8160, 8163, 8181, 8200,
  8301, 8302, 8322, 8323, 8324, 8401, 8402, 8501, 8561
];
function isGrazPlz(plz) {
  return GRAZ_PLZ_LIST.includes(parseInt(plz, 10));
}

const WIEN_PLZ_LIST = [
  1010, 1020, 1030, 1040, 1050, 1060, 1070, 1080, 1090, 1100,
  1110, 1120, 1130, 1140, 1150, 1160, 1170, 1180, 1190, 1200,
  1210, 1220, 1230, 1300, 2320, 2322, 2325, 2326, 2331, 2332,
  2333, 2334, 2340, 2342, 2344, 2345, 2351, 2352, 2353, 2354,
  2355, 2361, 2362, 2371, 2372, 2380, 2381, 2384, 2385, 2391,
  2392, 2393, 2481, 2482, 2483, 2500, 2504, 2511, 2512, 2514,
  2521, 2522, 2523, 2524, 2525, 2531, 2532, 2533, 2534, 2535,
  2540, 2542, 2544, 2545, 2560, 2601, 2602, 2603
];
function isWienPlz(plz) {
  return WIEN_PLZ_LIST.includes(parseInt(plz, 10));
}

class SVGVisualizer {
  constructor(container) {
    this.container = container;
    this.initSVG();
  }

  initSVG() {
    this.container.innerHTML = `
      <div class="visualizer-wrapper" style="position: relative; width: auto; height: 100%; max-width: 100%; max-height: 100%; aspect-ratio: 5 / 4;">
        <svg viewBox="0 0 1000 800" width="100%" height="100%" style="display: block; width: 100% !important; height: 100% !important; background: #f5f5f7;">
          <defs>
            <pattern id="blueprintGrid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(0,0,0,0.04)" stroke-width="1"/>
            </pattern>
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="0" dy="10" stdDeviation="15" flood-opacity="0.1"/>
            </filter>
          </defs>
          <rect width="1000" height="800" fill="#f5f5f7" />
          <rect width="1000" height="800" fill="url(#blueprintGrid)" />
          <g id="DrawingLayer"></g>
        </svg>
        <div id="HotspotsContainer" style="position:absolute; top:0; left:0; width:100%; height:100%; pointer-events:none;"></div>
      </div>
    `;
    this.drawingLayer = this.container.querySelector('#DrawingLayer');
    this.hotspotsContainer = this.container.querySelector('#HotspotsContainer');
    this.svg = this.container.querySelector('svg');
  }

  iso(x, y, z, scale, cx, cy) {
      let cartX = (x - y) * 0.866; 
      let cartY = (x + y) * 0.5 - z;
      return {
          x: cx + cartX * scale,
          y: cy + cartY * scale
      };
  }

  drawIsoBox(x, y, z, w, l, h, scale, cx, cy, options = {}) {
    let fill = options.fill || '#f1f5f9';
    let stroke = options.stroke || '#94a3b8';
    let strokeWidth = options.strokeWidth || 1;
    let opacity = (options.opacity !== undefined) ? options.opacity : 1;
    let html = '';

    // Floor Shadow Projection for base elements on the floor
    if (options.shadow !== false && z === 0) {
      let shShift = 2;
      let s1 = this.iso(x + shShift, y + shShift, 0, scale, cx, cy);
      let s2 = this.iso(x + w + shShift, y + shShift, 0, scale, cx, cy);
      let s3 = this.iso(x + w + shShift, y + l + shShift, 0, scale, cx, cy);
      let s4 = this.iso(x + shShift, y + l + shShift, 0, scale, cx, cy);
      html += `<polygon points="${s1.x},${s1.y} ${s2.x},${s2.y} ${s3.x},${s3.y} ${s4.x},${s4.y}" 
                        fill="rgba(15, 23, 42, 0.08)" stroke="none" pointer-events="none" />`;
    }

    let b1 = this.iso(x, y, z, scale, cx, cy);
    let b2 = this.iso(x + w, y, z, scale, cx, cy);
    let b3 = this.iso(x + w, y + l, z, scale, cx, cy);
    let b4 = this.iso(x, y + l, z, scale, cx, cy);

    let t1 = this.iso(x, y, z + h, scale, cx, cy);
    let t2 = this.iso(x + w, y, z + h, scale, cx, cy);
    let t3 = this.iso(x + w, y + l, z + h, scale, cx, cy);
    let t4 = this.iso(x, y + l, z + h, scale, cx, cy);

    // 1. Top Face
    html += `<polygon points="${t1.x},${t1.y} ${t2.x},${t2.y} ${t3.x},${t3.y} ${t4.x},${t4.y}" 
                      fill="${options.fillTop || fill}" stroke="${stroke}" stroke-width="${strokeWidth}" opacity="${opacity}" stroke-linejoin="round" />`;

    // 2. Front-Left Face (t4 -> t3 -> b3 -> b4)
    html += `<polygon points="${t4.x},${t4.y} ${t3.x},${t3.y} ${b3.x},${b3.y} ${b4.x},${b4.y}" 
                      fill="${options.fillLeft || fill}" stroke="${stroke}" stroke-width="${strokeWidth}" opacity="${opacity}" stroke-linejoin="round" />`;

    // 3. Front-Right Face (t2 -> t3 -> b3 -> b2)
    html += `<polygon points="${t2.x},${t2.y} ${t3.x},${t3.y} ${b3.x},${b3.y} ${b2.x},${b2.y}" 
                      fill="${options.fillRight || fill}" stroke="${stroke}" stroke-width="${strokeWidth}" opacity="${opacity}" stroke-linejoin="round" />`;

    return html;
  }

  drawPipeRoute(r, roomLayouts, scale, cx, cy) {
    let r0 = roomLayouts.find(l => l.index === 0);
    if (!r0) return '';
    
    let uZ = 69; // AC unit height
    let side = r.side;
    let startX = r.x + side / 2;
    let startY = r.y;
    
    // Balcony/valve coordinates on Room 1 (r0)
    let outX = r0.x + r0.side + 4;
    let outY = r0.y + 68; // outdoor unit Y-pos approx.
    let outZ = 12; // valve height
    
    let path3D = [];
    path3D.push({ x: startX, y: startY, z: uZ }); // Point 1: Start at unit
    
    if (r.index === 0) {
      // Room 1 (Wohnzimmer)
      // Go to the right wall corner: (r.x + r.side, r.y, uZ)
      path3D.push({ x: r.x + r.side, y: r.y, z: uZ });
      // Go along the balcony wall above the door to the outdoor unit Y-pos:
      path3D.push({ x: r.x + r.side, y: outY, z: uZ });
      // Go down vertically next to the outdoor unit to outZ:
      path3D.push({ x: r.x + r.side, y: outY, z: outZ });
      // Connect to the outdoor unit:
      path3D.push({ x: outX, y: outY, z: outZ });
    }
    else if (r.index === 1) {
      // Room 2 (Schlafzimmer)
      // Go to the right corner (adjacent to Room 1 back-left corner): (r.x + r.side, r.y, uZ)
      path3D.push({ x: r.x + r.side, y: r.y, z: uZ });
      // Go along Room 1's back wall to Room 1's back-right corner: (r0.x + r0.side, r0.y, uZ)
      path3D.push({ x: r0.x + r0.side, y: r0.y, z: uZ });
      // Go along the balcony wall above the door to outY:
      path3D.push({ x: r0.x + r0.side, y: outY, z: uZ - 2 });
      // Go down vertically next to the outdoor unit:
      path3D.push({ x: r0.x + r0.side, y: outY, z: outZ + 2 });
      // Connect to outdoor unit:
      path3D.push({ x: outX, y: outY, z: outZ + 2 });
    }
    else if (r.index === 2) {
      // Room 3 (Büro)
      // Go to the right corner of Room 3 back wall: (r.x + r.side, r.y, uZ)
      path3D.push({ x: r.x + r.side, y: r.y, z: uZ });
      // Go along Room 3's right wall to Room 1's back-right corner: (r.x + r.side, r0.y, uZ)
      path3D.push({ x: r.x + r.side, y: r0.y, z: uZ });
      // Go to Room 1's back-right corner: (r0.x + r0.side, r0.y, uZ)
      path3D.push({ x: r0.x + r0.side, y: r0.y, z: uZ });
      // Go along the balcony wall above the door to outY:
      path3D.push({ x: r0.x + r0.side, y: outY, z: uZ - 4 });
      // Go down vertically next to the outdoor unit:
      path3D.push({ x: r0.x + r0.side, y: outY, z: outZ + 4 });
      // Connect to outdoor unit:
      path3D.push({ x: outX, y: outY, z: outZ + 4 });
    }
    else if (r.index === 3) {
      // Room 4 (Küche)
      // Go to right corner of Room 4 back wall: (r.x + r.side, r.y, uZ)
      path3D.push({ x: r.x + r.side, y: r.y, z: uZ });
      // Go along Room 3's back wall to Room 3's right corner: (r2.x + r2.side, r2.y, uZ)
      let r2 = roomLayouts.find(l => l.index === 2);
      if (r2) {
        path3D.push({ x: r2.x + r2.side, y: r2.y, z: uZ });
        // Go along Room 3's right wall to Room 1's back-right corner: (r2.x + r2.side, r0.y, uZ)
        path3D.push({ x: r2.x + r2.side, y: r0.y, z: uZ });
      }
      // Go to Room 1's back-right corner: (r0.x + r0.side, r0.y, uZ)
      path3D.push({ x: r0.x + r0.side, y: r0.y, z: uZ });
      // Go along the balcony wall above the door to outY:
      path3D.push({ x: r0.x + r0.side, y: outY, z: uZ - 6 });
      // Go down vertically next to the outdoor unit:
      path3D.push({ x: r0.x + r0.side, y: outY, z: outZ + 6 });
      // Connect:
      path3D.push({ x: outX, y: outY, z: outZ + 6 });
    }
    else if (r.index === 4) {
      // Room 5 (Gästezimmer)
      // Go to the left corner of Room 5 back wall: (r.x, r.y, uZ)
      path3D.push({ x: r.x, y: r.y, z: uZ });
      // Go along Room 5's left wall to Room 1's back-right corner: (r.x, r0.y, uZ)
      path3D.push({ x: r.x, y: r0.y, z: uZ });
      // Go to Room 1's back-right corner: (r0.x + r0.side, r0.y, uZ)
      path3D.push({ x: r0.x + r0.side, y: r0.y, z: uZ });
      // Go along the balcony wall above the door to outY:
      path3D.push({ x: r0.x + r0.side, y: outY, z: uZ - 8 });
      // Go down vertically next to the outdoor unit:
      path3D.push({ x: r0.x + r0.side, y: outY, z: outZ + 8 });
      // Connect:
      path3D.push({ x: outX, y: outY, z: outZ + 8 });
    }
    
    // Project points to 2D
    let pts2D = path3D.map(p => this.iso(p.x, p.y, p.z, scale, cx, cy));
    let pathData = pts2D.map((p, idx) => `${idx === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
    
    let html = '';
    // Thicker dark outline
    html += `<path d="${pathData}" fill="none" stroke="#1e293b" stroke-width="${2.2 * scale}" stroke-linecap="round" stroke-linejoin="round" opacity="0.9" />`;
    // Thinner inner white pipe
    html += `<path d="${pathData}" fill="none" stroke="#ffffff" stroke-width="${1.0 * scale}" stroke-linecap="round" stroke-linejoin="round" opacity="0.95" />`;
    return html;
  }

  drawRoomFurniture(r, scale, cx, cy) {
    let html = '';
    let side = r.side;
    let fScale = side / 100;

    if (r.index === 0) {
      let rx = r.x + 35 * fScale;
      let ry = r.y + 20 * fScale;
      let rw = 30 * fScale;
      let rl = 40 * fScale;
      let rug1 = this.iso(rx, ry, 0, scale, cx, cy);
      let rug2 = this.iso(rx + rw, ry, 0, scale, cx, cy);
      let rug3 = this.iso(rx + rw, ry + rl, 0, scale, cx, cy);
      let rug4 = this.iso(rx, ry + rl, 0, scale, cx, cy);
      html += `<polygon points="${rug1.x},${rug1.y} ${rug2.x},${rug2.y} ${rug3.x},${rug3.y} ${rug4.x},${rug4.y}" 
                        fill="#cbd5e1" stroke="#94a3b8" stroke-width="0.5" stroke-dasharray="2,2" />`;

      // Couch Base (flush against left wall: x = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 15 * fScale, 0, 15 * fScale, 50 * fScale, 8 * fScale, scale, cx, cy, {
        fillTop: '#475569', fillLeft: '#334155', fillRight: '#1e293b', stroke: '#0f172a'
      });
      // Couch Backrest (flush against left wall: x = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 15 * fScale, 8 * fScale, 4 * fScale, 50 * fScale, 10 * fScale, scale, cx, cy, {
        fillTop: '#475569', fillLeft: '#334155', fillRight: '#1e293b', stroke: '#0f172a'
      });
      // Couch Armrest 1
      html += this.drawIsoBox(r.x + 4 * fScale, r.y + 15 * fScale, 8 * fScale, 11 * fScale, 4 * fScale, 6 * fScale, scale, cx, cy, {
        fillTop: '#334155', fillLeft: '#1e293b', fillRight: '#0f172a', stroke: '#0f172a'
      });
      // Couch Armrest 2
      html += this.drawIsoBox(r.x + 4 * fScale, r.y + 61 * fScale, 8 * fScale, 11 * fScale, 4 * fScale, 6 * fScale, scale, cx, cy, {
        fillTop: '#334155', fillLeft: '#1e293b', fillRight: '#0f172a', stroke: '#0f172a'
      });

      // Couch Table (Coffee table, touches floor, solid block)
      html += this.drawIsoBox(r.x + 30 * fScale, r.y + 25 * fScale, 0, 18 * fScale, 26 * fScale, 6 * fScale, scale, cx, cy, {
        fillTop: '#d5c2a5', fillLeft: '#cbb294', fillRight: '#bca180', stroke: '#a1825c'
      });

      // TV Console (flush against right wall: x = side - 8)
      html += this.drawIsoBox(r.x + side - 8 * fScale, r.y + 15 * fScale, 0, 8 * fScale, 50 * fScale, 10 * fScale, scale, cx, cy, {
        fillTop: '#e2e8f0', fillLeft: '#cbd5e1', fillRight: '#94a3b8', stroke: '#64748b'
      });
      // TV Screen on Console
      html += this.drawIsoBox(r.x + side - 2 * fScale, r.y + 25 * fScale, 10 * fScale, 2 * fScale, 30 * fScale, 20 * fScale, scale, cx, cy, {
        fillTop: '#1e293b', fillLeft: '#0f172a', fillRight: '#020617', stroke: '#0f172a'
      });
    } 
    else if (r.index === 1) {
      // Bedside table (flush against back wall: y = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 3 * fScale, 0, 10 * fScale, 10 * fScale, 9 * fScale, scale, cx, cy, {
        fillTop: '#d5c2a5', fillLeft: '#cbb294', fillRight: '#bca180', stroke: '#a1825c'
      });
      // Bed Base (flush against headboard, extending along X)
      html += this.drawIsoBox(r.x + 4 * fScale, r.y + 15 * fScale, 0, 45 * fScale, 48 * fScale, 7 * fScale, scale, cx, cy, {
        fillTop: '#f8fafc', fillLeft: '#f1f5f9', fillRight: '#e2e8f0', stroke: '#cbd5e1'
      });
      // Bed Headboard (flush against left wall: x = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 15 * fScale, 0, 4 * fScale, 48 * fScale, 14 * fScale, scale, cx, cy, {
        fillTop: '#cbd5e1', fillLeft: '#94a3b8', fillRight: '#64748b', stroke: '#475569'
      });
      // Pillow 1
      html += this.drawIsoBox(r.x + 6 * fScale, r.y + 19 * fScale, 7 * fScale, 8 * fScale, 16 * fScale, 2 * fScale, scale, cx, cy, {
        fillTop: '#ffffff', fillLeft: '#cbd5e1', fillRight: '#cbd5e1', stroke: '#cbd5e1'
      });
      // Pillow 2
      html += this.drawIsoBox(r.x + 6 * fScale, r.y + 39 * fScale, 7 * fScale, 8 * fScale, 16 * fScale, 2 * fScale, scale, cx, cy, {
        fillTop: '#ffffff', fillLeft: '#cbd5e1', fillRight: '#cbd5e1', stroke: '#cbd5e1'
      });
    } 
    else if (r.index === 2) {
      // Desk (flush against back wall: y = 0)
      html += this.drawIsoBox(r.x + 15 * fScale, r.y + 0, 0, 45 * fScale, 20 * fScale, 12 * fScale, scale, cx, cy, {
        fillTop: '#d5c2a5', fillLeft: '#cbb294', fillRight: '#bca180', stroke: '#a1825c'
      });
      // Office Chair
      html += this.drawIsoBox(r.x + 28 * fScale, r.y + 25 * fScale, 0, 12 * fScale, 12 * fScale, 7 * fScale, scale, cx, cy, {
        fillTop: '#475569', fillLeft: '#334155', fillRight: '#1e293b', stroke: '#1e293b'
      });
      // Monitor on Desk
      html += this.drawIsoBox(r.x + 30 * fScale, r.y + 4 * fScale, 12 * fScale, 15 * fScale, 3 * fScale, 10 * fScale, scale, cx, cy, {
        fillTop: '#1e293b', fillLeft: '#0f172a', fillRight: '#020617', stroke: '#0f172a'
      });
      // Cabinet (flush against left wall: x = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 20 * fScale, 0, 10 * fScale, 30 * fScale, 30 * fScale, scale, cx, cy, {
        fillTop: '#e2e8f0', fillLeft: '#cbd5e1', fillRight: '#94a3b8', stroke: '#64748b'
      });
    } 
    else if (r.index === 3) {
      // Kitchen counter (flush against back wall: y = 0)
      html += this.drawIsoBox(r.x + 10 * fScale, r.y + 0, 0, 20 * fScale, 60 * fScale, 13 * fScale, scale, cx, cy, {
        fillTop: '#ffffff', fillLeft: '#cbd5e1', fillRight: '#94a3b8', stroke: '#94a3b8'
      });
      let sx = r.x + 12 * fScale;
      let sy = r.y + 20 * fScale;
      let sw = 6 * fScale;
      let sl = 15 * fScale;
      let sh = 13.1 * fScale;
      let sink1 = this.iso(sx, sy, sh, scale, cx, cy);
      let sink2 = this.iso(sx + sw, sy, sh, scale, cx, cy);
      let sink3 = this.iso(sx + sw, sy + sl, sh, scale, cx, cy);
      let sink4 = this.iso(sx, sy + sl, sh, scale, cx, cy);
      html += `<polygon points="${sink1.x},${sink1.y} ${sink2.x},${sink2.y} ${sink3.x},${sink3.y} ${sink4.x},${sink4.y}" 
                        fill="#cbd5e1" stroke="#475569" stroke-width="0.5" />`;
      // Fridge next to counter (flush against back wall: y = 0)
      html += this.drawIsoBox(r.x + 30 * fScale, r.y + 0, 0, 18 * fScale, 18 * fScale, 35 * fScale, scale, cx, cy, {
        fillTop: '#cbd5e1', fillLeft: '#94a3b8', fillRight: '#64748b', stroke: '#475569'
      });
    } 
    else if (r.index === 4) {
      // Bed Base (flush against left wall: x = 0, head against back wall: y = 0)
      html += this.drawIsoBox(r.x + 0, r.y + 0, 0, 26 * fScale, 55 * fScale, 7 * fScale, scale, cx, cy, {
        fillTop: '#f1f5f9', fillLeft: '#cbd5e1', fillRight: '#94a3b8', stroke: '#94a3b8'
      });
      // Pillow
      html += this.drawIsoBox(r.x + 3 * fScale, r.y + 4 * fScale, 7 * fScale, 20 * fScale, 8 * fScale, 2 * fScale, scale, cx, cy, {
        fillTop: '#ffffff', fillLeft: '#cbd5e1', fillRight: '#cbd5e1', stroke: '#cbd5e1'
      });
      // Nightstand next to bed (flush against back wall: y = 0)
      html += this.drawIsoBox(r.x + 30 * fScale, r.y + 0, 0, 10 * fScale, 10 * fScale, 9 * fScale, scale, cx, cy, {
        fillTop: '#d5c2a5', fillLeft: '#cbb294', fillRight: '#bca180', stroke: '#a1825c'
      });
    }

    return html;
  }

  render(rooms, outdoorMatched) {
    this.drawingLayer.innerHTML = '';
    this.hotspotsContainer.innerHTML = '';

    // 1. Determine Room Layout (Apartment Grid Style)
    let roomLayouts = [];
    let sides = rooms.map(room => Math.sqrt(room.size || 25) * 30);
    
    rooms.forEach((room, i) => {
      let side = sides[i];
      let x = 0;
      let y = 0;
      
      if (i === 0) {
        x = 0;
        y = 0;
      } else if (i === 1) {
        x = -side;
        y = 0;
      } else if (i === 2) {
        x = 0;
        y = -side;
      } else if (i === 3) {
        x = -side;
        y = -sides[2];
      } else if (i === 4) {
        x = Math.max(sides[0], sides[2]);
        y = -side;
      }
      
      roomLayouts.push({ room, x, y, side, index: i });
    });

    // 2. Calculate Bounding Box
    let minSvgX = Infinity, maxSvgX = -Infinity;
    let minSvgY = Infinity, maxSvgY = -Infinity;
    
    let pointsToCheck = []; 
    
    if (outdoorMatched && roomLayouts.length > 0) {
      let r0 = roomLayouts[0];
      let outX = r0.x + r0.side; 
      let outY = r0.y; 
      pointsToCheck.push({x: outX + 60, y: outY + r0.side, z: -15}); 
      pointsToCheck.push({x: outX, y: outY, z: 75});
    }
    roomLayouts.forEach(r => {
        let wallHeight = 75;
        pointsToCheck.push({x: r.x, y: r.y, z: 0});
        pointsToCheck.push({x: r.x + r.side, y: r.y, z: 0});
        pointsToCheck.push({x: r.x + r.side, y: r.y + r.side, z: 0});
        pointsToCheck.push({x: r.x, y: r.y + r.side, z: 0});
        pointsToCheck.push({x: r.x, y: r.y, z: wallHeight}); 
    });

    pointsToCheck.forEach(p => {
        let pt = this.iso(p.x, p.y, p.z, 1, 0, 0);
        if (pt.x < minSvgX) minSvgX = pt.x;
        if (pt.x > maxSvgX) maxSvgX = pt.x;
        if (pt.y < minSvgY) minSvgY = pt.y;
        if (pt.y > maxSvgY) maxSvgY = pt.y;
    });

    let bbWidth = maxSvgX - minSvgX;
    let bbHeight = maxSvgY - minSvgY;
    
    let scale = Math.min(800 / bbWidth, 600 / bbHeight);
    if (scale > 2) scale = 2; 

    let bbCenterX = minSvgX + (bbWidth / 2);
    let bbCenterY = minSvgY + (bbHeight / 2);
    let cx = 500 - (bbCenterX * scale);
    let cy = 400 - (bbCenterY * scale);

    // 3. Draw Rooms in depth-sorted order (Painter's Algorithm: back to front)
    let drawOrder = [...roomLayouts].sort((a, b) => (a.x + a.y) - (b.x + b.y));
    
    drawOrder.forEach(r => {
      let side = r.side;
      let wallHeight = 75; 
      
      let p1 = this.iso(r.x, r.y, 0, scale, cx, cy);
      let p2 = this.iso(r.x + side, r.y, 0, scale, cx, cy);
      let p3 = this.iso(r.x + side, r.y + side, 0, scale, cx, cy);
      let p4 = this.iso(r.x, r.y + side, 0, scale, cx, cy);

      let html = `<polygon points="${p1.x},${p1.y} ${p2.x},${p2.y} ${p3.x},${p3.y} ${p4.x},${p4.y}" 
                        fill="rgba(255, 255, 255, 0.95)" stroke="#002A54" stroke-width="1.5" 
                        style="transition: all 0.2s ease; filter: url(#shadow);" />`;
      
      for (let k = 1; k <= 4; k++) {
        let px = r.x + (k / 5) * side;
        let l1 = this.iso(px, r.y, 0, scale, cx, cy);
        let l2 = this.iso(px, r.y + side, 0, scale, cx, cy);
        html += `<line x1="${l1.x}" y1="${l1.y}" x2="${l2.x}" y2="${l2.y}" stroke="#cbd5e1" stroke-width="0.5" opacity="0.6" />`;
      }

      let wallThick = 6;
      
      // Check if there is an adjacent room at the end of the back-left wall (Y-end)
      let hasRoomAtLeftEnd = roomLayouts.some(other => 
        other.room.id !== r.room.id && 
        Math.abs(other.x - r.x) < 2 && 
        Math.abs(other.y - (r.y + side)) < 2
      );

      // Check if there is an adjacent room at the end of the back-right wall (X-end)
      let hasRoomAtRightEnd = roomLayouts.some(other => 
        other.room.id !== r.room.id && 
        Math.abs(other.x - (r.x + side)) < 2 && 
        Math.abs(other.y - r.y) < 2
      );

      // Outer Back-Left Wall (X = r.x - wallThick)
      let obl1 = this.iso(r.x - wallThick, r.y - wallThick, 0, scale, cx, cy);
      let obl2 = this.iso(r.x - wallThick, r.y + side, 0, scale, cx, cy);
      let obl3 = this.iso(r.x - wallThick, r.y + side, wallHeight, scale, cx, cy);
      let obl4 = this.iso(r.x - wallThick, r.y - wallThick, wallHeight, scale, cx, cy);
      html += `<polygon points="${obl1.x},${obl1.y} ${obl2.x},${obl2.y} ${obl3.x},${obl3.y} ${obl4.x},${obl4.y}" 
                        fill="rgba(203, 213, 225, 0.55)" />`;

      // Outer Back-Right Wall (Y = r.y - wallThick)
      let obr1 = this.iso(r.x - wallThick, r.y - wallThick, 0, scale, cx, cy);
      let obr2 = this.iso(r.x + side, r.y - wallThick, 0, scale, cx, cy);
      let obr3 = this.iso(r.x + side, r.y - wallThick, wallHeight, scale, cx, cy);
      let obr4 = this.iso(r.x - wallThick, r.y - wallThick, wallHeight, scale, cx, cy);
      html += `<polygon points="${obr1.x},${obr1.y} ${obr2.x},${obr2.y} ${obr3.x},${obr3.y} ${obr4.x},${obr4.y}" 
                        fill="rgba(148, 163, 184, 0.55)" />`;

      // Outer wall outline borders
      html += `<line x1="${obl1.x}" y1="${obl1.y}" x2="${obl2.x}" y2="${obl2.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${obl4.x}" y1="${obl4.y}" x2="${obl3.x}" y2="${obl3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${obl1.x}" y1="${obl1.y}" x2="${obl4.x}" y2="${obl4.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      if (!hasRoomAtLeftEnd) {
        html += `<line x1="${obl2.x}" y1="${obl2.y}" x2="${obl3.x}" y2="${obl3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }

      html += `<line x1="${obr1.x}" y1="${obr1.y}" x2="${obr2.x}" y2="${obr2.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${obr4.x}" y1="${obr4.y}" x2="${obr3.x}" y2="${obr3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      if (!hasRoomAtRightEnd) {
        html += `<line x1="${obr2.x}" y1="${obr2.y}" x2="${obr3.x}" y2="${obr3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }

      // End-caps (only drawn if there are no adjacent rooms at the ends)
      if (!hasRoomAtLeftEnd) {
        let ebl1 = this.iso(r.x - wallThick, r.y + side, 0, scale, cx, cy);
        let ebl2 = this.iso(r.x, r.y + side, 0, scale, cx, cy);
        let ebl3 = this.iso(r.x, r.y + side, wallHeight, scale, cx, cy);
        let ebl4 = this.iso(r.x - wallThick, r.y + side, wallHeight, scale, cx, cy);
        html += `<polygon points="${ebl1.x},${ebl1.y} ${ebl2.x},${ebl2.y} ${ebl3.x},${ebl3.y} ${ebl4.x},${ebl4.y}" 
                          fill="rgba(226, 232, 240, 0.6)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round"/>`;
      }

      if (!hasRoomAtRightEnd) {
        let ebr1 = this.iso(r.x + side, r.y - wallThick, 0, scale, cx, cy);
        let ebr2 = this.iso(r.x + side, r.y, 0, scale, cx, cy);
        let ebr3 = this.iso(r.x + side, r.y, wallHeight, scale, cx, cy);
        let ebr4 = this.iso(r.x + side, r.y - wallThick, wallHeight, scale, cx, cy);
        html += `<polygon points="${ebr1.x},${ebr1.y} ${ebr2.x},${ebr2.y} ${ebr3.x},${ebr3.y} ${ebr4.x},${ebr4.y}" 
                          fill="rgba(226, 232, 240, 0.6)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round"/>`;
      }

      // Wall Top Face (L-shape)
      let L1 = this.iso(r.x + side, r.y - wallThick, wallHeight, scale, cx, cy);
      let L2 = this.iso(r.x - wallThick, r.y - wallThick, wallHeight, scale, cx, cy);
      let L3 = this.iso(r.x - wallThick, r.y + side, wallHeight, scale, cx, cy);
      let L4 = this.iso(r.x, r.y + side, wallHeight, scale, cx, cy);
      let L5 = this.iso(r.x, r.y, wallHeight, scale, cx, cy);
      let L6 = this.iso(r.x + side, r.y, wallHeight, scale, cx, cy);
      html += `<polygon points="${L1.x},${L1.y} ${L2.x},${L2.y} ${L3.x},${L3.y} ${L4.x},${L4.y} ${L5.x},${L5.y} ${L6.x},${L6.y}" 
                        fill="rgba(248, 250, 252, 0.85)" />`;

      // Wall Top Outline Borders
      html += `<line x1="${L2.x}" y1="${L2.y}" x2="${L3.x}" y2="${L3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${L2.x}" y1="${L2.y}" x2="${L1.x}" y2="${L1.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${L5.x}" y1="${L5.y}" x2="${L4.x}" y2="${L4.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${L5.x}" y1="${L5.y}" x2="${L6.x}" y2="${L6.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      if (!hasRoomAtLeftEnd) {
        html += `<line x1="${L3.x}" y1="${L3.y}" x2="${L4.x}" y2="${L4.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }
      if (!hasRoomAtRightEnd) {
        html += `<line x1="${L6.x}" y1="${L6.y}" x2="${L1.x}" y2="${L1.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }

      // Inner Back-Left Wall (X = r.x)
      let ibl1 = this.iso(r.x, r.y, 0, scale, cx, cy);
      let ibl2 = this.iso(r.x, r.y + side, 0, scale, cx, cy);
      let ibl3 = this.iso(r.x, r.y + side, wallHeight, scale, cx, cy);
      let ibl4 = this.iso(r.x, r.y, wallHeight, scale, cx, cy);
      html += `<polygon points="${ibl1.x},${ibl1.y} ${ibl2.x},${ibl2.y} ${ibl3.x},${ibl3.y} ${ibl4.x},${ibl4.y}" 
                        fill="rgba(226, 232, 240, 0.65)" />`;

      // Inner Back-Right Wall (Y = r.y)
      let ibr1 = this.iso(r.x, r.y, 0, scale, cx, cy);
      let ibr2 = this.iso(r.x + side, r.y, 0, scale, cx, cy);
      let ibr3 = this.iso(r.x + side, r.y, wallHeight, scale, cx, cy);
      let ibr4 = this.iso(r.x, r.y, wallHeight, scale, cx, cy);
      html += `<polygon points="${ibr1.x},${ibr1.y} ${ibr2.x},${ibr2.y} ${ibr3.x},${ibr3.y} ${ibr4.x},${ibr4.y}" 
                        fill="rgba(241, 245, 249, 0.65)" />`;

      // Inner wall outline borders
      html += `<line x1="${ibl1.x}" y1="${ibl1.y}" x2="${ibl2.x}" y2="${ibl2.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${ibl4.x}" y1="${ibl4.y}" x2="${ibl3.x}" y2="${ibl3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${ibl1.x}" y1="${ibl1.y}" x2="${ibl4.x}" y2="${ibl4.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      if (!hasRoomAtLeftEnd) {
        html += `<line x1="${ibl2.x}" y1="${ibl2.y}" x2="${ibl3.x}" y2="${ibl3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }

      html += `<line x1="${ibr1.x}" y1="${ibr1.y}" x2="${ibr2.x}" y2="${ibr2.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      html += `<line x1="${ibr4.x}" y1="${ibr4.y}" x2="${ibr3.x}" y2="${ibr3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      if (!hasRoomAtRightEnd) {
        html += `<line x1="${ibr2.x}" y1="${ibr2.y}" x2="${ibr3.x}" y2="${ibr3.y}" stroke="#002A54" stroke-width="1.2" stroke-linecap="round"/>`;
      }

      const names = ['Wohnzimmer', 'Schlafzimmer', 'Büro', 'Küche', 'Gästezimmer'];
      let roomLabel = (r.room && typeof r.room.customName === 'string')
        ? r.room.customName
        : (names[r.index] || `Raum ${r.index + 1}`);
      if (roomLabel === '') {
        roomLabel = `Raum ${r.index + 1}`;
      }
      let centerFloor = this.iso(r.x + side*0.65, r.y + side*0.65, 0, scale, cx, cy);
      html += `<text x="${centerFloor.x}" y="${centerFloor.y}" text-anchor="middle" dominant-baseline="middle" 
                     font-family="-apple-system, BlinkMacSystemFont, sans-serif" font-weight="800" font-size="${13 * scale}" fill="#002A54" opacity="0.3">
                 ${roomLabel.toUpperCase()}
               </text>`;

      html += this.drawRoomFurniture(r, scale, cx, cy);

      this.drawingLayer.insertAdjacentHTML('beforeend', html);

      if (r.room.variantId) {
        // 1. Draw pipe routing first so it sits behind the AC unit cover
        if (outdoorMatched) {
          let pipeHtml = this.drawPipeRoute(r, roomLayouts, scale, cx, cy);
          this.drawingLayer.insertAdjacentHTML('beforeend', pipeHtml);
        }

        let unitWidth = 24;
        let unitHeight = 9;
        let uZ = 69; 
        let uX = r.x + (side/2) - (unitWidth/2);
        let uY = r.y; 
        let uThick = 6;

        // 2. Draw wall shadow of the AC unit (slightly offset Y + 0.1 to avoid overlapping wall, and shifted down/right)
        let sw1 = this.iso(uX + 1.5, uY + 0.1, uZ - 1.5, scale, cx, cy);
        let sw2 = this.iso(uX + unitWidth + 1.5, uY + 0.1, uZ - 1.5, scale, cx, cy);
        let sw3 = this.iso(uX + unitWidth + 1.5, uY + 0.1, uZ - unitHeight - 1.5, scale, cx, cy);
        let sw4 = this.iso(uX + 1.5, uY + 0.1, uZ - unitHeight - 1.5, scale, cx, cy);
        let shadowHtml = `<polygon points="${sw1.x},${sw1.y} ${sw2.x},${sw2.y} ${sw3.x},${sw3.y} ${sw4.x},${sw4.y}" 
                                   fill="rgba(15, 23, 42, 0.12)" stroke="none" pointer-events="none" />`;
        this.drawingLayer.insertAdjacentHTML('beforeend', shadowHtml);

        // 3. Draw AC Unit
        let ur1 = this.iso(uX + unitWidth, uY, uZ, scale, cx, cy);
        let ur2 = this.iso(uX + unitWidth, uY + uThick, uZ, scale, cx, cy);
        let ur3 = this.iso(uX + unitWidth, uY + uThick, uZ - unitHeight, scale, cx, cy);
        let ur4 = this.iso(uX + unitWidth, uY, uZ - unitHeight, scale, cx, cy);
        let unitHtml = `<polygon points="${ur1.x},${ur1.y} ${ur2.x},${ur2.y} ${ur3.x},${ur3.y} ${ur4.x},${ur4.y}" fill="#cbd5e1" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;

        let uf1 = this.iso(uX, uY + uThick, uZ, scale, cx, cy);
        let uf2 = this.iso(uX + unitWidth, uY + uThick, uZ, scale, cx, cy);
        let uf3 = this.iso(uX + unitWidth, uY + uThick, uZ - unitHeight, scale, cx, cy);
        let uf4 = this.iso(uX, uY + uThick, uZ - unitHeight, scale, cx, cy);
        unitHtml += `<polygon points="${uf1.x},${uf1.y} ${uf2.x},${uf2.y} ${uf3.x},${uf3.y} ${uf4.x},${uf4.y}" fill="#f8fafc" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;
        
        let vZ = uZ - unitHeight + 3;
        let vf1 = this.iso(uX + 3, uY + uThick + 0.2, vZ + 2, scale, cx, cy);
        let vf2 = this.iso(uX + unitWidth - 3, uY + uThick + 0.2, vZ + 2, scale, cx, cy);
        let vf3 = this.iso(uX + unitWidth - 3, uY + uThick + 0.2, vZ, scale, cx, cy);
        let vf4 = this.iso(uX + 3, uY + uThick + 0.2, vZ, scale, cx, cy);
        unitHtml += `<polygon points="${vf1.x},${vf1.y} ${vf2.x},${vf2.y} ${vf3.x},${vf3.y} ${vf4.x},${vf4.y}" fill="#334155" />`;

        let ut1 = this.iso(uX, uY, uZ, scale, cx, cy);
        let ut2 = this.iso(uX + unitWidth, uY, uZ, scale, cx, cy);
        let ut3 = this.iso(uX + unitWidth, uY + uThick, uZ, scale, cx, cy);
        let ut4 = this.iso(uX, uY + uThick, uZ, scale, cx, cy);
        unitHtml += `<polygon points="${ut1.x},${ut1.y} ${ut2.x},${ut2.y} ${ut3.x},${ut3.y} ${ut4.x},${ut4.y}" fill="#ffffff" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;

        this.drawingLayer.insertAdjacentHTML('beforeend', unitHtml);

        // 4. Add hotspot centered on the front cover of the indoor unit
        let hotspotCenter = this.iso(r.x + side/2, r.y + uThick, uZ - unitHeight/2, scale, cx, cy);
        this.addHotspot(hotspotCenter.x, hotspotCenter.y, {isOutdoor: false, id: r.room.id});
      }
      
      // Draw Balcony and Outdoor unit for front room
      if (r.index === 0 && outdoorMatched) {
        this.drawOutdoorArea(r, scale, cx, cy);
      }
    }); // End of Draw Rooms
  }

  drawOutdoorArea(r, scale, cx, cy) {
    let html = '';
    let bX = r.x + r.side; // X position (front-right edge of room)
    let bY = r.y;          // Y position (back corner)
    let bW = 50;           // Balcony width (along X)
    let bL = r.side * 0.75;// Balcony length (along Y)
    let floorZ = 0;
    let foundZ = -10;

    // Balcony Floor
    let f1 = this.iso(bX, bY, floorZ, scale, cx, cy);
    let f2 = this.iso(bX + bW, bY, floorZ, scale, cx, cy);
    let f3 = this.iso(bX + bW, bY + bL, floorZ, scale, cx, cy);
    let f4 = this.iso(bX, bY + bL, floorZ, scale, cx, cy);
    html += `<polygon points="${f1.x},${f1.y} ${f2.x},${f2.y} ${f3.x},${f3.y} ${f4.x},${f4.y}" fill="#e2e8f0" stroke="#94a3b8" stroke-width="1" />`;

    // Balcony Foundation Front (facing bottom-left, along X)
    let ff1 = this.iso(bX, bY + bL, foundZ, scale, cx, cy);
    let ff2 = this.iso(bX + bW, bY + bL, foundZ, scale, cx, cy);
    let ff3 = this.iso(bX + bW, bY + bL, floorZ, scale, cx, cy);
    let ff4 = this.iso(bX, bY + bL, floorZ, scale, cx, cy);
    html += `<polygon points="${ff1.x},${ff1.y} ${ff2.x},${ff2.y} ${ff3.x},${ff3.y} ${ff4.x},${ff4.y}" fill="#cbd5e1" stroke="#94a3b8" stroke-width="1" />`;

    // Balcony Foundation Side (facing bottom-right, along Y)
    let fs1 = this.iso(bX + bW, bY, foundZ, scale, cx, cy);
    let fs2 = this.iso(bX + bW, bY + bL, foundZ, scale, cx, cy);
    let fs3 = this.iso(bX + bW, bY + bL, floorZ, scale, cx, cy);
    let fs4 = this.iso(bX + bW, bY, floorZ, scale, cx, cy);
    html += `<polygon points="${fs1.x},${fs1.y} ${fs2.x},${fs2.y} ${fs3.x},${fs3.y} ${fs4.x},${fs4.y}" fill="#94a3b8" stroke="#94a3b8" stroke-width="1" />`;

    // Back Railing (along X)
    let rH = 20;
    let br1 = this.iso(bX, bY, floorZ, scale, cx, cy);
    let br2 = this.iso(bX + bW, bY, floorZ, scale, cx, cy);
    let br3 = this.iso(bX + bW, bY, rH, scale, cx, cy);
    let br4 = this.iso(bX, bY, rH, scale, cx, cy);
    html += `<polygon points="${br1.x},${br1.y} ${br2.x},${br2.y} ${br3.x},${br3.y} ${br4.x},${br4.y}" fill="#f1f5f9" stroke="#cbd5e1" stroke-width="1" opacity="0.85" />`;

    // Right Railing (along Y, cut short)
    let rrL = bL * 0.4;
    let rr1 = this.iso(bX + bW, bY, floorZ, scale, cx, cy);
    let rr2 = this.iso(bX + bW, bY + rrL, floorZ, scale, cx, cy);
    let rr3 = this.iso(bX + bW, bY + rrL, rH, scale, cx, cy);
    let rr4 = this.iso(bX + bW, bY, rH, scale, cx, cy);
    html += `<polygon points="${rr1.x},${rr1.y} ${rr2.x},${rr2.y} ${rr3.x},${rr3.y} ${rr4.x},${rr4.y}" fill="#e2e8f0" stroke="#cbd5e1" stroke-width="1" opacity="0.85" />`;

    let wallThick = 6;

    // Front-Right Wall of the room (cut short to reveal balcony) -> Solid 3D Block
    let wL = bL; 
    let wH = 75; 
    
    // 1. Inner face (X = bX) -> Furthest
    let if1 = this.iso(bX, bY, floorZ, scale, cx, cy);
    let if2 = this.iso(bX, bY + wL, floorZ, scale, cx, cy);
    let if3 = this.iso(bX, bY + wL, wH, scale, cx, cy);
    let if4 = this.iso(bX, bY, wH, scale, cx, cy);
    html += `<polygon points="${if1.x},${if1.y} ${if2.x},${if2.y} ${if3.x},${if3.y} ${if4.x},${if4.y}" fill="rgba(241, 245, 249, 0.65)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round" />`;

    // 2. Cut edge (Y = bY + wL)
    let ce1 = this.iso(bX, bY + wL, floorZ, scale, cx, cy);
    let ce2 = this.iso(bX + wallThick, bY + wL, floorZ, scale, cx, cy);
    let ce3 = this.iso(bX + wallThick, bY + wL, wH, scale, cx, cy);
    let ce4 = this.iso(bX, bY + wL, wH, scale, cx, cy);
    html += `<polygon points="${ce1.x},${ce1.y} ${ce2.x},${ce2.y} ${ce3.x},${ce3.y} ${ce4.x},${ce4.y}" fill="rgba(226, 232, 240, 0.6)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round" />`;

    // 3. Outer face (X = bX + wallThick)
    let of1 = this.iso(bX + wallThick, bY, floorZ, scale, cx, cy);
    let of2 = this.iso(bX + wallThick, bY + wL, floorZ, scale, cx, cy);
    let of3 = this.iso(bX + wallThick, bY + wL, wH, scale, cx, cy);
    let of4 = this.iso(bX + wallThick, bY, wH, scale, cx, cy);
    html += `<polygon points="${of1.x},${of1.y} ${of2.x},${of2.y} ${of3.x},${of3.y} ${of4.x},${of4.y}" fill="rgba(203, 213, 225, 0.55)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round" />`;

    // 4. Top face
    let tf1 = this.iso(bX, bY, wH, scale, cx, cy);
    let tf2 = this.iso(bX + wallThick, bY, wH, scale, cx, cy);
    let tf3 = this.iso(bX + wallThick, bY + wL, wH, scale, cx, cy);
    let tf4 = this.iso(bX, bY + wL, wH, scale, cx, cy);
    html += `<polygon points="${tf1.x},${tf1.y} ${tf2.x},${tf2.y} ${tf3.x},${tf3.y} ${tf4.x},${tf4.y}" fill="rgba(248, 250, 252, 0.85)" stroke="#002A54" stroke-width="1.2" stroke-linejoin="round" />`;

    // Door on this Wall (placed on the outer face)
    let dY = bY + 15;
    let dW = 25; // width of door along Y
    let dH = 60;
    let d1 = this.iso(bX + wallThick, dY, floorZ, scale, cx, cy);
    let d2 = this.iso(bX + wallThick, dY + dW, floorZ, scale, cx, cy);
    let d3 = this.iso(bX + wallThick, dY + dW, dH, scale, cx, cy);
    let d4 = this.iso(bX + wallThick, dY, dH, scale, cx, cy);
    html += `<polygon points="${d1.x},${d1.y} ${d2.x},${d2.y} ${d3.x},${d3.y} ${d4.x},${d4.y}" fill="rgba(148, 163, 184, 0.75)" stroke="#002A54" stroke-width="1" stroke-linejoin="round" />`;
    
    // Door handle (on the left side of the door, at 1.0m height = 30 units)
    let dh = this.iso(bX + wallThick, dY + 4, 30, scale, cx, cy);
    html += `<ellipse cx="${dh.x}" cy="${dh.y}" rx="${1*scale}" ry="${2*scale}" fill="#475569" transform="rotate(-30 ${dh.x} ${dh.y})" />`;

    // Outdoor Unit on balcony floor
    let uX = bX + 4;
    let uY = dY + dW + 28; // Moved further away from the door
    let uZ = floorZ;
    let uW = 14.4; // depth along X (10% smaller)
    let uL = 28.8; // width along Y (10% smaller)
    let uH = 27.0; // height (10% smaller)
    let sockH = 3.6; // base sockel (10% smaller)

    let drawBlock = (bx, by, bz, bw, bl, bh, fillTop, fillFront, fillSide) => {
        let h = '';
        let t1 = this.iso(bx, by, bz+bh, scale, cx, cy);
        let t2 = this.iso(bx+bw, by, bz+bh, scale, cx, cy);
        let t3 = this.iso(bx+bw, by+bl, bz+bh, scale, cx, cy);
        let t4 = this.iso(bx, by+bl, bz+bh, scale, cx, cy);
        h += `<polygon points="${t1.x},${t1.y} ${t2.x},${t2.y} ${t3.x},${t3.y} ${t4.x},${t4.y}" fill="${fillTop}" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;
        // Front face (normal +Y)
        let f1 = this.iso(bx, by+bl, bz, scale, cx, cy);
        let f2 = this.iso(bx+bw, by+bl, bz, scale, cx, cy);
        let f3 = this.iso(bx+bw, by+bl, bz+bh, scale, cx, cy);
        let f4 = this.iso(bx, by+bl, bz+bh, scale, cx, cy);
        h += `<polygon points="${f1.x},${f1.y} ${f2.x},${f2.y} ${f3.x},${f3.y} ${f4.x},${f4.y}" fill="${fillFront}" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;
        // Side face (normal +X)
        let s1 = this.iso(bx+bw, by, bz, scale, cx, cy);
        let s2 = this.iso(bx+bw, by+bl, bz, scale, cx, cy);
        let s3 = this.iso(bx+bw, by+bl, bz+bh, scale, cx, cy);
        let s4 = this.iso(bx+bw, by, bz+bh, scale, cx, cy);
        h += `<polygon points="${s1.x},${s1.y} ${s2.x},${s2.y} ${s3.x},${s3.y} ${s4.x},${s4.y}" fill="${fillSide}" stroke="#94a3b8" stroke-width="1" stroke-linejoin="round" />`;
        return h;
    };

    // Two separate base feet
    html += drawBlock(uX + 1.8, uY + 3.6, uZ, uW - 3.6, 3.6, sockH, '#94a3b8', '#64748b', '#cbd5e1');
    html += drawBlock(uX + 1.8, uY + uL - 7.2, uZ, uW - 3.6, 3.6, sockH, '#94a3b8', '#64748b', '#cbd5e1');

    // Main Unit
    html += drawBlock(uX, uY, uZ + sockH, uW, uL, uH, '#f8fafc', '#e2e8f0', '#f1f5f9');

    // Side grills on the FRONT face (facing bottom-left, normal +Y)
    for(let i = 3.6; i < uW - 3.6; i+=2.7) {
        let sx1 = this.iso(uX+i, uY+uL+0.1, uZ+sockH+5.4, scale, cx, cy);
        let sx2 = this.iso(uX+i, uY+uL+0.1, uZ+sockH+uH-5.4, scale, cx, cy);
        html += `<line x1="${sx1.x}" y1="${sx1.y}" x2="${sx2.x}" y2="${sx2.y}" stroke="#cbd5e1" stroke-width="1" />`;
    }

    // Fan circle on the SIDE face (facing bottom-right, normal +X)
    let fanCenter = this.iso(uX + uW + 0.1, uY + uL/2 + 2, uZ + sockH + uH/2 - 1, scale, cx, cy);
    html += `<ellipse cx="${fanCenter.x}" cy="${fanCenter.y}" rx="${8 * scale}" ry="${11 * scale}" fill="#334155" stroke="#94a3b8" stroke-width="1" />`;
    html += `<ellipse cx="${fanCenter.x}" cy="${fanCenter.y}" rx="${3 * scale}" ry="${4 * scale}" fill="#0f172a" />`;

    // Daikin Logo (small blue square on top right of the fan face)
    let logo1 = this.iso(uX + uW + 0.2, uY + 3, uZ + sockH + uH - 3, scale, cx, cy);
    let logo2 = this.iso(uX + uW + 0.2, uY + 6, uZ + sockH + uH - 3, scale, cx, cy);
    let logo3 = this.iso(uX + uW + 0.2, uY + 6, uZ + sockH + uH - 5, scale, cx, cy);
    let logo4 = this.iso(uX + uW + 0.2, uY + 3, uZ + sockH + uH - 5, scale, cx, cy);
    html += `<polygon points="${logo1.x},${logo1.y} ${logo2.x},${logo2.y} ${logo3.x},${logo3.y} ${logo4.x},${logo4.y}" fill="#00a1e4" />`;

    this.drawingLayer.insertAdjacentHTML('beforeend', html);
    let hotspotCenter = this.iso(uX + uW, uY + uL/2, uZ + sockH + uH, scale, cx, cy);
    this.addHotspot(hotspotCenter.x, hotspotCenter.y, {isOutdoor: true, data: true});
  }

  addHotspot(svgX, svgY, itemData) {
    let pctX = (svgX / 1000) * 100;
    let pctY = (svgY / 800) * 100;

    let idAttr = itemData.isOutdoor ? 'data-outdoor="true"' : `data-room-id="${itemData.id}"`;

    let btn = `
      <button class="hotspot-pulse" style="left: ${pctX}%; top: ${pctY}%;" ${idAttr}>
        <span class="pulse-ring"></span>
        <span class="pulse-core"></span>
      </button>
    `;
    this.hotspotsContainer.insertAdjacentHTML('beforeend', btn);
  }
}

if (!customElements.get('global-configurator')) {
  customElements.define(
    'global-configurator',
    class GlobalConfigurator extends HTMLElement {
      constructor() {
        super();
        this.data = JSON.parse(this.querySelector('#ConfiguratorData').textContent);
        
        // Auto-scroll disabled to keep the main website header visible and accessible on load
        /*
        setTimeout(() => {
          if (this.offsetTop > 0 && !document.body.classList.contains('template-index')) {
            window.scrollTo({ top: this.offsetTop, behavior: 'smooth' });
          }
        }, 300);
        */
        
        this.roomsContainer = this.querySelector('#RoomsContainer');
        this.globalSettingsContainer = this.querySelector('#GlobalSettingsContainer');
        this.addRoomBtn = this.querySelector('#AddRoomBtn');
        this.matchResultEl = this.querySelector('#OutdoorMatchResult');
        this.totalPriceEl = this.querySelector('#ConfiguratorTotalPrice');
        this.addToCartBtn = this.querySelector('#ConfiguratorAddToCartBtn');
        this.requestQuoteBtn = this.querySelector('#ConfiguratorRequestQuoteBtn');
        this.errorEl = this.querySelector('#ConfiguratorError');
        this.accessoriesContainer = this.querySelector('#AccessoriesContainer');
        this.bottomSummaryCard = this.querySelector('#BottomSummaryCard');
        this.bottomTotalPriceEl = this.querySelector('#BottomTotalPrice');
        this.bottomAddToCartBtn = this.querySelector('#BottomAddToCartBtn');
        this.bottomRequestQuoteBtn = this.querySelector('#BottomRequestQuoteBtn');
        this.bottomErrorEl = this.querySelector('#BottomConfiguratorError');
        this.shareBtn = this.querySelector('#BottomShareBtn');
        
        this.modal = this.querySelector('#ProductInfoModal');
        this.modalImg = this.querySelector('#ModalProductImage');
        this.modal = this.querySelector('#ProductInfoModal');
        this.modalImg = this.querySelector('#ModalProductImage');
        this.modalTitle = this.querySelector('#ModalProductTitle');
        this.modalDesc = this.querySelector('#ModalProductDescription');

        // Read custom attributes for product-specific pre-selection
        const preselectBrand = this.getAttribute('data-preselect-brand');
        this.preselectSeries = this.getAttribute('data-preselect-series');
        this.useStaticImage = this.getAttribute('data-use-static-image') === 'true';
        this.staticImageUrl = this.getAttribute('data-static-image-url');
        this.hideGlobalSettings = this.getAttribute('data-hide-global-settings') === 'true';

        if (this.useStaticImage) {
          const canvas = this.querySelector('#VisualizerCanvas');
          if (canvas) {
            canvas.innerHTML = `<img id="StaticConfiguratorImage" src="${this.staticImageUrl || ''}" style="width: 100%; height: auto; max-height: 500px; object-fit: contain; border-radius: 12px; display: block; margin: 0 auto;">`;
          }
          this.visualizer = null;
        } else {
          this.visualizer = new SVGVisualizer(this.querySelector('#VisualizerCanvas'));
        }

        this.DAIKIN_LIMITS = [ { slots: 2, nomKw: 4.0, maxConnectable: 6.0 }, { slots: 2, nomKw: 5.0, maxConnectable: 8.5 }, { slots: 2, nomKw: 6.8, maxConnectable: 10.2 }, { slots: 3, nomKw: 4.0, maxConnectable: 7.0 }, { slots: 3, nomKw: 5.2, maxConnectable: 9.0 }, { slots: 3, nomKw: 6.8, maxConnectable: 11.0 }, { slots: 4, nomKw: 6.8, maxConnectable: 11.0 }, { slots: 4, nomKw: 8.0, maxConnectable: 14.5 }, { slots: 5, nomKw: 9.0, maxConnectable: 15.6 } ];
        this.SAMSUNG_LIMITS = [ { slots: 2, nomKw: 4.0, maxConnectable: 5.4 }, { slots: 2, nomKw: 5.0, maxConnectable: 6.75 }, { slots: 3, nomKw: 5.2, maxConnectable: 7.02 }, { slots: 3, nomKw: 6.8, maxConnectable: 9.18 }, { slots: 4, nomKw: 8.0, maxConnectable: 10.8 }, { slots: 5, nomKw: 10.0, maxConnectable: 13.5 } ];
        this.PANASONIC_LIMITS = [ { slots: 2, nomKw: 3.5, maxConnectable: 6.0 }, { slots: 2, nomKw: 4.1, maxConnectable: 6.0 }, { slots: 2, nomKw: 5.0, maxConnectable: 7.7 }, { slots: 3, nomKw: 5.2, maxConnectable: 9.5 }, { slots: 3, nomKw: 6.8, maxConnectable: 11.2 }, { slots: 4, nomKw: 6.8, maxConnectable: 11.5 }, { slots: 4, nomKw: 8.0, maxConnectable: 14.7 }, { slots: 5, nomKw: 9.0, maxConnectable: 18.3 } ];

        // Enrich Outdoor Units with maxSlots and maxKw
        this.data.outdoor_units.forEach(unit => {
          unit.variants.forEach(variant => {
            variant.maxSlots = this.getMaxSlotsFromSku(variant.sku, variant.title);
            variant.maxKw = this.getMaxKwFromSku(variant.sku, variant.title);
          });
        });

        // Initialize state
        this.state = {
          rooms: [],
          matchedOutdoorVariant: null,
          validOutdoorCandidates: [],
          manualOutdoorVariantId: null,
          outdoorExpanded: false,
          totalPrice: 0,
          expandedRoomId: 1,
          selectedAccessories: [],
          coverColor: 'Weiß',
          coverSizeOverride: null,
          showCoverSizeOptions: false,
          showInstallationOptions: false,
          globalPurpose: 'klimatisieren',
          globalInsulation: 'saniert',
          globalBrand: 'daikin',
          globalColor: '',
          globalMount: 'wand',
          globalSettingsExpanded: false,
          globalStep: 1,
          montageType: 'keine',
          montageMeters: -1,
          montageExpanded: false,
          garantieType: '2_jahre',
          garantieExpanded: false,
          softLautstaerke: 0,
          softTechnik: 0,
          softDesign: 0
        };

        // Query parameters deep-linking overrides (e.g. from homepage Quick-Start)
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('rooms')) {
            let roomsCount = parseInt(urlParams.get('rooms'));
            if (roomsCount >= 1 && roomsCount <= 5) {
                this.state.rooms = [];
                for (let i = 1; i <= roomsCount; i++) {
                    let rState = this.createRoomState(i);
                    let sizeParam = urlParams.get(`size${i - 1}`) || (i === 1 ? urlParams.get('size') : null);
                    if (sizeParam) {
                        let parsedSize = parseInt(sizeParam);
                        if (!isNaN(parsedSize)) {
                            rState.size = parsedSize;
                            rState.kw = this.getKwForSize(parsedSize);
                            rState.step = 2;
                        }
                    }
                    let modelParam = urlParams.get(`model${i - 1}`);
                    if (modelParam) {
                        rState.modelId = parseInt(modelParam) || null;
                        rState.step = 3;
                    }
                    let variantParam = urlParams.get(`variant${i - 1}`);
                    if (variantParam) {
                        let vid = parseInt(variantParam);
                        if (!isNaN(vid)) {
                            rState.variantId = vid;
                            // Find the model that contains this variant
                            let foundModel = this.data.indoor_units.find(u => u.variants.some(v => v.id === vid));
                            if (foundModel) {
                                rState.modelId = foundModel.id;
                                let foundVariant = foundModel.variants.find(v => v.id === vid);
                                if (foundVariant) {
                                    let colorOptionIndex = foundModel.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
                                    if (colorOptionIndex !== -1 && foundVariant.options && foundVariant.options[colorOptionIndex]) {
                                        rState.selectedColor = foundVariant.options[colorOptionIndex];
                                    }
                                }
                                rState.step = 4;
                            } else {
                                rState.step = 3;
                            }
                        }
                    }
                    let colorParam = urlParams.get(`color${i - 1}`);
                    if (colorParam) {
                        rState.selectedColor = colorParam;
                    }
                    this.state.rooms.push(rState);
                }
                
                if (urlParams.has('accessories')) {
                    this.state.selectedAccessories = urlParams.get('accessories').split(',').map(id => parseInt(id)).filter(id => !isNaN(id));
                }
                if (urlParams.has('montageType')) {
                    this.state.montageType = urlParams.get('montageType');
                }
                if (urlParams.has('montageMeters')) {
                    this.state.montageMeters = parseInt(urlParams.get('montageMeters')) || -1;
                }
                if (urlParams.has('garantieType')) {
                    this.state.garantieType = urlParams.get('garantieType');
                }
                if (urlParams.has('plz')) {
                    this.state.plz = urlParams.get('plz');
                }
                this.state.expandedRoomId = 1;
                this.saveState();
            }
        } else if (urlParams.has('size')) {
            this.state.rooms = [];
            let rState = this.createRoomState(1);
            let parsedSize = parseInt(urlParams.get('size'));
            if (!isNaN(parsedSize)) {
                rState.size = parsedSize;
                rState.kw = this.getKwForSize(parsedSize);
                rState.step = 2;
            }
            this.state.rooms.push(rState);
            this.state.expandedRoomId = 1;
            this.saveState();
        }
        if (urlParams.has('brand')) {
            let pBrand = urlParams.get('brand').trim().toLowerCase();
            if (['daikin', 'samsung', 'panasonic', 'vivax'].includes(pBrand)) {
                this.state.globalBrand = pBrand;
                this.saveState();
            }
        }

        const savedStateLoaded = this.loadState();
        if (this.hideGlobalSettings) {
          this.state.globalStep = 4;
        }
        this.applyMountAccessoryToState();

        if (this.state.rooms.length === 0) {
            this.state.rooms.push(this.createRoomState(1));
            this.state.expandedRoomId = 1;
        }

        if (preselectBrand) {
          this.state.globalBrand = preselectBrand.trim().toLowerCase();
        }

        if (this.preselectSeries && !savedStateLoaded) {
          const pattern = this.preselectSeries.toLowerCase();
          const matchingModel = this.data.indoor_units.find(u => 
            (u.title || '').toLowerCase().includes(pattern) || 
            ((u.brand || '') + ' ' + (u.title || '')).toLowerCase().includes(pattern)
          );
          if (matchingModel && this.state.rooms.length > 0) {
            this.state.rooms[0].modelId = matchingModel.id;
          }
        }

        this.validateAllRoomModels();

        this.addRoomBtn.addEventListener('click', () => {
          let hasSensira = this.state.rooms.some(r => {
            if (r.modelId) {
              let model = this.data.indoor_units.find(u => u.id === r.modelId);
              return model && (model.title || "").toLowerCase().includes('sensira');
            }
            return false;
          });

          if (hasSensira) {
            let warningEl = this.querySelector('#AddRoomWarning');
            if (warningEl) {
              warningEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              // Shake animation
              warningEl.style.transition = 'transform 0.1s ease';
              warningEl.style.transform = 'translateX(10px)';
              setTimeout(() => { warningEl.style.transform = 'translateX(-10px)'; }, 100);
              setTimeout(() => { warningEl.style.transform = 'translateX(5px)'; }, 200);
              setTimeout(() => { warningEl.style.transform = 'translateX(-5px)'; }, 300);
              setTimeout(() => { warningEl.style.transform = 'translateX(0)'; }, 400);
            }
            return;
          }

          if (this.state.rooms.length < 5) {
            let newId = Math.max(0, ...this.state.rooms.map(r => r.id)) + 1;
            this.state.rooms.push(this.createRoomState(newId));
            this.state.expandedRoomId = newId; // Auto-expand the newly added room
            this.validateAllRoomModels();
            this.state.rooms.forEach(r => {
                let v = this.findVariantForRoom(r);
                r.variantId = v ? v.id : null;
            });
            this.saveState();
            this.render();
          }
        });

        this.addToCartBtn.addEventListener('click', this.addToCart.bind(this));
        if (this.requestQuoteBtn) {
          this.requestQuoteBtn.addEventListener('click', this.requestQuote.bind(this));
        }
        if (this.bottomAddToCartBtn) {
          this.bottomAddToCartBtn.addEventListener('click', this.addToCart.bind(this));
        }
        if (this.bottomRequestQuoteBtn) {
          this.bottomRequestQuoteBtn.addEventListener('click', this.requestQuote.bind(this));
        }

        // Modal close events
        this.querySelectorAll('[data-close-modal]').forEach(btn => {
            btn.addEventListener('click', () => this.closeModal());
        });

        // Share Configuration link-copying logic
        if (this.shareBtn) {
            this.shareBtn.addEventListener('click', () => {
                const url = new URL(window.location.href);
                url.search = ''; // Clear existing query params
                
                const roomsCount = this.state.rooms.length;
                if (roomsCount > 0) {
                    url.searchParams.set('rooms', roomsCount);
                    this.state.rooms.forEach((room, idx) => {
                        if (room.size) {
                            url.searchParams.set(`size${idx}`, room.size);
                        }
                        if (room.modelId) {
                            url.searchParams.set(`model${idx}`, room.modelId);
                        }
                        if (room.variantId) {
                            url.searchParams.set(`variant${idx}`, room.variantId);
                        }
                        if (room.selectedColor) {
                            url.searchParams.set(`color${idx}`, room.selectedColor);
                        }
                    });
                }
                
                if (this.state.selectedAccessories && this.state.selectedAccessories.length > 0) {
                    url.searchParams.set('accessories', this.state.selectedAccessories.join(','));
                }
                
                if (this.state.montageType && this.state.montageType !== 'keine') {
                    url.searchParams.set('montageType', this.state.montageType);
                }
                if (this.state.montageMeters && this.state.montageMeters !== -1) {
                    url.searchParams.set('montageMeters', this.state.montageMeters);
                }
                if (this.state.garantieType && this.state.garantieType !== '2_jahre') {
                    url.searchParams.set('garantieType', this.state.garantieType);
                }
                if (this.state.plz) {
                    url.searchParams.set('plz', this.state.plz);
                }
                if (this.state.globalBrand) {
                    url.searchParams.set('brand', this.state.globalBrand);
                }
                
                navigator.clipboard.writeText(url.toString()).then(() => {
                    const origHTML = this.shareBtn.innerHTML;
                    this.shareBtn.innerHTML = `<span>✓ Link kopiert!</span>`;
                    this.shareBtn.style.color = '#34c759';
                    this.shareBtn.style.borderColor = '#34c759';
                    setTimeout(() => {
                        this.shareBtn.innerHTML = origHTML;
                        this.shareBtn.style.color = '';
                        this.shareBtn.style.borderColor = '';
                    }, 2000);
                }).catch(err => {
                    console.error('Failed to copy link:', err);
                });
            });
        }

        // Delegate hotspot clicks
        if (this.visualizer && this.visualizer.hotspotsContainer) {
          this.visualizer.hotspotsContainer.addEventListener('click', (e) => {
            let hotspot = e.target.closest('.hotspot-pulse');
            if (!hotspot) return;
            
            if (hotspot.dataset.outdoor) {
                if (this.state.matchedOutdoorVariant) {
                    this.openModal(this.state.matchedOutdoorVariant);
                }
            } else if (hotspot.dataset.roomId) {
                let roomId = parseInt(hotspot.dataset.roomId);
                let room = this.state.rooms.find(r => r.id === roomId);
                if (room && room.modelId) {
                    let model = this.data.indoor_units.find(u => u.id === room.modelId);
                    if (model) this.openModal(model);
                }
            }
          });
        }

        this.scrollspyObserver = new IntersectionObserver((entries) => {
          const scrollspyContainer = this.querySelector('.configurator-scrollspy');
          if (!scrollspyContainer) return;
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              scrollspyContainer.querySelectorAll('.scrollspy-dot').forEach(d => d.classList.remove('is-active'));
              let dot = scrollspyContainer.querySelector(`[data-target="${entry.target.id}"]`);
              if (dot) dot.classList.add('is-active');
            }
          });
        }, { root: null, rootMargin: '-30% 0px -40% 0px', threshold: 0 });
        this.initEventDelegation();

        this.render();
        setTimeout(() => {
            this.classList.add('is-ready');
        }, 50);
      }
      initEventDelegation() {
        this.addEventListener('click', (e) => {
          // Global Settings: Edit Global Settings button (summary panel)
          const editGlobalSettings = e.target.closest('.edit-global-settings-btn');
          if (editGlobalSettings) {
            e.stopPropagation();
            this.state.globalStep = 1;
            this.saveState();
            this.render();
            return;
          }

          // Global Settings: Back button
          const globalBackBtn = e.target.closest('.global-back-btn');
          if (globalBackBtn) {
            e.stopPropagation();
            if (this.state.globalStep > 1) {
              this.state.globalStep--;
              this.saveState();
              this.render();
            }
            return;
          }

          // Global Settings: Select Purpose
          const purposeSelect = e.target.closest('[data-purpose-select]');
          if (purposeSelect) {
            e.stopPropagation();
            this.state.globalPurpose = purposeSelect.dataset.purposeSelect;
            this.state.globalStep = 2;
            this.updateAllRoomsKw();
            this.saveState();
            this.render();
            return;
          }

          // Global Settings: Select Insulation
          const insulationSelect = e.target.closest('[data-insulation-select]');
          if (insulationSelect) {
            e.stopPropagation();
            this.state.globalInsulation = insulationSelect.dataset.insulationSelect;
            this.state.globalStep = 3;
            this.updateAllRoomsKw();
            this.saveState();
            this.render();
            return;
          }

          // Global Settings: Select Brand
          const brandSelect = e.target.closest('[data-brand-select]');
          if (brandSelect) {
            e.stopPropagation();
            this.state.globalBrand = brandSelect.dataset.brandSelect;
            this.state.globalStep = 4;
            this.applyBrandFilterToState();
            this.saveState();
            this.render();

            // Auto-scroll past the redundant base summary panel to the first room card
            setTimeout(() => {
              if (this.state.rooms && this.state.rooms.length > 0) {
                const firstRoomId = this.state.rooms[0].id;
                const firstRoomHeader = this.querySelector(`.room-card-header[data-toggle="${firstRoomId}"]`);
                if (firstRoomHeader) {
                  const firstRoom = firstRoomHeader.closest('.room-card');
                  if (firstRoom) {
                    firstRoom.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  } else {
                    firstRoomHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }
              }
            }, 50);
            return;
          }

          // Toggle Cover Size Options (Accessory)
          const toggleCoverSizes = e.target.closest('[data-toggle-cover-sizes]');
          if (toggleCoverSizes) {
            e.stopPropagation();
            this.state.showCoverSizeOptions = !this.state.showCoverSizeOptions;
            this.render();
            return;
          }

          // Select Cover Size (Accessory)
          const coverSizeSelect = e.target.closest('[data-cover-size-select]');
          if (coverSizeSelect) {
            e.stopPropagation();
            this.state.coverSizeOverride = coverSizeSelect.dataset.coverSizeSelect;
            this.saveState();
            this.render();
            return;
          }

          // 1. Remove room
          const removeBtn = e.target.closest('button[data-remove]');
          if (removeBtn) {
            e.stopPropagation();
            this.removeRoom(parseInt(removeBtn.dataset.remove));
            return;
          }

          // Toggle Room (Accordion)
          const toggleEl = e.target.closest('[data-toggle]');
          if (toggleEl) {
            if (e.target.closest('button[data-remove]') || e.target.closest('.room-name-input')) {
              return;
            }
            e.stopPropagation();
            this.toggleRoom(parseInt(toggleEl.dataset.toggle));
            return;
          }

          // Confirm size (for slider)
          const confirmSizeBtn = e.target.closest('[data-confirm-size]');
          if (confirmSizeBtn) {
            e.stopPropagation();
            let roomId = parseInt(confirmSizeBtn.dataset.confirmSize);
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              if (!room.size) room.size = 25;
              room.kw = this.getKwForSize(room.size);
              room.step = 2;

              // If brand only has one model valid, auto-select it
              let brandFilter = this.state.globalBrand;
              if (!brandFilter && this.state.rooms.length > 0 && this.state.rooms[0].modelId && room.id !== this.state.rooms[0].id) {
                  let firstRoomModel = this.data.indoor_units.find(u => u.id === this.state.rooms[0].modelId);
                  if (firstRoomModel && firstRoomModel.brand) {
                      brandFilter = firstRoomModel.brand;
                  }
              }
              let validModels = this.data.indoor_units.filter(u => {
                let brandMatches = brandFilter ? (u.brand || '').toLowerCase() === brandFilter.toLowerCase() : true;
                return brandMatches && this.isModelValidForRoom(u, { kw: room.kw }, this.state.rooms.length);
              });
              
              let matchingModel = null;
              if (this.preselectSeries) {
                const pattern = this.preselectSeries.toLowerCase();
                matchingModel = validModels.find(u => 
                  (u.title || '').toLowerCase().includes(pattern) || 
                  ((u.brand || '') + ' ' + (u.title || '')).toLowerCase().includes(pattern)
                );
              }

              let modelToSelect = matchingModel || (validModels.length === 1 ? validModels[0] : null);

              if (modelToSelect) {
                room.modelId = modelToSelect.id;
                let colorOptionIndex = -1;
                let availableColors = [];
                let model = modelToSelect;
                if (model.options && Array.isArray(model.options)) {
                  colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
                  if (colorOptionIndex !== -1) {
                    let colorSet = new Set();
                    model.variants.forEach(v => {
                      if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                        colorSet.add(v.options[colorOptionIndex]);
                      }
                    });
                    availableColors = Array.from(colorSet);
                  }
                }
                if (availableColors.length > 1) {
                  room.step = 3;
                } else {
                  room.step = 4;
                  if (availableColors.length === 1) {
                    room.selectedColor = availableColors[0];
                  }
                  this.updateRoomVariant(room);
                }
              }

              this.saveState();
              this.render();
            }
            return;
          }

          // 2. Progressive selection - Select size
          const selectSizeBtn = e.target.closest('[data-select-size]');
          if (selectSizeBtn) {
            e.stopPropagation();
            let roomId = parseInt(selectSizeBtn.dataset.roomId);
            let sizeVal = selectSizeBtn.dataset.selectSize;
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              const sizeKw = {
                "10-25 m²": 2.0,
                "10-25 m2": 2.0,
                "26-35 m²": 2.5,
                "26-35 m2": 2.5,
                "36-50 m²": 3.5,
                "36-50 m2": 3.5,
                "51-75 m²": 5.0,
                "51-75 m2": 5.0
              };
              const sizeNum = {
                "10-25 m²": 25,
                "10-25 m2": 25,
                "26-35 m²": 35,
                "26-35 m2": 35,
                "36-50 m²": 50,
                "36-50 m2": 50,
                "51-75 m²": 75,
                "51-75 m2": 75
              };
              room.size = sizeNum[sizeVal] || 25;
              room.kw = sizeKw[sizeVal] || 2.5;
              room.step = 2;

              // If brand only has one model valid, auto-select it
              let brandFilter = this.state.globalBrand;
              if (!brandFilter && this.state.rooms.length > 0 && this.state.rooms[0].modelId && room.id !== this.state.rooms[0].id) {
                  let firstRoomModel = this.data.indoor_units.find(u => u.id === this.state.rooms[0].modelId);
                  if (firstRoomModel && firstRoomModel.brand) {
                      brandFilter = firstRoomModel.brand;
                  }
              }
              let validModels = this.data.indoor_units.filter(u => {
                let brandMatches = brandFilter ? (u.brand || '').toLowerCase() === brandFilter.toLowerCase() : true;
                return brandMatches && this.isModelValidForRoom(u, { kw: room.kw }, this.state.rooms.length);
              });
              
              let matchingModel = null;
              if (this.preselectSeries) {
                const pattern = this.preselectSeries.toLowerCase();
                matchingModel = validModels.find(u => 
                  (u.title || '').toLowerCase().includes(pattern) || 
                  ((u.brand || '') + ' ' + (u.title || '')).toLowerCase().includes(pattern)
                );
              }

              let modelToSelect = matchingModel || (validModels.length === 1 ? validModels[0] : null);

              if (modelToSelect) {
                room.modelId = modelToSelect.id;
                let colorOptionIndex = -1;
                let availableColors = [];
                let model = modelToSelect;
                if (model.options && Array.isArray(model.options)) {
                  colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
                  if (colorOptionIndex !== -1) {
                    let colorSet = new Set();
                    model.variants.forEach(v => {
                      if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                        colorSet.add(v.options[colorOptionIndex]);
                      }
                    });
                    availableColors = Array.from(colorSet);
                  }
                }
                if (availableColors.length > 1) {
                  room.step = 3;
                } else {
                  room.step = 4;
                  if (availableColors.length === 1) {
                    room.selectedColor = availableColors[0];
                  }
                  this.updateRoomVariant(room);
                }
              }

              this.saveState();
              this.render();
            }
            return;
          }

          // 3. Progressive selection - Select model
          const selectModelBtn = e.target.closest('[data-select-model]');
          if (selectModelBtn) {
            e.stopPropagation();
            let roomId = parseInt(selectModelBtn.dataset.roomId);
            let modelId = parseInt(selectModelBtn.dataset.selectModel);
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              room.modelId = modelId;
              let model = this.data.indoor_units.find(u => u.id === modelId);
              
              // Check colors
              let colorOptionIndex = -1;
              let availableColors = [];
              if (model && model.options && Array.isArray(model.options)) {
                colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
                if (colorOptionIndex !== -1) {
                  let colorSet = new Set();
                  model.variants.forEach(v => {
                    if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                      colorSet.add(v.options[colorOptionIndex]);
                    }
                  });
                  availableColors = Array.from(colorSet);
                }
              }

              if (availableColors.length > 1) {
                room.step = 3;
              } else {
                room.step = 4;
                if (availableColors.length === 1) {
                  room.selectedColor = availableColors[0];
                }
                this.updateRoomVariant(room);
                this.autoProgressAfterRoomComplete(roomId);
              }

              // Update visualizer focus
              let imgs = model && model.images && model.images.length > 0 ? model.images : (model && model.image ? [model.image] : []);
              if (imgs.length > 0) this.setFocusedImage(imgs);

              this.saveState();
              this.render();
            }
            return;
          }

          // 4. Progressive selection - Select color
          const selectColorBtn = e.target.closest('[data-select-color]');
          if (selectColorBtn) {
            e.stopPropagation();
            let roomId = parseInt(selectColorBtn.dataset.roomId);
            let colorVal = selectColorBtn.dataset.selectColor;
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              room.selectedColor = colorVal;
              room.step = 4;
              this.updateRoomVariant(room);
              this.autoProgressAfterRoomComplete(roomId);

              // Update visualizer focus with color variant image
              let matchedVariant = this.data.indoor_units.find(u => u.id === room.modelId)?.variants.find(v => v.id === room.variantId);
              let imgs = [];
              if (matchedVariant && matchedVariant.image) imgs.push(matchedVariant.image);
              let model = this.data.indoor_units.find(p => p.id === room.modelId);
              if (model && model.images && model.images.length > 0) {
                model.images.forEach(img => { if(!imgs.includes(img)) imgs.push(img); });
              } else if (model && model.image && !imgs.includes(model.image)) {
                imgs.push(model.image);
              }
              if (imgs.length > 0) this.setFocusedImage(imgs);

              this.saveState();
              this.render();
            }
            return;
          }

          // 5. Progressive selection - Change step
          const changeStepBtn = e.target.closest('[data-change-step]');
          if (changeStepBtn) {
            e.stopPropagation();
            let roomId = parseInt(changeStepBtn.dataset.roomId);
            let targetStep = parseInt(changeStepBtn.dataset.changeStep);
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              room.step = targetStep;
              if (targetStep === 1) {
                room.size = null;
                room.modelId = null;
                room.variantId = null;
                room.selectedColor = null;
                room.kw = 0;
              } else if (targetStep === 2) {
                room.modelId = null;
                room.variantId = null;
                room.selectedColor = null;
              } else if (targetStep === 3) {
                room.variantId = null;
                room.selectedColor = null;
              }
              this.saveState();
              this.render();
            }
            return;
          }

          // 6. Edit Outdoor
          if (e.target.closest('#BtnEditOutdoor')) {
            this.state.outdoorExpanded = true;
            this.saveState();
            this.render();
            return;
          }

          // 7. Close Outdoor
          if (e.target.closest('#BtnCloseOutdoor')) {
            this.state.outdoorExpanded = false;
            this.saveState();
            this.render();
            return;
          }

          // 8. Select Outdoor Variant
          const outdoorCard = e.target.closest('.outdoor-card[data-outdoor-variant-id]');
          if (outdoorCard) {
            let vid = parseInt(outdoorCard.dataset.outdoorVariantId);
            if (this.state.manualOutdoorVariantId !== vid) {
                this.state.manualOutdoorVariantId = vid;
                this.calculateOutdoorMatch();
                this.updateTotals();
            }
            this.state.outdoorExpanded = false;
            this.saveState();
            this.render();
            return;
          }

          // Cover color select click
          const coverColorBtn = e.target.closest('[data-cover-color]');
          if (coverColorBtn) {
            e.stopPropagation();
            let color = coverColorBtn.dataset.coverColor;
            this.state.coverColor = color;
            this.saveState();
            this.render();
            return;
          }

          // Accessory Quantity Minus
          const qtyMinusBtn = e.target.closest('[data-qty-minus]');
          if (qtyMinusBtn) {
            e.stopPropagation();
            let accId = parseInt(qtyMinusBtn.dataset.qtyMinus);
            let qty = this.state.selectedAccessories.filter(id => id === accId).length;
            
            let accs = this.getAccessories() || [];
            let acc = accs.find(a => a.id === accId);
            let step = acc ? this.getAccessoryStep(acc) : 1;

            if (qty > step) {
              this.setAccessoryQty(accId, qty - step);
            } else {
              // Deselect
              this.state.selectedAccessories = this.state.selectedAccessories.filter(id => id !== accId);
              this.saveState();
              this.render();
            }
            return;
          }

          // Accessory Quantity Plus
          const qtyPlusBtn = e.target.closest('[data-qty-plus]');
          if (qtyPlusBtn) {
            e.stopPropagation();
            let accId = parseInt(qtyPlusBtn.dataset.qtyPlus);
            let qty = this.state.selectedAccessories.filter(id => id === accId).length;
            
            let accs = this.getAccessories() || [];
            let acc = accs.find(a => a.id === accId);
            let isPump = acc && (acc.title.toLowerCase().includes('pumpe') || acc.title.toLowerCase().includes('pump'));
            let maxQty = isPump ? this.state.rooms.length : 100;
            let step = acc ? this.getAccessoryStep(acc) : 1;
            
            if (qty + step <= maxQty) {
              this.setAccessoryQty(accId, qty + step);
            }
            return;
          }

          // Toggle Installationsmaterial sub-options panel
          const toggleInstallBtn = e.target.closest('[data-toggle-install-material]');
          if (toggleInstallBtn) {
            e.stopPropagation();
            this.state.showInstallationOptions = !this.state.showInstallationOptions;
            this.render();
            return;
          }

          // Toggle sub-accessory selection in installationsmaterial panel
          const subAccCard = e.target.closest('[data-install-sub-acc-id]');
          if (subAccCard) {
            if (e.target.closest('.quantity-selector-wrapper')) {
              return;
            }
            e.stopPropagation();
            let accId = parseInt(subAccCard.dataset.installSubAccId);
            this.toggleAccessory(accId);
            return;
          }

          // Toggle main Installationsmaterial accessory card
          const mainInstallCard = e.target.closest('.accessory-card[data-install-material-group]');
          if (mainInstallCard) {
            if (e.target.closest('.btn-change-install-material') || e.target.closest('.quantity-selector-wrapper') || e.target.closest('.install-options-selector-grid')) {
              return;
            }
            e.stopPropagation();
            
            let installationItems = (this.getAccessories() || []).filter(item => this.isInstallationMaterial(item));
            let isAnySelected = installationItems.some(item => this.state.selectedAccessories.includes(item.id));
            if (isAnySelected) {
              // Deselect all
              let installIds = installationItems.map(item => item.id);
              this.state.selectedAccessories = this.state.selectedAccessories.filter(id => !installIds.includes(id));
              this.state.showInstallationOptions = false;
            } else {
              // Toggle expand/collapse if none selected
              this.state.showInstallationOptions = !this.state.showInstallationOptions;
            }
            this.saveState();
            this.render();
            return;
          }

          // 9. Select Accessory
          const accCard = e.target.closest('.accessory-card[data-acc-id]');
          if (accCard) {
            if (e.target.closest('.quantity-selector-wrapper') || e.target.closest('.cover-color-swatches') || e.target.closest('.cover-size-selector-grid')) {
              return;
            }
            let accId = parseInt(accCard.dataset.accId);
            this.toggleAccessory(accId);
            return;
          }

          // 10. Edit Montage
          if (e.target.closest('#BtnEditMontage')) {
            this.state.montageExpanded = true;
            this.saveState();
            this.render();
            return;
          }

          // 11. Close Montage
          if (e.target.closest('#BtnCloseMontage')) {
            this.state.montageExpanded = false;
            this.saveState();
            this.render();
            return;
          }

          // 12. Select Montage Type
          const montageCard = e.target.closest('.montage-card[data-montage-type]');
          if (montageCard) {
            let type = montageCard.dataset.montageType;
            if (this.state.montageType !== type) {
                this.state.montageType = type;
                this.applyMountAccessoryToState();
                if (type === 'komplett') {
                    if (this.state.montageMeters === -1) {
                        this.state.montageMeters = this.state.rooms.length * 5;
                    }
                    const minLfm = this.state.rooms.length * 3;
                    if (this.state.montageMeters < minLfm) {
                        this.state.montageMeters = minLfm;
                    }
                    const maxLfm = this.getMaxLfm(this.state.rooms.length);
                    if (this.state.montageMeters > maxLfm) {
                        this.state.montageMeters = maxLfm;
                    }
                }
                this.saveState();
                this.render();
            }
            return;
          }

          // 13. Edit Garantie
          if (e.target.closest('#BtnEditGarantie') || e.target.closest('#BtnEditGarantieBox')) {
            this.state.garantieExpanded = true;
            this.saveState();
            this.render();
            return;
          }

          // 14. Close Garantie
          if (e.target.closest('#BtnCloseGarantie')) {
            this.state.garantieExpanded = false;
            this.saveState();
            this.render();
            return;
          }

          // 15. Select Garantie Type
          const garantieCard = e.target.closest('.montage-card[data-garantie-type]');
          if (garantieCard) {
            let type = garantieCard.dataset.garantieType;
            if (this.state.garantieType !== type) {
                this.state.garantieType = type;
                this.saveState();
                this.render();
            }
            return;
          }
        });

        // Close dropdowns when clicking outside (moved from render)
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.custom-dropdown')) {
             this.roomsContainer.querySelectorAll('.custom-dropdown.is-open').forEach(d => d.classList.remove('is-open'));
          }
        });

        // input event delegation
        this.addEventListener('input', (e) => {
          // Room Name input
          const nameInput = e.target.closest('.room-name-input');
          if (nameInput) {
            let roomId = parseInt(nameInput.dataset.roomName);
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              room.customName = nameInput.value;
              this.saveState();
              
              let card = nameInput.closest('.room-card');
              if (card) {
                let titleEl = card.querySelector('.room-title');
                if (titleEl) {
                  let index = this.state.rooms.indexOf(room);
                  let roomName = this.getRoomName(room, index);
                  titleEl.textContent = roomName ? `Raum ${index + 1} (${roomName})` : `Raum ${index + 1}`;
                }
              }
              
              if (this.visualizer) {
                this.visualizer.render(this.state.rooms, this.state.matchedOutdoorVariant);
              }
            }
            return;
          }

          // Room Size slider
          const slider = e.target.closest('input[data-room-size]');
          if (slider) {
            let val = parseInt(slider.value);
            let container = slider.closest('.step-slider-container') || slider.parentElement;
            let display = container.querySelector('.slider-value-display');
            if (display) display.textContent = val + ' m²';
            this.updateRoomSizeRealtime(parseInt(slider.dataset.roomSize), val);
            return;
          }

          // Montage Meters slider
          const metersSlider = e.target.closest('#MontageMetersSlider');
          if (metersSlider) {
            let val = parseInt(metersSlider.value);
            const container = this.querySelector('#MontageContainer');
            if (container) {
              const valEl = container.querySelector('.meters-value');
              if (valEl) valEl.textContent = val + ' m';
            }
            return;
          }
        });

        // change event delegation
        this.addEventListener('change', (e) => {
          // Room Name change
          const nameInput = e.target.closest('.room-name-input');
          if (nameInput) {
            let roomId = parseInt(nameInput.dataset.roomName);
            let room = this.state.rooms.find(r => r.id === roomId);
            if (room) {
              room.customName = nameInput.value.trim();
              this.saveState();
              this.render();
            }
            return;
          }

          // Montage Meters change
          const metersSlider = e.target.closest('#MontageMetersSlider');
          if (metersSlider) {
            let val = parseInt(metersSlider.value);
            const minLfm = this.state.rooms.length * 3;
            if (val < minLfm) val = minLfm;
            const maxLfm = this.getMaxLfm(this.state.rooms.length);
            if (val > maxLfm) val = maxLfm;
            this.state.montageMeters = val;
            this.saveState();
            this.render();
            return;
          }
        });

        // keydown event delegation for room-name-input (blur on Enter) and collapsible accessibility
        this.addEventListener('keydown', (e) => {
          const nameInput = e.target.closest('.room-name-input');
          if (nameInput && e.key === 'Enter') {
            nameInput.blur();
            return;
          }

          // Keyboard support for data-toggle and accessory card select
          if (e.key === ' ' || e.key === 'Enter') {
            if (e.target.closest('.btn-remove-room') || e.target.closest('.room-name-input')) {
              return;
            }
            const toggleEl = e.target.closest('[data-toggle]');
            if (toggleEl) {
              e.preventDefault();
              this.toggleRoom(parseInt(toggleEl.dataset.toggle));
              return;
            }

            const accCard = e.target.closest('.accessory-card[data-acc-id]');
            if (accCard) {
              if (e.target.closest('.quantity-selector-wrapper') || e.target.closest('.cover-color-swatches') || e.target.closest('.cover-size-selector-grid')) {
                return;
              }
              e.preventDefault();
              accCard.click();
              return;
            }
          }
        });
      }


      createRoomState(id) {
        let roomIndex = this.state && this.state.rooms ? this.state.rooms.length : 0;
        const defaultNames = ['Wohnzimmer', 'Schlafzimmer', 'Büro', 'Küche', 'Gästezimmer'];
        let defaultSize = 25;
        let defaultKw = this.getKwForSize ? this.getKwForSize(defaultSize) : 2.0;
        let room = {
          id: id,
          size: defaultSize,
          modelId: null,
          variantId: null,
          kw: defaultKw,
          selectedColor: null,
          customName: defaultNames[roomIndex] || `Raum ${roomIndex + 1}`,
          step: 1
        };
        if (this.preselectSeries) {
          const pattern = this.preselectSeries.toLowerCase();
          const matchingModel = this.data.indoor_units.find(u => 
            (u.title || '').toLowerCase().includes(pattern) || 
            ((u.brand || '') + ' ' + (u.title || '')).toLowerCase().includes(pattern)
          );
          if (matchingModel) {
            room.modelId = matchingModel.id;
          }
        }
        return room;
      }

      isMatchingKw(v, targetKw) {
        if (!v) return false;
        
        // 1. Get parsed capacity from SKU/title
        const vKw = this.getMaxKwFromSku(v.sku, v.title);
        if (Math.abs(vKw - targetKw) < 0.2) {
          return true;
        }
        
        // 2. Fallback to raw v.cool if set
        if (v.cool !== null && v.cool !== undefined && v.cool !== "") {
          const vCoolNum = parseFloat(v.cool.toString().replace(',', '.'));
          if (!isNaN(vCoolNum)) {
            return Math.abs(vCoolNum - targetKw) < 0.2;
          }
        }

        return false;
      }

      isModelValidForRoom(model, room, totalRooms) {
        if (!model) return false;
        let title = (model.title || "").toLowerCase();
        
        // Rule 1: Sensira only for Single-Split
        if (totalRooms > 1 && title.includes('sensira')) {
          return false;
        }
        
        // Rule 2: Comfora is max 3.5kW in Multi-Split
        if (totalRooms > 1 && title.includes('comfora') && room.kw > 3.5) {
          return false;
        }
        
        return true;
      }

      validateAllRoomModels() {
        let totalRooms = this.state.rooms.length;
        this.state.rooms.forEach(room => {
            if (room.size === null || room.size === undefined || room.size === 0) {
                room.size = 25;
            }
            if (room.kw === null || room.kw === undefined || room.kw === 0) {
                room.kw = this.getKwForSize(room.size);
            }

            let currentModel = this.data.indoor_units.find(u => u.id === room.modelId);
            let brandFilter = this.state.globalBrand;
            if (!brandFilter && this.state.rooms.length > 0 && this.state.rooms[0].modelId && room.id !== this.state.rooms[0].id) {
                let firstRoomModel = this.data.indoor_units.find(u => u.id === this.state.rooms[0].modelId);
                if (firstRoomModel && firstRoomModel.brand) {
                    brandFilter = firstRoomModel.brand;
                }
            }
            
            // Check if current model is invalid due to constraints OR due to brand filter mismatch
            let isBrandMismatch = brandFilter && currentModel && currentModel.brand.toUpperCase() !== brandFilter.toUpperCase();
            
            if (!currentModel || isBrandMismatch || !this.isModelValidForRoom(currentModel, room, totalRooms)) {
                let targetKw = room.kw;
                let hasVariantForKw = (u) => {
                  return u.variants.some(v => this.isMatchingKw(v, targetKw));
                };
                let validModels = this.data.indoor_units.filter(u => {
                  let brandMatches = brandFilter ? (u.brand || '').toLowerCase() === brandFilter.toLowerCase() : true;
                  return brandMatches && this.isModelValidForRoom(u, room, totalRooms) && hasVariantForKw(u);
                });

                if (validModels.length > 0) {
                  // Sort by price of the matching variant to get the cheapest one
                  validModels.sort((a, b) => {
                    let varA = a.variants.find(v => this.isMatchingKw(v, targetKw));
                    let varB = b.variants.find(v => this.isMatchingKw(v, targetKw));
                    let priceA = varA ? parseFloat(varA.price) : Infinity;
                    let priceB = varB ? parseFloat(varB.price) : Infinity;
                    return priceA - priceB;
                  });

                  room.modelId = validModels[0].id;
                  
                  // Reset variant and color for new model
                  let colorOptionIndex = -1;
                  let availableColors = [];
                  let model = validModels[0];
                  if (model.options && Array.isArray(model.options)) {
                    colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
                    if (colorOptionIndex !== -1) {
                      let colorSet = new Set();
                      model.variants.forEach(v => {
                        if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                          colorSet.add(v.options[colorOptionIndex]);
                        }
                      });
                      availableColors = Array.from(colorSet);
                    }
                  }
                  
                  if (availableColors.length > 0) {
                    if (!room.selectedColor || !availableColors.includes(room.selectedColor)) {
                      room.selectedColor = availableColors[0];
                    }
                  } else {
                    room.selectedColor = null;
                  }
                  
                  this.updateRoomVariant(room);
                  
                  if (room.step > 1) {
                    if (availableColors.length > 1) {
                      room.step = 3;
                    } else {
                      room.step = 4;
                    }
                  }
                } else {
                  room.modelId = null;
                  room.variantId = null;
                  room.selectedColor = null;
                }
            } else {
                if (!room.variantId) {
                  this.updateRoomVariant(room);
                }
            }
        });
      }

      getMaxSlotsFromSku(sku, title) {
        if (!sku && !title) return 1;
        const s = sku ? sku.toUpperCase().trim() : '';
        const t = title ? title.trim().toUpperCase() : '';

        if (s) {
          if (s.includes('5MX') || s.includes('5AMX') || s.includes('5Z') || s.includes('J5KG') || s.includes('5KG/EU')) return 5;
          if (s.includes('4MX') || s.includes('4AMX') || s.includes('4Z') || s.includes('J4KG') || s.includes('4KG/EU')) return 4;
          if (s.includes('3MX') || s.includes('3AMX') || s.includes('3Z') || s.includes('J3KG') || s.includes('3KG/EU')) return 3;
          if (s.includes('2MX') || s.includes('2AMX') || s.includes('2Z') || s.includes('J2KG') || s.includes('2KG/EU')) return 2;
        }

        if (t) {
          const titleMatch = t.match(/^(\d+)\s*\//);
          if (titleMatch) {
            const slots = parseInt(titleMatch[1], 10);
            if (slots >= 1 && slots <= 5) return slots;
          }
          const portMatch = t.match(/(\d+)\s*-\s*PORT/);
          if (portMatch) {
            const slots = parseInt(portMatch[1], 10);
            if (slots >= 1 && slots <= 5) return slots;
          }
          const raumMatch = t.match(/(\d+)\s*RAUM/);
          if (raumMatch) {
            const slots = parseInt(raumMatch[1], 10);
            if (slots >= 1 && slots <= 5) return slots;
          }
        }

        return 1;
      }

      getMaxKwFromSku(sku, title) {
        const s = sku ? sku.toUpperCase().trim() : '';
        const t = title ? title.trim().toUpperCase() : '';

        // 1. Try to parse from title if it has a decimal number like "3,5 kW" or "3.5 kW"
        const titleMatch = t.match(/(\d+[\.,]\d)/);
        if (titleMatch) {
            let kw = parseFloat(titleMatch[1].replace(',', '.'));
            if (kw >= 2.0 && kw <= 15.0) return kw;
        }
        
        // 2. Try to parse from SKU first (very robust for indoor/outdoor units with SKUs)
        if (s) {
            // Vivax
            if (s.includes('ACP')) {
                if (s.includes('18')) return 5.0;
                if (s.includes('12')) return 3.5;
                if (s.includes('09')) return 2.5;
            }
            // Samsung
            if (s.startsWith('AR') || s.startsWith('A') || s.startsWith('AJ')) {
                if (s.includes('100')) return 10.0;
                if (s.includes('080') || s.includes('80')) return 8.0;
                if (s.includes('068') || s.includes('68') || s.includes('24')) return 6.8;
                if (s.includes('052') || s.includes('52')) return 5.2;
                if (s.includes('050') || s.includes('50') || s.includes('18')) return 5.0;
                if (s.includes('040') || s.includes('40')) return 4.0;
                if (s.includes('035') || s.includes('35') || s.includes('12')) return 3.5;
                if (s.includes('025') || s.includes('25') || s.includes('09')) return 2.5;
                if (s.includes('020') || s.includes('20') || s.includes('07')) return 2.0;
            }
            // Panasonic & Daikin & general SKU matches
            if (s.includes('100')) return 10.0;
            if (s.includes('90')) return 9.0;
            if (s.includes('80')) return 8.0;
            if (s.includes('71')) return 7.1;
            if (s.includes('68')) return 6.8;
            if (s.includes('60')) return 6.0;
            if (s.includes('56')) return 5.6;
            if (s.includes('52')) return 5.2;
            if (s.includes('50')) return 5.0;
            if (s.includes('42')) return 4.2;
            if (s.includes('41')) return 4.1;
            if (s.includes('40')) return 4.0;
            if (s.includes('35')) return 3.5;
            if (s.includes('25')) return 2.5;
            if (s.includes('20')) return 2.0;
        }

        // 3. Fallback to range parsing from title (used when SKU is missing, e.g. Daikin Sensira)
        const tClean = t.replace(/\s+/g, '');
        if (tClean.includes('10-25') || tClean.includes('25M')) return 2.0;
        if (tClean.includes('26-35') || tClean.includes('35M')) return 2.5;
        if (tClean.includes('36-50') || tClean.includes('50M')) return 3.5;
        if (tClean.includes('51-75') || tClean.includes('75M')) return 5.0;
        
        // Brand-specific fallback ranges
        if (tClean.includes('10-35')) return 3.5;
        if (tClean.includes('36-51')) return 5.0;

        return 2.5;
      }

      getKwForSize(size) {
        const purposePower = {
          "klimatisieren": 65,
          "klimatisieren_heizen": 80,
          "vollheizung": 100
        };
        const insulationMultiplier = {
          "neubau": 0.8,
          "saniert": 1.0,
          "altbau": 1.2
        };

        let basePower = purposePower[this.state.globalPurpose || "klimatisieren"] || 65;
        let mult = insulationMultiplier[this.state.globalInsulation || "saniert"] || 1.0;
        let finalPowerPerM2 = basePower * mult;
        
        let calculatedLoadKw = (size * finalPowerPerM2) / 1000;

        if (calculatedLoadKw <= 2.1) return 2.0;
        if (calculatedLoadKw <= 2.6) return 2.5;
        if (calculatedLoadKw <= 3.6) return 3.5;
        return 5.0;
      }

      isInstallationMaterial(acc) {
        const handle = (acc.handle || '').toLowerCase();
        const title = (acc.title || '').toLowerCase();
        return handle.includes('installationskanal') ||
               handle.includes('endstuck') ||
               handle.includes('endstück') ||
               handle.includes('kondensatschlauch') ||
               handle.includes('steuerleitung') ||
               handle.includes('kupferrohr') ||
               title.includes('installationskanal') ||
               title.includes('endstück') ||
               title.includes('kondensatschlauch') ||
               title.includes('steuerleitung') ||
               title.includes('kältemittelleitung') ||
               title.includes('kaltemittelleitung') ||
               title.includes('kupferrohr');
      }

      getAccessoryUnit(acc) {
        const title = (acc.title || '').toLowerCase();
        if (title.includes('kanal') && !title.includes('endstück') && !title.includes('endstuck')) {
          return 'm';
        }
        if (title.includes('schlauch') || title.includes('leitung') || title.includes('kabel') || title.includes('rohr') || title.includes('kupferrohr')) {
          return 'm';
        }
        return 'Stk.';
      }

      getAccessoryStep(acc) {
        const title = (acc.title || '').toLowerCase();
        const handle = (acc.handle || '').toLowerCase();
        if (title.includes('endstück') || title.includes('endstuck') || handle.includes('endstuck') || handle.includes('endstück')) {
          return 2;
        }
        if (title.includes('installationskanal') || handle.includes('installationskanal')) {
          return 2;
        }
        return 1;
      }

      getAccessoryMinQty(acc) {
        const title = (acc.title || '').toLowerCase().replace(/\s+/g, '');
        const handle = (acc.handle || '').toLowerCase();
        if (title.includes('kupferrohr') || title.includes('rohr')) {
          if (title.includes('6mm')) {
            return this.state.rooms.length * 3;
          }
          if (title.includes('10mm')) {
            let count = this.state.rooms.filter(r => r.kw < 5.0).length;
            return count * 3;
          }
          if (title.includes('12mm') || title.includes('13mm')) {
            let count = this.state.rooms.filter(r => r.kw >= 5.0).length;
            return count * 3;
          }
        }
        if (title.includes('endstück') || title.includes('endstuck') || handle.includes('endstuck') || handle.includes('endstück')) {
          return 2;
        }
        if (title.includes('installationskanal') || handle.includes('installationskanal')) {
          return 2;
        }
        return 1;
      }

      getAccessoryDefaultQty(acc) {
        const title = (acc.title || '').toLowerCase().replace(/\s+/g, '');
        const handle = (acc.handle || '').toLowerCase();
        if (title.includes('kupferrohr') || title.includes('rohr')) {
          if (title.includes('6mm')) {
            return this.state.rooms.length * 5;
          }
          if (title.includes('10mm')) {
            let count = this.state.rooms.filter(r => r.kw < 5.0).length;
            return count * 5;
          }
          if (title.includes('12mm') || title.includes('13mm')) {
            let count = this.state.rooms.filter(r => r.kw >= 5.0).length;
            return count * 5;
          }
        }
        if (title.includes('endstück') || title.includes('endstuck') || handle.includes('endstuck') || handle.includes('endstück')) {
          return 2;
        }
        if (title.includes('installationskanal') || handle.includes('installationskanal')) {
          return 2;
        }
        return 1;
      }

      getAccessories() {
        if (this.data.accessories && this.data.accessories.length > 0) {
            return this.data.accessories;
        }
        // Fallback mock accessories for development & demo stability
        return [
          {
            id: 1,
            title: "Bodenkonsole & Gummidämpfer",
            image: "https://cdn.shopify.com/s/files/1/0879/8244/0761/files/bracket-floor.png?v=1716380000",
            variants: [{ id: 101, title: "Standard", price: 6000 }]
          },
          {
            id: 2,
            title: "Wandkonsole inkl. Befestigung",
            image: "https://cdn.shopify.com/s/files/1/0879/8244/0761/files/bracket-wall.png?v=1716380000",
            variants: [{ id: 102, title: "Standard", price: 8000 }]
          },
          {
            id: 3,
            title: "Kondensatpumpe (leise)",
            image: "https://cdn.shopify.com/s/files/1/0879/8244/0761/files/pump.png?v=1716380000",
            variants: [{ id: 103, title: "Standard", price: 12000 }]
          }
        ];
      }

      getMatchingCoverSize(outdoorUnitDim, roomsCount) {
        if (!outdoorUnitDim) {
            if (roomsCount === 1) return 'Small';
            if (roomsCount <= 3) return 'Medium';
            if (roomsCount === 4) return 'Large';
            return 'X-Large';
        }
        const parts = outdoorUnitDim.match(/\d+/g);
        if (!parts || parts.length < 3) {
            if (roomsCount === 1) return 'Small';
            if (roomsCount <= 3) return 'Medium';
            if (roomsCount === 4) return 'Large';
            return 'X-Large';
        }
        const h = parseInt(parts[0], 10);
        const w = parseInt(parts[1], 10);
        const d = parseInt(parts[2], 10);

        const reqH = h;
        const reqW = w;
        const reqD = d + 70; // 7 cm recess buffer

        if (reqH <= 680 && reqW <= 900 && reqD <= 600) {
            return 'Small';
        }
        if (reqH <= 835 && reqW <= 1050 && reqD <= 660) {
            return 'Medium';
        }
        if (reqH <= 950 && reqW <= 1100 && reqD <= 700) {
            return 'Large';
        }
        return 'X-Large';
      }

      getCoverVariant(acc, matchingSize, preferredColor) {
        if (!acc || !acc.variants || acc.variants.length === 0) return null;
        let size = matchingSize || 'Medium';
        let color = preferredColor || 'Weiß';
        if (color === 'Anthrazit') {
          color = 'Grau';
        }

        let match = acc.variants.find(v => {
          let titleLower = v.title.toLowerCase();
          return titleLower.includes(size.toLowerCase()) && titleLower.includes(color.toLowerCase());
        });

        return match || acc.variants[0];
      }

       syncCoverColorWithGlobalColor() {
        if (!this.state.globalColor) return;
        let c = this.state.globalColor.toLowerCase();
        if (c.includes('silber') || c.includes('silver') || c.includes('grau') || c.includes('grey') || c.includes('anthrazit') || c.includes('schwarz') || c.includes('black')) {
            this.state.coverColor = 'Anthrazit';
        } else {
            this.state.coverColor = 'Weiß';
        }
      }

      resolveOutdoorDimensions(sku, title) {
        if (!sku && !title) return null;
        let skuUpper = (sku || '').toUpperCase();
        let titleLower = (title || '').toLowerCase();
        
        // Daikin Multi Split
        if (skuUpper.includes('2MXM')) return '552 x 852 x 350 mm';
        if (skuUpper.includes('3MXM') || skuUpper.includes('4MXM') || skuUpper.includes('5MXM')) {
          return '734 x 974 x 408 mm';
        }
        
        // Daikin Single Split
        // RXM20A, RXM25A9, RXM35A9, RXJ20A9, RXJ25A9, RXJ35A9
        if (skuUpper.includes('RXM20') || skuUpper.includes('RXM25') || skuUpper.includes('RXM35') ||
            skuUpper.includes('RXJ20') || skuUpper.includes('RXJ25') || skuUpper.includes('RXJ35')) {
          return '610 x 923 x 367 mm';
        }
        // RXM50A8, RXJ50A9
        if (skuUpper.includes('RXM50') || skuUpper.includes('RXJ50')) {
          return '734 x 954 x 401 mm';
        }
        
        // Fallback by capacity / rooms if SKU has numbers or title contains room sizes
        if (titleLower.includes('2 /') || titleLower.includes('2-port')) return '552 x 852 x 350 mm';
        if (titleLower.includes('3 /') || titleLower.includes('4 /') || titleLower.includes('5 /') ||
            titleLower.includes('3-port') || titleLower.includes('4-port') || titleLower.includes('5-port')) {
          return '734 x 974 x 408 mm';
        }
        
        // Single split capacity fallback
        if (titleLower.includes('10-25') || titleLower.includes('26-35') || titleLower.includes('36-50') || titleLower.includes('10-35') ||
            skuUpper.includes('12') || skuUpper.includes('09') || skuUpper.includes('20') || skuUpper.includes('25') || skuUpper.includes('35')) {
          return '610 x 923 x 367 mm'; // <= 3.5 kW
        }
        if (titleLower.includes('51-75') || titleLower.includes('36-51') ||
            skuUpper.includes('18') || skuUpper.includes('24') || skuUpper.includes('50') || skuUpper.includes('60')) {
          return '734 x 954 x 401 mm'; // >= 5.0 kW
        }
        
        return null;
      }

      getMaxLfm(rooms) {
         if (rooms === 1) return 25;
         if (rooms === 2) return 40;
         if (rooms === 3) return 50;
         if (rooms === 4) return 60;
         if (rooms === 5) return 70;
         return 50; // fallback
      }

      getMontageVariant(type, isFirst) {
         if (!this.data.montage_services) return null;
         let services = this.data.montage_services;
         
         const getByHandle = (handle) => {
            return services.find(s => s.handle === handle);
         };

         let match = null;
         if (type === 'komplett') {
            match = isFirst ? getByHandle('montage-klimaanlage') : getByHandle('montage-zusatzliches-innengerat');
         } else if (type === 'anschluss') {
            match = isFirst ? getByHandle('anschluss-inbetriebnahme') : getByHandle('anschluss-inbetriebnahme-zusatzliches-gerat');
         } else if (type === 'inbetriebnahme') {
            match = isFirst ? getByHandle('inbetriebnahme') : getByHandle('inbetriebnahme-zusatzliches-innengerat');
         } else if (type === 'laufmeter') {
            match = getByHandle('laufmeter-kaltemittelleitung') || getByHandle('laufmeter');
         }
         
         // Fallback if exact handles are not found (e.g. in other staging environments)
         if (!match) {
            const check = (keywords, exclude = []) => {
               return services.find(s => {
                  let text = (s.title + ' ' + s.handle).toLowerCase();
                  let hasKeywords = keywords.every(k => text.includes(k.toLowerCase()));
                  let hasExcluded = exclude.some(e => text.includes(e.toLowerCase()));
                  return hasKeywords && !hasExcluded;
               });
            };
            if (type === 'komplett') {
               match = isFirst ? check(['montage'], ['zusatz', 'weiter']) : check(['montage', 'zusatz']);
            } else if (type === 'anschluss') {
               match = isFirst ? check(['anschluss'], ['zusatz', 'weiter']) : check(['anschluss', 'zusatz']);
            } else if (type === 'inbetriebnahme') {
               match = isFirst ? check(['inbetriebnahme'], ['zusatz', 'weiter', 'anschluss']) : check(['inbetriebnahme', 'zusatz'], ['anschluss']);
            } else if (type === 'laufmeter') {
               match = check(['laufmeter']);
            }
         }
         
         if (match && match.variants.length > 0) return match.variants[0];
         return null;
      }

      matchColor(availableColors, preferred) {
        if (!preferred) return null;
        const prefLower = preferred.toLowerCase();
        return availableColors.find(c => {
          const cLower = c.toLowerCase();
          if (prefLower === 'weiß' || prefLower === 'white') return cLower.includes('weiß') || cLower.includes('white');
          if (prefLower === 'silber' || prefLower === 'silver') return cLower.includes('silber') || cLower.includes('silver') || cLower.includes('anthrazit') || cLower.includes('grey') || cLower.includes('grau');
          if (prefLower === 'schwarz' || prefLower === 'black') return cLower.includes('schwarz') || cLower.includes('black');
          return false;
        });
      }

      getSeriesBaseSku(sku) {
        if (!sku) return '';
        let clean = sku.trim().toUpperCase();
        
        // Daikin: e.g. FTXM20A -> FTXM-A, FTXF20A -> FTXF-A, FTXP20N9 -> FTXP-N9, FTXA20CB -> FTXA-CB
        if (clean.startsWith('FTX')) {
          return clean.replace(/(FTX[A-Z])\d{2}/, '$1-');
        }
        
        // Samsung: e.g. AR60F09C1AWNEU/-XEU -> AR60F-C1AWNEU/-XEU
        if (clean.startsWith('AR')) {
          return clean.replace(/(AR\d{2}[A-Z])\d{2}/, '$1-');
        }
        
        // Panasonic: e.g. CS-TZ50CKEW -> CS-TZ-CKEW
        if (clean.startsWith('CS-TZ')) {
          return clean.replace(/(CS-TZ)\d{2}/, '$1-');
        }
        
        // Vivax: e.g. ACP-12CH35AERI+/I -> ACP-CH-AERI+/I
        if (clean.startsWith('ACP-')) {
          return clean.replace(/ACP-\d{2}CH\d{2}/, 'ACP-CH-');
        }
        
        return clean;
      }

      updateAllRoomsKw() {
        this.state.rooms.forEach(room => {
          room.kw = this.getKwForSize(room.size);
          let matchedVariant = this.findVariantForRoom(room);
          room.variantId = matchedVariant ? matchedVariant.id : null;
        });
        this.validateAllRoomModels();
      }

      applyBrandFilterToState() {
        this.validateAllRoomModels();
        this.state.rooms.forEach(room => {
          let matchedVariant = this.findVariantForRoom(room);
          room.variantId = matchedVariant ? matchedVariant.id : null;
        });
      }

      applyColorFilterToState() {
        if (!this.state.globalColor) return;
        this.syncCoverColorWithGlobalColor();
        this.state.rooms.forEach(room => {
          let model = this.data.indoor_units.find(u => u.id === room.modelId);
          if (model) {
            let colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
            if (colorOptionIndex !== -1) {
              let colors = Array.from(new Set(model.variants.map(v => v.options[colorOptionIndex])));
              let matched = this.matchColor(colors, this.state.globalColor);
              if (matched) {
                room.selectedColor = matched;
                let v = this.findVariantForRoom(room);
                room.variantId = v ? v.id : null;
              }
            }
          }
        });
      }

      applyMountAccessoryToState() {
        const accessories = this.getAccessories();
        if (!accessories || accessories.length === 0) return;
        
        let floorAcc = accessories.find(a => (a.title || "").toLowerCase().includes("bodenkonsole") || (a.title || "").toLowerCase().includes("dämpfer") || a.id === 1);
        let wallAcc = accessories.find(a => (a.title || "").toLowerCase().includes("wandkonsole") || a.id === 2);
        let roofAcc = accessories.find(a => (a.title || "").toLowerCase().includes("dachkonsole") || a.id === 3);

        let floorId = floorAcc ? floorAcc.id : null;
        let wallId = wallAcc ? wallAcc.id : null;
        let roofId = roofAcc ? roofAcc.id : null;

        let exclude = [floorId, wallId, roofId].filter(id => id !== null);
        this.state.selectedAccessories = this.state.selectedAccessories.filter(id => !exclude.includes(id));

        if (this.state.montageType && this.state.montageType !== 'keine') {
          if (this.state.globalMount === 'boden_balkon' && floorId !== null) {
            this.state.selectedAccessories.push(floorId);
          } else if (this.state.globalMount === 'wand' && wallId !== null) {
            this.state.selectedAccessories.push(wallId);
          } else if (this.state.globalMount === 'dach' && roofId !== null) {
            this.state.selectedAccessories.push(roofId);
          }
        }
      }

      findVariantForRoom(room) {
        let model = this.data.indoor_units.find(u => u.id === room.modelId);
        if (!model || !model.variants || model.variants.length === 0) return null;

        let colorOptionIndex = -1;
        let availableColors = [];
        if (model.options && Array.isArray(model.options)) {
            colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
            if (colorOptionIndex !== -1) {
                let colorSet = new Set();
                model.variants.forEach(v => {
                    if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                        colorSet.add(v.options[colorOptionIndex]);
                    }
                });
                availableColors = Array.from(colorSet);
            }
        }
        
        if (availableColors.length > 0) {
            if (!room.selectedColor || !availableColors.includes(room.selectedColor)) {
                room.selectedColor = availableColors[0];
            }
        } else {
            room.selectedColor = null;
        }

        let targetKw = room.kw;
        let candidates = model.variants.filter(v => this.isMatchingKw(v, targetKw));

        if (candidates.length === 0) {
            candidates = model.variants;
        }

        if (colorOptionIndex !== -1 && room.selectedColor) {
            let colorFiltered = candidates.filter(v => v.options && v.options[colorOptionIndex] === room.selectedColor);
            if (colorFiltered.length > 0) return colorFiltered[0];
        }

        return candidates[0] || model.variants[0];
      }

      updateRoomVariant(room) {
        let matchedVariant = this.findVariantForRoom(room);
        room.variantId = matchedVariant ? matchedVariant.id : null;
      }

      getRoomName(indexOrRoom, fallbackIndex) {
        let room = null;
        let index = 0;
        if (indexOrRoom && typeof indexOrRoom === 'object') {
          room = indexOrRoom;
          index = typeof fallbackIndex === 'number' ? fallbackIndex : (this.state && this.state.rooms ? this.state.rooms.indexOf(room) : -1);
          if (index === -1) {
            let foundIndex = this.state && this.state.rooms ? this.state.rooms.findIndex(r => r.id === room.id) : -1;
            index = foundIndex !== -1 ? foundIndex : (this.state && this.state.rooms ? this.state.rooms.length : 0);
          }
        } else {
          index = indexOrRoom;
          room = this.state && this.state.rooms ? this.state.rooms[index] : null;
        }
        if (room && typeof room.customName === 'string') {
          return room.customName;
        }
        const names = ['Wohnzimmer', 'Schlafzimmer', 'Büro', 'Küche', 'Gästezimmer'];
        return names[index] || `Raum ${index + 1}`;
      }

      updateRoomSizeRealtime(roomId, size) {
        let room = this.state.rooms.find(r => r.id === roomId);
        if (!room) return;

        room.size = size;
        room.kw = this.getKwForSize(room.size);

        this.validateAllRoomModels();

        let matchedVariant = this.findVariantForRoom(room);
        room.variantId = matchedVariant ? matchedVariant.id : null;

        this.calculateOutdoorMatch();

        let card = this.roomsContainer.querySelector(`.room-card [data-room-size="${roomId}"]`)?.closest('.room-card');
        if (card) {
          let kwEl = card.querySelector('.room-kw');
          
          const purposePower = {
            "klimatisieren": 65,
            "klimatisieren_heizen": 80,
            "vollheizung": 100
          };
          const insulationMultiplier = {
            "neubau": 0.8,
            "saniert": 1.0,
            "altbau": 1.2
          };
          let basePower = purposePower[this.state.globalPurpose || "klimatisieren"] || 65;
          let mult = insulationMultiplier[this.state.globalInsulation || "saniert"] || 1.0;
          let coolingLoadPerM2 = basePower * mult;

          // Update real-time label values in slider panel if visible
          let loadEl = card.querySelector(`.calculated-load-${roomId}`);
          let recEl = card.querySelector(`.recommended-class-${roomId}`);
          if (loadEl) loadEl.textContent = `ca. ${(room.size * coolingLoadPerM2 / 1000).toFixed(1)} kW`;
          if (recEl) recEl.textContent = `${room.kw.toFixed(1)} kW`;

          if (kwEl) kwEl.innerHTML = `Kühllast ca. ${(room.size * coolingLoadPerM2 / 1000).toFixed(1)} kW &nbsp;|&nbsp; Gerät: ${room.kw.toFixed(1)} kW`;
          
          let priceEl = card.querySelector('.room-card-price');
          let model = this.data.indoor_units.find(u => u.id === room.modelId);
          let variant = model ? model.variants.find(v => v.id === room.variantId) : null;
          if (priceEl) {
            if (variant) {
              priceEl.textContent = this.formatMoney(variant.price);
            } else {
              priceEl.textContent = '0,00 €';
            }
          }
        }

        if (this.state.matchedOutdoorVariant) {
            let o = this.state.matchedOutdoorVariant;
            this.matchResultEl.style.display = 'block';
            this.matchResultEl.innerHTML = `
              <div class="klimondo-summary-card" style="padding:0 !important; margin:0 0 24px 0 !important; background:none !important; border:none !important; box-shadow:none !important;">
                 <div class="asc-top" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
                    <div class="asc-title-group" style="display:flex; align-items:center; font-weight:600; font-size:1.35rem; color:#1d1d1f;">
                       <strong>Außengerät. <span style="color:#86868b; font-weight:500;">Ausgewähltes Modell</span></strong>
                    </div>
                    <button type="button" class="asc-btn" id="BtnEditOutdoor" style="background:none; border:none; color:#0071e3; cursor:pointer; font-weight:600; font-size:0.9rem; display:flex; align-items:center; gap:4px; padding:0;">Ändern <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></button>
                 </div>
                 <p class="asc-desc" style="font-size:0.85rem; color:#86868b; margin:0 0 16px 0 !important; line-height:1.4;">Für deine Räume passendes Außengerät.</p>
                 
                 <div class="outdoor-current" style="display:flex; gap:16px; background:#ffffff; border:1px solid #d2d2d7; padding:16px 20px; border-radius:16px; align-items:center; justify-content:space-between; box-sizing:border-box; width:100%;">
                    <div style="display:flex; align-items:center; gap:16px; flex:1;">
                       ${o.image ? `<img src="${o.image}" style="width:50px; height:50px; object-fit:contain; mix-blend-mode:multiply; border-radius:8px; flex-shrink:0;">` : `<div style="width:50px; height:50px; background:#e5e5ea; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#86868b" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect></svg></div>`}
                       <div style="flex:1; text-align:left; display:flex; flex-direction:column; gap:2px;">
                          <strong style="display:block; font-size:0.95rem; font-weight:600; color:#1d1d1f; line-height:1.25;">${o.title} - ${o.variant.title.replace(/Leistungsklasse:\s*/i, '').trim()}</strong>
                          <span style="font-size:0.8rem; color:#86868b;">${o.variant.sku || ''}</span>
                       </div>
                    </div>
                    <div style="font-weight:600; font-size:0.95rem; color:#1d1d1f; margin-left:12px; white-space:nowrap; flex-shrink:0;">
                       ${this.formatMoney(o.variant.price)}
                    </div>
                 </div>
              </div>
            `;
        } else {
            this.matchResultEl.style.display = 'block';
            this.matchResultEl.innerHTML = `
                <div class="error-card">
                    <h4>⚠️ Leistungsgrenze erreicht</h4>
                    <p>Für diese Kombination gibt es kein passendes Außengerät. Bitte reduziere die Räume oder teile das Projekt in zwei Anlagen.</p>
                </div>
            `;
        }

        this.updateTotals();
        if (this.visualizer) {
            this.visualizer.render(this.state.rooms, this.state.matchedOutdoorVariant);
        }
        this.saveState();
      }

      updateRoom(roomId, updates) {
        let room = this.state.rooms.find(r => r.id === roomId);
        if (!room) return;

        Object.assign(room, updates);

        if (updates.size !== undefined) {
          room.kw = this.getKwForSize(room.size);
        }

        this.validateAllRoomModels();

        if (updates.size !== undefined || updates.modelId !== undefined) {
          let matchedVariant = this.findVariantForRoom(room);
          room.variantId = matchedVariant ? matchedVariant.id : null;
        }

        if (updates.modelId !== undefined && roomId === 1) {
            let model = this.data.indoor_units.find(u => u.id === updates.modelId);
            if (model) {
                this.state.rooms.forEach(r => {
                    if (r.id !== 1) {
                        let brandModel = this.data.indoor_units.find(u => u.brand === model.brand);
                        if (brandModel) {
                            r.modelId = brandModel.id;
                            let v = this.findVariantForRoom(r);
                            r.variantId = v ? v.id : null;
                        }
                    }
                });
            }
        }
        this.saveState();
        this.render();
      }

      removeRoom(roomId) {
        this.state.rooms = this.state.rooms.filter(r => r.id !== roomId);
        if (this.state.expandedRoomId === roomId) {
           this.state.expandedRoomId = this.state.rooms.length > 0 ? this.state.rooms[this.state.rooms.length - 1].id : null;
        }
        this.validateAllRoomModels();
        this.state.rooms.forEach(r => {
           let v = this.findVariantForRoom(r);
           r.variantId = v ? v.id : null;
        });
        this.saveState();
        this.render();
      }

      toggleRoom(roomId) {
        if (typeof this.clearFocusedImage === 'function') {
           this.clearFocusedImage();
        }
        if (this.state.expandedRoomId === roomId) {
          this.state.expandedRoomId = null;
        } else {
          this.state.expandedRoomId = roomId;
        }
        this.saveState();
        this.render();
      }

      autoProgressAfterRoomComplete(roomId) {
        let nextUncompletedRoom = this.state.rooms.find(r => r.step < 4);
        if (nextUncompletedRoom) {
          this.state.expandedRoomId = nextUncompletedRoom.id;
          this.saveState();
          this.render();
          setTimeout(() => {
            const nextCardHeader = this.querySelector(`.room-card-header[data-toggle="${nextUncompletedRoom.id}"]`);
            if (nextCardHeader) {
              const nextCard = nextCardHeader.closest('.room-card');
              if (nextCard) {
                nextCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } else {
                nextCardHeader.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }
          }, 100);
        } else {
          this.state.expandedRoomId = null;
          this.saveState();
          this.render();
          setTimeout(() => {
            const addRoomBtn = this.querySelector('#AddRoomBtn');
            if (addRoomBtn) {
              addRoomBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
        }
      }

      toggleAccessory(accId) {
        let accs = this.getAccessories() || [];
        let acc = accs.find(a => a.id === accId);
        let defaultQty = acc ? this.getAccessoryDefaultQty(acc) : 1;

        if (this.state.selectedAccessories.includes(accId)) {
            this.state.selectedAccessories = this.state.selectedAccessories.filter(id => id !== accId);
        } else {
            for (let i = 0; i < defaultQty; i++) {
              this.state.selectedAccessories.push(accId);
            }
        }
        this.saveState();
        this.render();
      }

      setAccessoryQty(accId, qty) {
        this.state.selectedAccessories = this.state.selectedAccessories.filter(id => id !== accId);
        for (let i = 0; i < qty; i++) {
          this.state.selectedAccessories.push(accId);
        }
        this.saveState();
        this.render();
      }

      openModal(productData) {
        if (!this.modal) return;
        this.modalImg.src = productData.image || '';
        this.modalTitle.textContent = productData.brand + ' ' + productData.title;
        let desc = productData.description || 'Weitere Informationen zu diesem Produkt.';
        if (desc.length > 200) desc = desc.substring(0, 200) + '...';
        this.modalDesc.innerHTML = `<p>${desc}</p><p class="modal-hint">Technische Details findest du später in der Zusammenfassung.</p>`;
        this.modal.style.display = 'flex';
        this.modal.setAttribute('aria-hidden', 'false');
      }

      closeModal() {
        if (!this.modal) return;
        this.modal.setAttribute('aria-hidden', 'true');
        setTimeout(() => { this.modal.style.display = 'none'; }, 300);
      }

      calculateOutdoorMatch() {
        if (this.state.rooms.length === 0) {
            this.state.matchedOutdoorVariant = null;
            return;
        }

        let totalKw = this.state.rooms.reduce((sum, r) => sum + r.kw, 0);
        let slotsNeeded = this.state.rooms.length;
        
        let firstRoomModel = this.data.indoor_units.find(u => u.id === this.state.rooms[0].modelId);
        let brand = this.state.globalBrand || (firstRoomModel ? firstRoomModel.brand : 'Daikin');
        let indoorModelTitle = firstRoomModel ? firstRoomModel.title : '';

        let candidates = [];

        this.data.outdoor_units.forEach(unit => {
            let isBrandMatch = unit.brand.toUpperCase() === brand.toUpperCase() || unit.title.toUpperCase().includes(brand.toUpperCase());
            if (!isBrandMatch) return;

            unit.variants.forEach(variant => {
                if (slotsNeeded === 1) {
                    let isSingleSplitProduct = variant.maxSlots === 1 || (unit.title.includes('Außengerät') && !unit.title.includes('Multi-Split'));
                    let matchesIndoorLine = true;
                    
                    if (isSingleSplitProduct && indoorModelTitle) {
                        let indoorWords = indoorModelTitle.split(' ').filter(w => w.length > 3 && w.toUpperCase() !== brand.toUpperCase());
                        if (indoorWords.length > 0) {
                            let lineMatch = indoorWords.some(w => unit.title.toUpperCase().includes(w.toUpperCase()));
                            if (!lineMatch) {
                                matchesIndoorLine = false;
                            }
                        }
                    }

                    if (matchesIndoorLine && variant.maxKw >= totalKw) {
                        // Penalty to prefer Single-Split over Multi-Split for 1 room
                        let penalty = isSingleSplitProduct ? 0 : 10000;
                        candidates.push({...unit, variant: variant, penalty: penalty});
                    }
                } else {
                    if (variant.maxSlots >= slotsNeeded) {
                        // Check limits
                        let limitArray = this.DAIKIN_LIMITS;
                        if (brand.toUpperCase() === 'SAMSUNG') limitArray = this.SAMSUNG_LIMITS;
                        if (brand.toUpperCase() === 'PANASONIC') limitArray = this.PANASONIC_LIMITS;

                        let limit = limitArray.find(l => l.slots === variant.maxSlots && Math.abs(l.nomKw - variant.maxKw) < 0.3);
                        let fitsLimit = limit ? totalKw <= limit.maxConnectable : totalKw <= (variant.maxKw * 1.5);
                        
                        if (fitsLimit) {
                            candidates.push({...unit, variant: variant, penalty: 0});
                        }
                    }
                }
            });
        });

        if (candidates.length === 0 && slotsNeeded === 1) {
            // Retry without strict line matching constraint to prevent blocking
            this.data.outdoor_units.forEach(unit => {
                let isBrandMatch = unit.brand.toUpperCase() === brand.toUpperCase() || unit.title.toUpperCase().includes(brand.toUpperCase());
                if (!isBrandMatch) return;

                unit.variants.forEach(variant => {
                    let isSingleSplitProduct = variant.maxSlots === 1 || (unit.title.includes('Außengerät') && !unit.title.includes('Multi-Split'));
                    if (variant.maxKw >= totalKw) {
                        let penalty = isSingleSplitProduct ? 0 : 10000;
                        candidates.push({...unit, variant: variant, penalty: penalty});
                    }
                });
            });
        }

        // Sort by penalty (prefer exact slot match) and then by price
        candidates.sort((a, b) => {
            if (a.penalty !== b.penalty) return a.penalty - b.penalty;
            return a.variant.price - b.variant.price;
        });
        
        this.state.validOutdoorCandidates = candidates;
        
        if (candidates.length > 0) {
            // Apply manual override if it still exists in valid candidates
            if (this.state.manualOutdoorVariantId) {
                let manualMatch = candidates.find(c => c.variant.id === this.state.manualOutdoorVariantId);
                if (manualMatch) {
                    this.state.matchedOutdoorVariant = manualMatch;
                } else {
                    this.state.manualOutdoorVariantId = null;
                    this.state.matchedOutdoorVariant = candidates[0];
                }
            } else {
                this.state.matchedOutdoorVariant = candidates[0];
            }
        } else {
            this.state.matchedOutdoorVariant = null; // Over capacity
            this.state.manualOutdoorVariantId = null;
        }
      }

      formatMoney(cents) {
        return (cents / 100).toLocaleString('de-AT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }

      preselectModelAndColor(brandName, modelTitlePattern, colorValue) {
        console.log("Preselecting model and color:", brandName, modelTitlePattern, colorValue);
        if (brandName) {
          this.state.globalBrand = brandName.toLowerCase();
        }
        if (colorValue) {
          this.state.globalColor = colorValue.toLowerCase();
        }

        // Find the model
        let matchingModel = null;
        if (modelTitlePattern) {
          const pattern = modelTitlePattern.toLowerCase();
          matchingModel = this.data.indoor_units.find(u => 
            (u.title || '').toLowerCase().includes(pattern) || 
            ((u.brand || '') + ' ' + (u.title || '')).toLowerCase().includes(pattern)
          );
        }

        if (matchingModel) {
          this.state.rooms.forEach(room => {
            room.modelId = matchingModel.id;
          });
        }

        // Run updates
        this.validateAllRoomModels();
        this.applyBrandFilterToState();
        this.applyColorFilterToState();
        this.calculateOutdoorMatch();
        this.saveState();
        this.render();
      }

      saveState() {
        try {
          sessionStorage.setItem('klimondo_configurator_state', JSON.stringify({
            rooms: this.state.rooms,
            selectedAccessories: this.state.selectedAccessories,
            expandedRoomId: this.state.expandedRoomId,
            globalPurpose: this.state.globalPurpose,
            globalInsulation: this.state.globalInsulation,
            globalBrand: this.state.globalBrand,
            globalColor: this.state.globalColor,
            globalMount: this.state.globalMount,
            globalSettingsExpanded: this.state.globalSettingsExpanded,
            globalStep: this.state.globalStep,
            softLautstaerke: this.state.softLautstaerke,
            softTechnik: this.state.softTechnik,
            softDesign: this.state.softDesign,
            montageType: this.state.montageType,
            montageMeters: this.state.montageMeters,
            montageExpanded: this.state.montageExpanded,
            garantieType: this.state.garantieType,
            garantieExpanded: this.state.garantieExpanded,
            manualOutdoorVariantId: this.state.manualOutdoorVariantId,
            outdoorExpanded: this.state.outdoorExpanded,
            plz: this.state.plz,
            coverColor: this.state.coverColor,
            coverSizeOverride: this.state.coverSizeOverride,
            showCoverSizeOptions: this.state.showCoverSizeOptions,
            showInstallationOptions: this.state.showInstallationOptions
          }));
        } catch (e) {
          console.error('Failed to save state:', e);
        }
      }

      loadState() {
        try {
          let saved = sessionStorage.getItem('klimondo_configurator_state');
          if (saved) {
            let parsed = JSON.parse(saved);
            if (parsed && Array.isArray(parsed.rooms) && parsed.rooms.length > 0) {
              this.state.rooms = parsed.rooms;
              this.state.rooms.forEach(room => {
                if (!room.step) {
                  if (room.variantId) {
                    room.step = 4;
                  } else {
                    room.step = 1;
                  }
                }
              });
              this.state.selectedAccessories = parsed.selectedAccessories || [];
              this.state.coverColor = (parsed.coverColor === 'Grau' || parsed.coverColor === 'Anthrazit') ? 'Anthrazit' : (parsed.coverColor !== undefined ? parsed.coverColor : 'Weiß');
              this.state.coverSizeOverride = parsed.coverSizeOverride !== undefined ? parsed.coverSizeOverride : null;
              this.state.showCoverSizeOptions = parsed.showCoverSizeOptions !== undefined ? parsed.showCoverSizeOptions : false;
              this.state.showInstallationOptions = parsed.showInstallationOptions !== undefined ? parsed.showInstallationOptions : false;
              this.state.expandedRoomId = parsed.expandedRoomId !== undefined ? parsed.expandedRoomId : parsed.rooms[0].id;
              this.state.globalPurpose = parsed.globalPurpose !== undefined ? parsed.globalPurpose : 'klimatisieren';
              this.state.globalInsulation = parsed.globalInsulation !== undefined ? parsed.globalInsulation : 'saniert';
              this.state.globalBrand = parsed.globalBrand ? parsed.globalBrand : 'daikin';
              this.state.globalColor = ''; // Reset global color to empty to prevent forcing black from old session states
              this.state.globalMount = parsed.globalMount !== undefined ? parsed.globalMount : 'wand';
              this.state.globalSettingsExpanded = parsed.globalSettingsExpanded !== undefined ? parsed.globalSettingsExpanded : false;
              
              if (this.hideGlobalSettings) {
                this.state.globalStep = 4;
              } else if (this.state.rooms.some(r => r.size !== null)) {
                this.state.globalStep = 4;
              } else {
                this.state.globalStep = parsed.globalStep !== undefined ? parsed.globalStep : 1;
              }
              this.state.softLautstaerke = parsed.softLautstaerke !== undefined ? parsed.softLautstaerke : 0;
              this.state.softTechnik = parsed.softTechnik !== undefined ? parsed.softTechnik : 0;
              this.state.softDesign = parsed.softDesign !== undefined ? parsed.softDesign : 0;
              this.state.montageType = parsed.montageType !== undefined ? parsed.montageType : 'keine';
              this.state.montageMeters = parsed.montageMeters !== undefined ? parsed.montageMeters : -1;
              this.state.montageExpanded = parsed.montageExpanded !== undefined ? parsed.montageExpanded : false;
              this.state.garantieType = parsed.garantieType !== undefined ? parsed.garantieType : '2_jahre';
              this.state.garantieExpanded = parsed.garantieExpanded !== undefined ? parsed.garantieExpanded : false;
              this.state.manualOutdoorVariantId = parsed.manualOutdoorVariantId !== undefined ? parsed.manualOutdoorVariantId : null;
              this.state.outdoorExpanded = parsed.outdoorExpanded !== undefined ? parsed.outdoorExpanded : false;
              this.state.plz = parsed.plz || '';
              return true;
            }
          }
        } catch (e) {
          console.error('Failed to load state:', e);
        }
        return false;
      }

      updateTotals() {
        let total = 0;
        this.state.rooms.forEach(r => {
            let model = this.data.indoor_units.find(u => u.id === r.modelId);
            let variant = model ? model.variants.find(v => v.id === r.variantId) : null;
            if (variant) total += variant.price;
        });

        let hasConsole = true;
        let roomsCount = this.state.rooms.length;
        if (roomsCount > 0 && this.state.matchedOutdoorVariant && this.state.montageType !== 'keine') {
            let accessoriesList = this.getAccessories() || [];
            hasConsole = this.state.selectedAccessories.some(accId => {
                let acc = accessoriesList.find(a => a.id === accId || String(a.id) === String(accId));
                if (!acc) return false;
                let title = (acc.title || '').toLowerCase();
                return title.includes('konsole') || title.includes('halterung') || title.includes('dämpfer') || title.includes('bracket') || accId === 1 || accId === 2 || accId === 3;
            });
        }

        let plzValid = true;
        if (roomsCount > 0 && this.state.matchedOutdoorVariant && this.state.montageType !== 'keine') {
            if (!this.state.plz) {
                plzValid = false;
            } else {
                let plzInt = parseInt(this.state.plz.trim(), 10);
                let isValidWien = isWienPlz(plzInt);
                let isValidGraz = isGrazPlz(plzInt);
                plzValid = isValidWien || isValidGraz;
            }
        }

        let isConfiguratorValid = hasConsole && plzValid;

        if (this.state.matchedOutdoorVariant && isConfiguratorValid) {
            total += this.state.matchedOutdoorVariant.variant.price;
            this.addToCartBtn.disabled = false;
            if (this.requestQuoteBtn) this.requestQuoteBtn.disabled = false;
            if (this.bottomAddToCartBtn) this.bottomAddToCartBtn.disabled = false;
            if (this.bottomRequestQuoteBtn) this.bottomRequestQuoteBtn.disabled = false;
            if (this.bottomSummaryCard) this.bottomSummaryCard.style.display = 'block';
            this.errorEl.style.display = 'none';
            if (this.bottomErrorEl) {
                this.bottomErrorEl.style.display = 'none';
            }
        } else {
            this.addToCartBtn.disabled = true;
            if (this.requestQuoteBtn) this.requestQuoteBtn.disabled = true;
            if (this.bottomAddToCartBtn) this.bottomAddToCartBtn.disabled = true;
            if (this.bottomRequestQuoteBtn) this.bottomRequestQuoteBtn.disabled = true;
            
            if (this.state.matchedOutdoorVariant) {
                total += this.state.matchedOutdoorVariant.variant.price;
                if (this.bottomSummaryCard) this.bottomSummaryCard.style.display = 'block';
            } else {
                if (this.bottomSummaryCard) this.bottomSummaryCard.style.display = 'none';
            }

            let errMsg = '';
            if (this.state.matchedOutdoorVariant) {
                if (!plzValid) {
                    if (!this.state.plz) {
                        errMsg = 'Bitte gib eine Postleitzahl für die Montage ein.';
                    } else {
                        errMsg = 'Eine Montage ist derzeit nur im Raum Wien (1000-1239) und Graz (+ 25km Umland) möglich. Für andere Gebiete wähle bitte "Gerätelieferung".';
                    }
                } else if (!hasConsole) {
                    errMsg = 'Für die Montage wird eine Wand-, Boden- oder Dachkonsole benötigt. Bitte wähle eine passende Halterung im Zubehör aus.';
                }
            }
            
            if (errMsg) {
                this.errorEl.textContent = errMsg;
                this.errorEl.style.display = 'block';
                if (this.bottomErrorEl) {
                    this.bottomErrorEl.textContent = errMsg;
                    this.bottomErrorEl.style.display = 'block';
                }
            } else {
                this.errorEl.style.display = 'none';
                if (this.bottomErrorEl) {
                    this.bottomErrorEl.style.display = 'none';
                }
            }
        }

        let accessories = this.getAccessories();
        if (accessories) {
            // Cap pump quantity to room count
            let pumpId = null;
            let pumpAcc = accessories.find(a => (a.title || '').toLowerCase().includes('pumpe') || (a.title || '').toLowerCase().includes('pump'));
            if (pumpAcc) {
              pumpId = pumpAcc.id;
              let pumpQty = this.state.selectedAccessories.filter(id => id === pumpId).length;
              if (pumpQty > roomsCount) {
                // Keep all non-pump items, and add pumpId exactly roomsCount times
                this.state.selectedAccessories = this.state.selectedAccessories.filter(id => id !== pumpId);
                for (let i = 0; i < roomsCount; i++) {
                  this.state.selectedAccessories.push(pumpId);
                }
                this.saveState();
              }
            }

            this.state.selectedAccessories.forEach(accId => {
                let acc = accessories.find(a => a.id === accId);
                if (acc && acc.variants.length > 0) {
                    let price = acc.variants[0].price;
                    let isCover = (acc.handle === 'abdeckung-aussengerat') || (acc.title && acc.title.toLowerCase().includes('abdeckung')) || acc.id === 16338514444633;
                    if (isCover) {
                        let outdoorDim = this.state.matchedOutdoorVariant ? (this.state.matchedOutdoorVariant.variant.dim || this.resolveOutdoorDimensions(this.state.matchedOutdoorVariant.variant.sku, this.state.matchedOutdoorVariant.title + ' ' + this.state.matchedOutdoorVariant.variant.title)) : null;
                        let matchingSize = this.state.coverSizeOverride || this.getMatchingCoverSize(outdoorDim, this.state.rooms.length);
                        let matchedVariant = this.getCoverVariant(acc, matchingSize, this.state.coverColor);
                        if (matchedVariant) {
                            price = matchedVariant.price;
                        }
                    }
                    total += price;
                }
            });
        }
        
        // Add Montage Costs
        if (roomsCount > 0 && this.state.matchedOutdoorVariant) {
            let mType = this.state.montageType;
            if (mType !== 'keine') {
                let vFirst = this.getMontageVariant(mType, true);
                let vNext = this.getMontageVariant(mType, false);
                
                let pFirst = vFirst ? vFirst.price : (mType === 'komplett' ? 75000 : (mType === 'anschluss' ? 70000 : 60000));
                let pNext = vNext ? vNext.price : (mType === 'komplett' ? 30000 : (mType === 'anschluss' ? 20000 : 15000));
                
                total += pFirst;
                if (roomsCount > 1) {
                    total += (roomsCount - 1) * pNext;
                }
                
                if (mType === 'komplett') {
                    if (this.state.montageMeters === -1) {
                        this.state.montageMeters = roomsCount * 5;
                    }
                    const minLfm = roomsCount * 3;
                    if (this.state.montageMeters < minLfm) {
                        this.state.montageMeters = minLfm;
                    }
                    const maxLfm = this.getMaxLfm(roomsCount);
                    if (this.state.montageMeters > maxLfm) {
                        this.state.montageMeters = maxLfm;
                    }
                    let vMeter = this.getMontageVariant('laufmeter', false);
                    let pMeter = vMeter ? vMeter.price : 10000;
                    total += this.state.montageMeters * pMeter;
                }
            }
        }

        let baseTotal = total;
        if (this.state.garantieType === '5_jahre') {
            let rawPercent = baseTotal * 0.09;
            let eurVal = rawPercent / 100;
            let roundedEur = Math.round(eurVal / 10) * 10;
            let warrantyPrice = roundedEur * 100;
            total += warrantyPrice;
        }

        this.state.totalPrice = total;
        this.totalPriceEl.textContent = this.formatMoney(total);
        if (this.bottomTotalPriceEl) {
            this.bottomTotalPriceEl.textContent = this.formatMoney(total);
        }
      }

      renderGlobalSettings() {
        if (!this.globalSettingsContainer) return;
        if (this.hideGlobalSettings) {
          this.globalSettingsContainer.style.display = 'none';
          return;
        }
        this.globalSettingsContainer.style.display = 'block';

        const p = this.state.globalPurpose;
        const ins = this.state.globalInsulation;
        const br = this.state.globalBrand;
        const step = this.state.globalStep || 1;

        let html = '';

        if (step < 4) {
          if (step > 1) {
            // Render Back button
            html += `
              <button type="button" class="global-back-btn" style="background:none; border:none; color:#0071e3; cursor:pointer; font-size:0.95rem; margin-bottom:2rem; display:flex; align-items:center; gap:6px; padding:0; font-weight: 600;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="transform:translateY(-0.5px);"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                Zurück
              </button>
            `;
          }

          if (step === 1) {
            html += `
              <div class="global-setting-group" style="margin-bottom: 2rem;">
                <h3 style="font-size:1.45rem; font-weight:600; margin-bottom:24px; color:#1d1d1f; margin-top:0; line-height:1.25;">Hauptzweck. <span class="step-title-grey" style="display:block; font-size:1.05rem; font-weight:400; margin-top:4px; color:#86868b;">Zweck der Klimaanlage</span></h3>
                <div class="options-boxes-grid" style="display:grid; grid-template-columns:repeat(auto-fit, minmax(200px, 1fr)); gap:16px;">
                  
                  <div class="step-option-card ${p === 'klimatisieren' ? 'is-selected' : ''}" data-purpose-select="klimatisieren" role="button" style="padding:24px 20px; border:1px solid ${p === 'klimatisieren' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${p === 'klimatisieren' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line><path d="m20 16-4-4 4-4"></path><path d="m4 8 4 4-4 4"></path><path d="m16 4-4 4-4-4"></path><path d="m8 20 4-4 4 4"></path></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Klimatisieren</strong>
                    <span style="font-size:0.8rem; color:#86868b;">65 W/m²</span>
                  </div>

                  <div class="step-option-card ${p === 'klimatisieren_heizen' ? 'is-selected' : ''}" data-purpose-select="klimatisieren_heizen" role="button" style="padding:24px 20px; border:1px solid ${p === 'klimatisieren_heizen' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${p === 'klimatisieren_heizen' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path><path d="M2 12h2"></path><path d="M20 12h2"></path><path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Klimatisieren & Heizen</strong>
                    <span style="font-size:0.8rem; color:#86868b;">80 W/m²</span>
                  </div>

                  <div class="step-option-card ${p === 'vollheizung' ? 'is-selected' : ''}" data-purpose-select="vollheizung" role="button" style="padding:24px 20px; border:1px solid ${p === 'vollheizung' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${p === 'vollheizung' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Vollwertige Heizung</strong>
                    <span style="font-size:0.8rem; color:#86868b;">100 W/m²</span>
                  </div>

                </div>
              </div>
            `;
          } else if (step === 2) {
            html += `
              <div class="global-setting-group" style="margin-bottom: 2rem;">
                <h3 style="font-size:1.45rem; font-weight:600; margin-bottom:24px; color:#1d1d1f; margin-top:0; line-height:1.25;">Gebäudedämmung. <span class="step-title-grey" style="display:block; font-size:1.05rem; font-weight:400; margin-top:4px; color:#86868b;">Zustand der Dämmung</span></h3>
                <div class="options-boxes-grid" style="display:grid; grid-template-columns:repeat(auto-fit, minmax(200px, 1fr)); gap:16px;">
                  
                  <div class="step-option-card ${ins === 'neubau' ? 'is-selected' : ''}" data-insulation-select="neubau" role="button" style="padding:24px 20px; border:1px solid ${ins === 'neubau' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${ins === 'neubau' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Gute Dämmung</strong>
                    <span style="font-size:0.8rem; color:#86868b;">Neubau (-20%)</span>
                  </div>

                  <div class="step-option-card ${ins === 'saniert' ? 'is-selected' : ''}" data-insulation-select="saniert" role="button" style="padding:24px 20px; border:1px solid ${ins === 'saniert' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${ins === 'saniert' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Standard Dämmung</strong>
                    <span style="font-size:0.8rem; color:#86868b;">Saniert</span>
                  </div>

                  <div class="step-option-card ${ins === 'altbau' ? 'is-selected' : ''}" data-insulation-select="altbau" role="button" style="padding:24px 20px; border:1px solid ${ins === 'altbau' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:8px; box-sizing:border-box; transition: all 0.2s; min-height: 120px; justify-content: center; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <div class="option-icon" style="margin-bottom:4px; display:flex; align-items:center; justify-content:center;">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${ins === 'altbau' ? '#0071e3' : '#86868b'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line></svg>
                    </div>
                    <strong style="font-size:1rem; color:#1d1d1f; display:block; font-weight:600;">Schlechte Dämmung</strong>
                    <span style="font-size:0.8rem; color:#86868b;">Altbau (+20%)</span>
                  </div>

                </div>
              </div>
            `;
          } else if (step === 3) {
            html += `
              <div class="global-setting-group" style="margin-bottom: 2rem;">
                <h3 style="font-size:1.45rem; font-weight:600; margin-bottom:24px; color:#1d1d1f; margin-top:0; line-height:1.25;">Marke. <span class="step-title-grey" style="display:block; font-size:1.05rem; font-weight:400; margin-top:4px; color:#86868b;">Wähle deinen Hersteller</span></h3>
                <div class="options-boxes-grid" style="display:grid; grid-template-columns:repeat(auto-fit, minmax(130px, 1fr)); gap:12px;">
                  
                  <div class="step-option-card ${br === '' ? 'is-selected' : ''}" data-brand-select="" role="button" style="padding:20px; border:1px solid ${br === '' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:96px; gap:8px; box-sizing:border-box; transition: all 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <span style="font-size:1rem; font-weight:600; color:#1d1d1f;">Alle Marken</span>
                  </div>

                  <div class="step-option-card ${br === 'Daikin' ? 'is-selected' : ''}" data-brand-select="Daikin" role="button" style="padding:20px; border:1px solid ${br === 'Daikin' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:96px; gap:8px; box-sizing:border-box; transition: all 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <img src="/cdn/shop/files/Daikin_Logo.png" alt="Daikin" style="max-height:48px; max-width:90%; object-fit:contain;" />
                  </div>

                  <div class="step-option-card ${br === 'Samsung' ? 'is-selected' : ''}" data-brand-select="Samsung" role="button" style="padding:20px; border:1px solid ${br === 'Samsung' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:96px; gap:8px; box-sizing:border-box; transition: all 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <img src="/cdn/shop/files/samsung_logo.png" alt="Samsung" style="max-height:30px; max-width:90%; object-fit:contain;" />
                  </div>

                  <div class="step-option-card ${br === 'Panasonic' ? 'is-selected' : ''}" data-brand-select="Panasonic" role="button" style="padding:20px; border:1px solid ${br === 'Panasonic' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:96px; gap:8px; box-sizing:border-box; transition: all 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <img src="/cdn/shop/files/logo_panasonic.jpg" alt="Panasonic" style="max-height:26px; max-width:90%; object-fit:contain;" />
                  </div>

                  <div class="step-option-card ${br === 'Vivax' ? 'is-selected' : ''}" data-brand-select="Vivax" role="button" style="padding:20px; border:1px solid ${br === 'Vivax' ? '#0071e3' : '#d2d2d7'}; border-radius:16px; background:#fff; text-align:center; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:96px; gap:8px; box-sizing:border-box; transition: all 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.02);">
                    <img src="/cdn/shop/files/logo_vivax_red.svg" alt="Vivax" style="max-height:30px; max-width:90%; object-fit:contain;" />
                  </div>

                </div>
              </div>
            `;
          }
        } else {
          // Render elegant summary panel at step 4
          let purposeText = 'Klimatisieren & Heizen';
          if (p === 'klimatisieren') purposeText = 'Klimatisieren';
          else if (p === 'vollheizung') purposeText = 'Vollwertige Heizung';

          let insulationText = 'Standard Dämmung';
          if (ins === 'neubau') insulationText = 'Gute Dämmung';
          else if (ins === 'altbau') insulationText = 'Schlechte Dämmung';

          let brandText = 'Alle Marken';
          if (br === 'Daikin') brandText = 'Daikin';
          else if (br === 'Samsung') brandText = 'Samsung';
          else if (br === 'Panasonic') brandText = 'Panasonic';
          else if (br === 'Vivax') brandText = 'Vivax';

          let purposeIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path></svg>';
          if (p === 'klimatisieren') {
            purposeIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="22"></line><line x1="17" y1="5" x2="7" y2="19"></line><line x1="19" y1="12" x2="5" y2="12"></line><line x1="17" y1="19" x2="7" y2="5"></line></svg>';
          } else if (p === 'vollheizung') {
            purposeIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path></svg>';
          }

          let insulationIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>';
          let brandIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>';

          html += `
            <div class="global-settings-summary-panel">
              <div class="global-settings-summary-header">
                <span class="global-settings-summary-title">Konfiguration-Basis</span>
                <button type="button" class="edit-global-settings-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                  Ändern
                </button>
              </div>
              <div class="global-settings-summary-grid">
                <div class="global-settings-summary-item">
                  <span class="global-settings-summary-label">Hauptzweck</span>
                  <strong class="global-settings-summary-value">${purposeIcon} ${purposeText}</strong>
                </div>
                <div class="global-settings-summary-item">
                  <span class="global-settings-summary-label">Dämmung</span>
                  <strong class="global-settings-summary-value">${insulationIcon} ${insulationText}</strong>
                </div>
                <div class="global-settings-summary-item">
                  <span class="global-settings-summary-label">Marke</span>
                  <strong class="global-settings-summary-value">${brandIcon} ${brandText}</strong>
                </div>
              </div>
            </div>
          `;
        }

        this.globalSettingsContainer.innerHTML = html;
      }

      setFocusedImage(images) {
        if (!images) return;
        if (!Array.isArray(images)) images = [images];
        if (images.length === 0) return;

        let canvas = this.querySelector('#VisualizerCanvas');
        if(!canvas) return;

        if (this.autoSwitchTimer) clearTimeout(this.autoSwitchTimer);
        let oldOverlay = canvas.querySelector('.focused-image-overlay');
        if (oldOverlay) oldOverlay.remove();

        let overlay = document.createElement('div');
        overlay.className = 'focused-image-overlay';
        overlay.style.cssText = "position:absolute; top:0; left:0; width:100%; height:100%; background:#f5f5f7; z-index:10; animation: popIn 0.4s ease-out; display:flex; flex-direction:column; align-items:center; justify-content:center; pointer-events:none;";

        let sliderContainer = document.createElement('div');
        sliderContainer.style.cssText = "position:relative; width:100%; height:80%; display:flex; align-items:center; justify-content:center; overflow:hidden;";

        let img = document.createElement('img');
        img.src = images[0];
        img.style.cssText = `position:absolute; max-width:90%; max-height:90%; object-fit:contain; transition: opacity 0.3s ease, transform 0.3s ease; opacity: 1; transform: translateX(0); pointer-events:auto;`;
        sliderContainer.appendChild(img);

        overlay.appendChild(sliderContainer);

        let controls = document.createElement('div');
        controls.style.cssText = "display:flex; align-items:center; gap:1rem; margin-top:1rem; pointer-events:auto;";

        let prevBtn = document.createElement('button');
        prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
        prevBtn.style.cssText = "width:32px; height:32px; border-radius:50%; border:none; background:#e5e5ea; cursor:pointer; display:flex; align-items:center; justify-content:center; color:#1d1d1f;";

        let dotsContainer = document.createElement('div');
        dotsContainer.style.cssText = "display:flex; gap:8px; background:#e5e5ea; padding:8px 12px; border-radius:100px;";

        let dot0 = document.createElement('div');
        dot0.style.cssText = `width:8px; height:8px; border-radius:50%; background:#1d1d1f; cursor:pointer; opacity:1; transition: opacity 0.2s;`;
        let dot1 = document.createElement('div');
        dot1.style.cssText = `width:8px; height:8px; border-radius:50%; background:#1d1d1f; cursor:pointer; opacity:0.3; transition: opacity 0.2s;`;
        
        dotsContainer.appendChild(dot0);
        dotsContainer.appendChild(dot1);

        let nextBtn = document.createElement('button');
        nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
        nextBtn.style.cssText = "width:32px; height:32px; border-radius:50%; border:none; background:#e5e5ea; cursor:pointer; display:flex; align-items:center; justify-content:center; color:#1d1d1f;";

        controls.appendChild(prevBtn);
        controls.appendChild(dotsContainer);
        controls.appendChild(nextBtn);
        overlay.appendChild(controls);

        let hotspots = canvas.querySelector('#HotspotsContainer');
        let currentIndex = 0;

        const updateSlider = (newIndex) => {
            currentIndex = newIndex;
            if (currentIndex === 0) {
                img.style.opacity = '1';
                img.style.transform = 'translateX(0)';
                img.style.pointerEvents = 'auto';
                overlay.style.background = '#f5f5f7';
                dot0.style.opacity = '1';
                dot1.style.opacity = '0.3';
                if(hotspots) hotspots.style.display = 'none';
            } else {
                img.style.opacity = '0';
                img.style.transform = 'translateX(-20px)';
                img.style.pointerEvents = 'none';
                overlay.style.background = 'transparent';
                dot0.style.opacity = '0.3';
                dot1.style.opacity = '1';
                if(hotspots) hotspots.style.display = 'block';
            }
        };

        const onAction = (newIndex) => {
            if (this.autoSwitchTimer) clearTimeout(this.autoSwitchTimer);
            updateSlider(newIndex);
        };

        prevBtn.onclick = (e) => {
            e.stopPropagation();
            onAction(currentIndex === 0 ? 1 : 0);
        };

        nextBtn.onclick = (e) => {
            e.stopPropagation();
            onAction(currentIndex === 0 ? 1 : 0);
        };

        dot0.onclick = (e) => {
            e.stopPropagation();
            if (currentIndex !== 0) onAction(0);
        };
        dot1.onclick = (e) => {
            e.stopPropagation();
            if (currentIndex !== 1) onAction(1);
        };

        canvas.appendChild(overlay);
        if(hotspots) hotspots.style.display = 'none';

        this.autoSwitchTimer = setTimeout(() => {
            if (currentIndex === 0) updateSlider(1);
        }, 10000);
      }

      clearFocusedImage() {
        let canvas = this.querySelector('#VisualizerCanvas');
        if(!canvas) return;
        if (this.autoSwitchTimer) clearTimeout(this.autoSwitchTimer);
        let overlay = canvas.querySelector('.focused-image-overlay');
        if(overlay) overlay.remove();

        let hotspots = canvas.querySelector('#HotspotsContainer');
        if(hotspots) hotspots.style.display = 'block';
      }

      render() {
        this.renderGlobalSettings();
        this.calculateOutdoorMatch();

        const step = this.state.globalStep || 1;
        // 1. Render Rooms UI
        this.roomsContainer.innerHTML = '';
        this.state.rooms.forEach((room, index) => {
          let model = this.data.indoor_units.find(u => u.id === room.modelId);
          let variant = model ? model.variants.find(v => v.id === room.variantId) : null;
          let isExpanded = this.state.expandedRoomId === room.id;
          
          let colorOptionIndex = -1;
          let availableColors = [];
          if (model && model.options && Array.isArray(model.options)) {
            colorOptionIndex = model.options.findIndex(opt => opt && typeof opt === 'string' && (opt.toLowerCase() === 'farbe' || opt.toLowerCase() === 'color'));
            if (colorOptionIndex !== -1) {
                let colorSet = new Set();
                model.variants.forEach(v => {
                    if (v.options && v.options[colorOptionIndex] && typeof v.options[colorOptionIndex] === 'string') {
                        colorSet.add(v.options[colorOptionIndex]);
                    }
                });
                availableColors = Array.from(colorSet);
            }
          }
          
          let roomName = this.getRoomName(room, index);
          let titleText = roomName ? `Raum ${index + 1} (${roomName})` : `Raum ${index + 1}`;
          
          // Minimum price helper for size cards
          const getMinPriceForKw = (kwVal) => {
            let minPrice = Infinity;
            let brandFilter = this.state.globalBrand || 'daikin';
            this.data.indoor_units.forEach(u => {
              if (brandFilter && (u.brand || '').toLowerCase() !== brandFilter.toLowerCase()) return;
              if (!this.isModelValidForRoom(u, { kw: kwVal }, this.state.rooms.length)) return;
              let candidates = u.variants.filter(v => this.isMatchingKw(v, kwVal));
              candidates.forEach(v => {
                if (v.price < minPrice) minPrice = v.price;
              });
            });
            return minPrice === Infinity ? null : minPrice;
          };

          // Tags HTML
          let tagsHtml = '';
          if (room.step > 1 && room.size) {
            let sizeVal = `${room.size} m²`;
            if (room.size === 25) sizeVal = "10-25 m²";
            else if (room.size === 35) sizeVal = "26-35 m²";
            else if (room.size === 50) sizeVal = "36-50 m²";
            else if (room.size === 75) sizeVal = "51-75 m²";
            
            tagsHtml += `
              <div class="room-tag">
                <span>Größe: ${sizeVal}</span>
                <button type="button" data-change-step="1" data-room-id="${room.id}">Ändern</button>
              </div>
            `;
          }
          if (room.step > 2 && model) {
            tagsHtml += `
              <div class="room-tag">
                <span>Serie: ${model.brand} ${model.title}</span>
                <button type="button" data-change-step="2" data-room-id="${room.id}">Ändern</button>
              </div>
            `;
          }
          if (room.step > 3 && room.selectedColor) {
            tagsHtml += `
              <div class="room-tag">
                <span>Farbe: ${room.selectedColor}</span>
                ${availableColors.length > 1 ? `<button type="button" data-change-step="3" data-room-id="${room.id}">Ändern</button>` : ''}
              </div>
            `;
          }

          let cardSubtitle = 'Größe wählen';
          if (room.step === 2) {
            let sizeVal = `${room.size} m²`;
            cardSubtitle = `${sizeVal} • Innengerät wählen`;
          } else if (room.step === 3 && model) {
            let sizeVal = `${room.size} m²`;
            cardSubtitle = `${sizeVal} • ${model.brand} ${model.title} • Farbe wählen`;
          } else if (room.step === 4 && model) {
            let sizeVal = `${room.size} m²`;
            let parts = [sizeVal, `${model.brand} ${model.title}`];
            if (room.selectedColor) parts.push(room.selectedColor);
            cardSubtitle = parts.join(' • ');
          }

          let htmlBody = '';
          if (room.step === 1) {
              let currentSize = room.size || 25;
              const purposePower = {
                "klimatisieren": 65,
                "klimatisieren_heizen": 80,
                "vollheizung": 100
              };
              const insulationMultiplier = {
                "neubau": 0.8,
                "saniert": 1.0,
                "altbau": 1.2
              };
              let basePower = purposePower[this.state.globalPurpose || "klimatisieren"] || 65;
              let mult = insulationMultiplier[this.state.globalInsulation || "saniert"] || 1.0;
              let finalPowerPerM2 = basePower * mult;
              let loadKw = (currentSize * finalPowerPerM2) / 1000;
              let recommendedKw = this.getKwForSize(currentSize);

              htmlBody = `
                <div class="step-slider-container" style="padding: 0.5rem 0;">
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.75rem; align-items: baseline;">
                    <span style="font-size: 0.8rem; font-weight: 600; color: #86868b; text-transform: uppercase; letter-spacing: 0.5px;">Raumgröße</span>
                    <span class="slider-value-display" style="font-size: 1.5rem; font-weight: 600; color: #1d1d1f;">${currentSize} m²</span>
                  </div>
                  <div style="position: relative; margin-bottom: 1.5rem;">
                    <input type="range" class="premium-slider" data-room-size="${room.id}" min="10" max="100" step="5" value="${currentSize}" style="width: 100%; -webkit-appearance: none; background: #e5e5ea; height: 6px; border-radius: 3px; outline: none; margin: 0; cursor: pointer;">
                  </div>
                  
                  <div style="padding: 16px; background: #f5f5f7; border-radius: 16px; margin-bottom: 1.5rem; display: flex; flex-direction: column; gap: 8px;">
                    <div style="font-size: 0.95rem; color: #1d1d1f; display: flex; justify-content: space-between;">
                      <span style="font-weight: 500;">Errechnete Kühllast:</span>
                      <span class="calculated-load-${room.id}" style="font-weight: 600;">ca. ${loadKw.toFixed(1)} kW</span>
                    </div>
                    <div style="font-size: 0.85rem; color: #86868b; line-height: 1.4; border-top: 1px solid #e5e5ea; padding-top: 8px; margin-top: 4px;">
                      Empfohlene Leistungsklasse: <strong class="recommended-class-${room.id}" style="color: #1d1d1f;">${recommendedKw.toFixed(1)} kW</strong>
                    </div>
                  </div>

                  <button type="button" class="btn-confirm-size" data-confirm-size="${room.id}" style="width: 100%; background: #0071e3; color: white; border: none; padding: 14px 24px; border-radius: 20px; font-weight: 600; font-size: 0.95rem; cursor: pointer; transition: background 0.2s; text-align: center;">
                    Größe bestätigen
                  </button>
                </div>
              `;
          } else if (room.step === 2) {
            let targetKw = room.kw;
            let hasVariantForKw = (u) => {
              return u.variants.some(v => this.isMatchingKw(v, targetKw));
            };
            let brandFilter = this.state.globalBrand;
            if (!brandFilter && this.state.rooms.length > 0 && this.state.rooms[0].modelId && room.id !== this.state.rooms[0].id) {
                let firstRoomModel = this.data.indoor_units.find(u => u.id === this.state.rooms[0].modelId);
                if (firstRoomModel && firstRoomModel.brand) {
                    brandFilter = firstRoomModel.brand;
                }
            }
            let validModelsForKw = this.data.indoor_units.filter(u => {
              let brandMatches = brandFilter ? (u.brand || '').toUpperCase() === brandFilter.toUpperCase() : true;
              return brandMatches && this.isModelValidForRoom(u, room, this.state.rooms.length) && hasVariantForKw(u);
            });

            if (this.state.softLautstaerke || this.state.softTechnik || this.state.softDesign) {
              validModelsForKw = [...validModelsForKw].sort((a, b) => {
                let scoreA = 0;
                let scoreB = 0;
                if (this.state.softLautstaerke) {
                  scoreA += parseInt(this.state.softLautstaerke) * (a.rating_lautstaerke || 3);
                  scoreB += parseInt(this.state.softLautstaerke) * (b.rating_lautstaerke || 3);
                }
                if (this.state.softTechnik) {
                  scoreA += parseInt(this.state.softTechnik) * (a.rating_technik || 3);
                  scoreB += parseInt(this.state.softTechnik) * (b.rating_technik || 3);
                }
                if (this.state.softDesign) {
                  scoreA += parseInt(this.state.softDesign) * (a.rating_design || 3);
                  scoreB += parseInt(this.state.softDesign) * (b.rating_design || 3);
                }
                if (scoreB !== scoreA) {
                  return scoreB - scoreA;
                }
                return 0;
              });
            }

            let minPriceOverall = Infinity;
            let modelPrices = new Map();

            validModelsForKw.forEach(u => {
              let variantsForKw = u.variants.filter(v => this.isMatchingKw(v, targetKw));
              if (variantsForKw.length > 0) {
                let minPriceForModel = Math.min(...variantsForKw.map(v => v.price));
                modelPrices.set(u.id, minPriceForModel);
                if (minPriceForModel < minPriceOverall) {
                  minPriceOverall = minPriceForModel;
                }
              }
            });

            let modelCardsHtml = validModelsForKw.map(u => {
              let skus = u.variants.filter(v => this.isMatchingKw(v, targetKw)).map(v => v.sku).filter(Boolean);
              
              let customSubtitle = "";
              let utitle = u.title.toLowerCase();
              if (utitle.includes('comfora')) {
                customSubtitle = "Kompakt & Preiswert";
              } else if (utitle.includes('perfera')) {
                customSubtitle = "Der smarte Allrounder";
              } else if (utitle.includes('stylish')) {
                customSubtitle = "Premium & extrem flach";
              } else if (utitle.includes('emura')) {
                customSubtitle = "Preisgekröntes Design";
              } else if (utitle.includes('sensira')) {
                customSubtitle = "Preis-Leistungs-Sieger";
              } else {
                let uniqueBaseSkus = [...new Set(skus.map(s => this.getSeriesBaseSku(s)))].filter(Boolean);
                customSubtitle = uniqueBaseSkus.join(' / ');
              }
              let subtitleDisplay = customSubtitle ? `<span class="step-option-sku-sub" style="color:#0071e3; font-weight:500;">${customSubtitle}</span>` : '';
              let imageUrl = u.image || '';

              let modelBasePrice = modelPrices.get(u.id);
              let priceDisplayHtml = '';
              
              // Detect sale/discount for the active variant in this room size
              let activeVariants = u.variants.filter(v => this.isMatchingKw(v, targetKw));
              let isOnSale = false;
              let saleBadgeText = '';
              let savingsText = '';
              
              if (activeVariants.length > 0) {
                let activeVariant = activeVariants[0];
                let priceNum = parseFloat(activeVariant.price);
                let compareAtPriceNum = parseFloat(activeVariant.compare_at_price);
                if (compareAtPriceNum && compareAtPriceNum > priceNum) {
                  isOnSale = true;
                  let discountPercent = Math.round(((compareAtPriceNum - priceNum) / compareAtPriceNum) * 100);
                  saleBadgeText = `-${discountPercent}%`;
                  let savings = compareAtPriceNum - priceNum;
                  savingsText = `<span class="configurator-savings" style="display:block; font-size:11px; font-weight:600; color:#e1251b; margin-top:2px;">Aktion: ${this.formatMoney(savings)} sparen!</span>`;
                }
              }

              if (modelBasePrice !== undefined && minPriceOverall !== Infinity) {
                let diff = modelBasePrice - minPriceOverall;
                if (diff <= 0) {
                  priceDisplayHtml = `<span style="display:block; margin-top:6px; font-size:12px; font-weight:600; color:${isOnSale ? '#e1251b' : '#86868b'};">Ohne Aufpreis</span>`;
                } else {
                  priceDisplayHtml = `<span style="display:block; margin-top:6px; font-size:12px; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(diff)}</span>`;
                }
                if (savingsText) {
                  priceDisplayHtml += savingsText;
                }
              }

              let badgeHtml = '';
              let saleBadgeHtml = '';
              if (isOnSale) {
                saleBadgeHtml = `<div class="klimondo-badge sale" style="position: absolute; top: 8px; left: 8px; background: #e1251b; color: #ffffff; font-size: 10px; font-weight: 700; padding: 4px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.5px; z-index: 1; box-shadow: 0 2px 4px rgba(225, 37, 27, 0.2);">Aktion ${saleBadgeText}</div>`;
              }
              if (u.title.toLowerCase().includes('perfera')) {
                badgeHtml = '<div class="klimondo-badge bestseller" style="position: absolute; top: 8px; right: 8px; background: #ffecd1; color: #d97706; font-size: 10px; font-weight: 600; padding: 4px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.5px; z-index: 1;">Bestseller</div>';
              } else if (u.title.toLowerCase().includes('emura')) {
                badgeHtml = '<div class="klimondo-badge design" style="position: absolute; top: 8px; right: 8px; background: #f3e8ff; color: #7e22ce; font-size: 10px; font-weight: 600; padding: 4px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.5px; z-index: 1;">Designliebhaber</div>';
              }

              return `
                <div class="step-option-card series-card" data-select-model="${u.id}" data-room-id="${room.id}" style="position: relative;">
                  ${badgeHtml}
                  ${saleBadgeHtml}
                  <img src="${imageUrl}" alt="${u.title}">
                  <span>${u.title}</span>
                  ${subtitleDisplay}
                  ${priceDisplayHtml}
                </div>
              `;
            }).join('');

            htmlBody = `
              <div class="room-options-grid">
                ${modelCardsHtml}
              </div>
            `;
          } else if (room.step === 3) {
            let targetKw = room.kw;
            let candidates = model.variants.filter(v => this.isMatchingKw(v, targetKw));
            if (candidates.length === 0) {
              candidates = model.variants;
            }

            let seenColors = new Set();
            let uniqueColorVariants = [];
            candidates.forEach(v => {
              let colorName = (colorOptionIndex !== -1 && v.options && v.options[colorOptionIndex]) ? v.options[colorOptionIndex] : 'Standard';
              
              let normName = colorName.toLowerCase().trim();
              if (normName.includes('silber') || normName.includes('silver')) normName = 'silber';
              if (normName.includes('schwarz') || normName.includes('black')) normName = 'schwarz';
              if (normName.includes('weiß') || normName.includes('weiss') || normName.includes('white')) normName = 'weiß';
              if (normName.includes('grau') || normName.includes('grey') || normName.includes('anthrazit') || normName.includes('titan')) normName = 'grau';
              if (normName.includes('gold') || normName.includes('champagner')) normName = 'gold';

              if (!seenColors.has(normName)) {
                seenColors.add(normName);
                uniqueColorVariants.push({ variant: v, colorName: colorName });
              }
            });

            let swatchesHtml = uniqueColorVariants.map(item => {
              let colorName = item.colorName;
              let v = item.variant;
              const getColorHex = (name) => {
                const n = name.toLowerCase().trim();
                if (n.includes('schwarz') || n.includes('black')) return '#1d1d1f';
                if (n.includes('silber') || n.includes('silver')) return '#d2d2d7';
                if (n.includes('grau') || n.includes('grey') || n.includes('anthrazit') || n.includes('titan')) return '#8e8e93';
                if (n.includes('weiß') || n.includes('weiss') || n.includes('white')) return '#f5f5f7';
                if (n.includes('gold') || n.includes('champagner')) return '#e5c158';
                return '#e5e5ea';
              };
              let hexColor = getColorHex(colorName);
              let isSelected = colorName === room.selectedColor;
              return `
                <button type="button" class="color-swatch-circle ${isSelected ? 'is-selected' : ''}" 
                  style="width: 40px; height: 40px; border-radius: 50%; cursor: pointer; border: 1px solid rgba(0,0,0,0.15); transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1); background: ${hexColor}; padding: 0; position: relative;"
                  data-select-color="${colorName}" data-room-id="${room.id}"
                  title="${colorName}">
                </button>
              `;
            }).join('');

            htmlBody = `
              <div>
                <div style="margin-bottom: 12px; font-size: 0.95rem; font-weight: 500; color: #86868b;">
                  Farbe: <strong style="color: #1d1d1f;">${room.selectedColor || 'Bitte wählen...'}</strong>
                </div>
                <div style="display: flex; gap: 16px; margin-top: 8px;">
                  ${swatchesHtml}
                </div>
              </div>
            `;
          } else if (room.step === 4) {
            if (variant) {
              htmlBody = `
                <div class="indoor-unit-option selected" style="display: flex; align-items: center; gap: 12px; background: #ffffff; border: 1px solid #d2d2d7; border-radius: 12px; padding: 16px; margin-bottom: 0;">
                  ${variant.image ? `<img src="${variant.image}" style="width: 50px; height: 50px; object-fit: contain; border-radius: 6px; background: #fff;">` : `<div style="width: 50px; height: 50px; background: #e5e5ea; border-radius: 6px;"></div>`}
                  <div class="indoor-unit-info" style="flex: 1; text-align: left;">
                    <span class="indoor-unit-title" style="font-weight: 600; display: block; color: #1d1d1f;">${model.brand} ${model.title} - ${variant.title}</span>
                    <span class="indoor-unit-sku-sub" style="display: block; font-size: 11px; color: #86868b; margin-top: 2px; text-transform: uppercase;">${variant.sku || ''}</span>
                  </div>
                  <div style="font-weight: 600; color: #1d1d1f;">
                    ${this.formatMoney(variant.price)}
                  </div>
                </div>
              `;
            }
          }

          let roomNameInputHtml = '';
          if (isExpanded) {
            roomNameInputHtml = `
              <div style="margin-bottom: 1.25rem;">
                <label style="display: block; font-size: 0.75rem; font-weight: 600; color: #86868b; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px;">Raumname</label>
                <input type="text" class="room-name-input" data-room-name="${room.id}" value="${room.customName || ''}" placeholder="z.B. Wohnzimmer" style="width:100%; padding: 10px 14px; border-radius: 8px; border: 1px solid #d2d2d7; font-size: 0.9rem; outline: none; background-color: #f5f5f7; color: #1d1d1f; box-sizing: border-box;">
              </div>
            `;
          }

          let html = `
            <div class="room-card ${isExpanded ? 'is-expanded' : 'is-collapsed'}">
              <div class="room-card-header" data-toggle="${room.id}" tabindex="0" role="button" aria-expanded="${isExpanded}">
                <div class="room-header-title-group">
                  <h3 class="room-title">${titleText}</h3>
                  <p class="room-card-subtitle">${cardSubtitle}</p>
                </div>
                <div class="room-header-meta">
                  <span class="room-card-price">${variant ? this.formatMoney(variant.price) : '0,00 €'}</span>
                  ${index > 0 ? `<button type="button" class="btn-remove-room" data-remove="${room.id}">✕</button>` : ''}
                  <svg class="room-toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              
              <div class="room-card-body">
                ${roomNameInputHtml}
                ${tagsHtml ? `<div class="room-tags" style="margin-bottom: 16px;">${tagsHtml}</div>` : ''}
                ${htmlBody}
              </div>
            </div>
          `;
          this.roomsContainer.insertAdjacentHTML('beforeend', html);
        });

        let hasSensira = this.state.rooms.some(r => {
          if (r.modelId) {
            let model = this.data.indoor_units.find(u => u.id === r.modelId);
            return model && (model.title || "").toLowerCase().includes('sensira');
          }
          return false;
        });

        let warningEl = this.querySelector('#AddRoomWarning');
        if (hasSensira) {
          if (!warningEl) {
            warningEl = document.createElement('div');
            warningEl.id = 'AddRoomWarning';
            warningEl.className = 'add-room-warning-box';
            warningEl.style.cssText = 'background: #fff3cd; border: 1px solid #ffeeba; color: #856404; padding: 16px 20px; border-radius: 16px; margin-bottom: 16px; font-size: 0.9rem; line-height: 1.4; text-align: left; box-shadow: 0 4px 12px rgba(0,0,0,0.02); transition: all 0.3s ease; box-sizing: border-box; width: 100%;';
            this.addRoomBtn.parentNode.insertBefore(warningEl, this.addRoomBtn);
          }
          warningEl.innerHTML = `
            <div style="display: flex; gap: 12px; align-items: flex-start;">
              <span style="font-size: 1.25rem; line-height: 1; margin-top: 1px;">⚠️</span>
              <div>
                <strong style="display: block; margin-bottom: 4px; color: #856404; font-weight: 600;">Daikin Sensira ist ein Single-Split Gerät</strong>
                Die Sensira kann nur für eine 1-Raum-Lösung (Single-Split) verwendet werden und unterstützt keine Mehrraum-Außengeräte. Bitte wechseln Sie das Gerät im ersten Raum auf die <strong>Daikin Comfora</strong> (oder ein anderes Modell), um weitere Räume hinzuzufügen.
              </div>
            </div>
          `;
          warningEl.style.display = 'block';
        } else {
          if (warningEl) {
            warningEl.style.display = 'none';
          }
        }

        this.addRoomBtn.style.display = this.state.rooms.length >= 5 ? 'none' : 'flex';

        // 2. Render Outdoor Match

        if (this.state.matchedOutdoorVariant) {
            let o = this.state.matchedOutdoorVariant;
            this.matchResultEl.style.display = 'block';
            
            let html = '';
            let cleanVariantTitle = o.variant.title.replace(/Leistungsklasse:\s*/i, '').trim();
            if (!this.state.outdoorExpanded) {
                html = `
                  <div class="klimondo-summary-card">
                     <div class="asc-top">
                        <div class="asc-title-group">
                           <h3>Außengerät. <span class="step-title-grey">Ausgewähltes Modell</span></h3>
                        </div>
                        <button type="button" class="asc-btn" id="BtnEditOutdoor" style="background:none; border:none; color:#0071e3; cursor:pointer; font-weight:600; font-size:0.9rem; display:flex; align-items:center; gap:4px; padding:0;">Ändern <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></button>
                     </div>
                     <p class="asc-desc" style="margin-top:4px; margin-bottom:16px;">Für deine Räume passendes Außengerät.</p>
                     
                     <div class="outdoor-current" style="display:flex; gap:16px; background:#ffffff; border:1px solid #d2d2d7; padding:16px 20px; border-radius:16px; align-items:center; justify-content:space-between; box-sizing:border-box; width:100%;">
                        <div style="display:flex; align-items:center; gap:16px; flex:1;">
                           ${o.image ? `<img src="${o.image}" style="width:50px; height:50px; object-fit:contain; mix-blend-mode:multiply; border-radius:8px; flex-shrink:0;">` : `<div style="width:50px; height:50px; background:#e5e5ea; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#86868b" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect></svg></div>`}
                           <div style="flex:1; text-align:left; display:flex; flex-direction:column; gap:2px;">
                              <strong style="display:block; font-size:0.95rem; font-weight:600; color:#1d1d1f; line-height:1.25;">${o.title} - ${o.variant.title.replace(/Leistungsklasse:\s*/i, '').trim()}</strong>
                              <span style="font-size:0.8rem; color:#86868b;">${o.variant.sku || ''}</span>
                           </div>
                        </div>
                        <div style="font-weight:600; font-size:0.95rem; color:#1d1d1f; margin-left:12px; white-space:nowrap; flex-shrink:0;">
                           ${this.formatMoney(o.variant.price)}
                        </div>
                     </div>
                  </div>
                `;
            } else {
                html = `
                  <div class="klimondo-summary-card">
                     <div class="asc-top">
                        <div class="asc-title-group">
                           <h3>Außengerät. <span class="step-title-grey">Auswählen</span></h3>
                        </div>
                        <button type="button" class="asc-btn" id="BtnCloseOutdoor" style="background:none; border:none; color:#0071e3; cursor:pointer; font-weight:600; font-size:0.9rem; display:flex; align-items:center; gap:4px; padding:0;">Schließen <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg></button>
                     </div>
                     <p class="asc-desc" style="margin-top:4px; margin-bottom:16px;">Hier sind alle Geräte, die für deine Konfiguration ausreichen.</p>
                     <div class="montage-list">
                `;
                
                let baseCand = this.state.validOutdoorCandidates[0];
                let mehrLeistungCand = this.state.validOutdoorCandidates.find(c => c.variant.maxSlots === baseCand.variant.maxSlots && c.variant.maxKw > baseCand.variant.maxKw);
                let reserveAnsCand = this.state.validOutdoorCandidates.find(c => c.variant.maxSlots === baseCand.variant.maxSlots + 1 && c.variant.maxKw >= baseCand.variant.maxKw);

                this.state.validOutdoorCandidates.forEach(cand => {
                    let isSelected = cand.variant.id === this.state.manualOutdoorVariantId || (!this.state.manualOutdoorVariantId && cand.variant.id === this.state.matchedOutdoorVariant.variant.id);
                    let candImage = cand.image || '';
                    let cleanCandVariantTitle = cand.variant.title.replace(/Leistungsklasse:\s*/i, '').trim();
                    
                    let badgeHtml = '';
                    if (mehrLeistungCand && cand.variant.id === mehrLeistungCand.variant.id) {
                        badgeHtml = '<div class="klimondo-badge upsell-leistung" style="position: absolute; top: 8px; right: 8px; background: #e0f2fe; color: #0284c7; font-size: 10px; font-weight: 600; padding: 4px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.5px; z-index: 1;">Mehr Leistung</div>';
                    } else if (reserveAnsCand && cand.variant.id === reserveAnsCand.variant.id) {
                        badgeHtml = '<div class="klimondo-badge upsell-reserve" style="position: absolute; top: 8px; right: 8px; background: #fce7f3; color: #db2777; font-size: 10px; font-weight: 600; padding: 4px 8px; border-radius: 12px; text-transform: uppercase; letter-spacing: 0.5px; z-index: 1;">Reserveanschluss</div>';
                    }

                    html += `
                        <button type="button" class="outdoor-card ${isSelected ? 'is-selected' : ''}" data-outdoor-variant-id="${cand.variant.id}" style="margin-bottom:12px; display:flex; align-items:center; gap:12px; background:#ffffff; border:1px solid ${isSelected ? '#0071e3' : '#d2d2d7'}; border-radius:12px; padding:12px; cursor:pointer; position:relative;" aria-pressed="${isSelected}">
                            ${badgeHtml}
                            <div class="outdoor-radio" style="width:16px; height:16px; border-radius:50%; border:2px solid ${isSelected ? '#0071e3' : '#cbd5e1'}; background:${isSelected ? '#0071e3' : '#fff'}; display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:3px;">
                              ${isSelected ? '<div style="width:6px; height:6px; border-radius:50%; background:#fff;"></div>' : ''}
                            </div>
                            ${candImage ? `<img src="${candImage}" style="width:50px; height:50px; object-fit:contain; mix-blend-mode:multiply; border-radius:8px;">` : `<div style="width:50px; height:50px; background:#e5e5ea; border-radius:8px; display:flex; align-items:center; justify-content:center;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#86868b" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect></svg></div>`}
                            <div style="flex:1; text-align:left;">
                               <strong style="display:block; font-size:0.95rem; font-weight:600; color:#1d1d1f;">${cand.title} - ${cleanCandVariantTitle}</strong>
                               <span style="font-size:0.8rem; color:#86868b;">${cand.variant.sku || ''}</span>
                            </div>
                            <div style="font-weight:600; font-size:0.95rem; color:#1d1d1f; margin-left:12px;">
                               ${this.formatMoney(cand.variant.price)}
                            </div>
                        </button>
                    `;
                });
                
                html += `</div></div>`;
            }
            
            this.matchResultEl.innerHTML = html;
        } else {
            this.matchResultEl.style.display = 'block';
            this.matchResultEl.innerHTML = `
                <div class="error-card">
                    <h4>⚠️ Leistungsgrenze erreicht</h4>
                    <p>Für diese Kombination gibt es kein passendes Außengerät. Bitte reduziere die Räume oder teile das Projekt in zwei Anlagen.</p>
                </div>
            `;
        }

        // 2.5 Render Accessories
        let accessories = this.getAccessories();
        if (accessories && accessories.length > 0 && this.state.matchedOutdoorVariant) {
            this.accessoriesContainer.style.display = 'block';

            // Cleanup selected accessories based on active rooms and capacities
            if (this.state.selectedAccessories.length > 0) {
              let needs6mm = this.state.rooms.length > 0;
              let needs10mm = this.state.rooms.some(r => r.kw < 5.0);
              let needs12mm = this.state.rooms.some(r => r.kw >= 5.0);
              
              this.state.selectedAccessories = this.state.selectedAccessories.filter(accId => {
                let acc = accessories.find(a => a.id === accId);
                if (!acc) return true;
                let title = (acc.title || '').toLowerCase().replace(/\s+/g, '');
                if (title.includes('kupferrohr') || title.includes('rohr')) {
                  if (title.includes('6mm') && !needs6mm) return false;
                  if (title.includes('10mm') && !needs10mm) return false;
                  if (title.includes('12mm') && !needs12mm) return false;
                  if (title.includes('13mm') && !needs12mm) return false;
                }
                return true;
              });
            }
            
            let accHtml = `
              <div class="accessories-header" style="margin-bottom: 16px;">
                <h3>Zubehör. <span class="step-title-grey">Wähle optionales Zubehör.</span></h3>
              </div>
              <div class="accessories-list">
            `;

            let installationItems = accessories.filter(acc => this.isInstallationMaterial(acc));
            let normalAccessories = accessories.filter(acc => !this.isInstallationMaterial(acc));
            
            normalAccessories.forEach(acc => {
                let isSelected = this.state.selectedAccessories.includes(acc.id);
                let isCover = (acc.handle === 'abdeckung-aussengerat') || (acc.title && acc.title.toLowerCase().includes('abdeckung')) || acc.id === 16338514444633;
                let variant = acc.variants[0];

                 if (isCover) {
                   let outdoorDim = this.state.matchedOutdoorVariant ? (this.state.matchedOutdoorVariant.variant.dim || this.resolveOutdoorDimensions(this.state.matchedOutdoorVariant.variant.sku, this.state.matchedOutdoorVariant.title + ' ' + this.state.matchedOutdoorVariant.variant.title)) : null;
                   let matchingSize = this.state.coverSizeOverride || this.getMatchingCoverSize(outdoorDim, this.state.rooms.length);
                   let matchedVariant = this.getCoverVariant(acc, matchingSize, this.state.coverColor);
                   if (matchedVariant) {
                     let smallVariant = this.getCoverVariant(acc, 'Small', this.state.coverColor);
                     let mediumVariant = this.getCoverVariant(acc, 'Medium', this.state.coverColor);
                     let largeVariant = this.getCoverVariant(acc, 'Large', this.state.coverColor);
                     let xlVariant = this.getCoverVariant(acc, 'X-Large', this.state.coverColor);

                     let sizeLabel = 'Größe M';
                     if (matchingSize === 'Small') { sizeLabel = 'Größe S'; }
                     else if (matchingSize === 'Medium') { sizeLabel = 'Größe M'; }
                     else if (matchingSize === 'Large') { sizeLabel = 'Größe L'; }
                     else if (matchingSize === 'X-Large') { sizeLabel = 'Größe XL'; }

                     let sizeOptionsHtml = '';
                     if (this.state.showCoverSizeOptions) {
                       sizeOptionsHtml = `
                         <div class="cover-size-selector-grid" style="display:grid; grid-template-columns:1fr; gap:8px; margin-top:12px; width:100%;">
                             <div class="step-option-card size-card-stacked ${matchingSize === 'Small' ? 'is-selected' : ''}" data-cover-size-select="Small" role="button" style="padding:10px 14px; border:1px solid ${matchingSize === 'Small' ? '#0071e3' : '#d2d2d7'}; border-radius:8px; cursor:pointer; background:#fff; display:flex; justify-content:space-between; align-items:center; box-shadow:none;">
                                 <div style="text-align:left;">
                                     <strong style="font-size:0.85rem; color:#1d1d1f; display:block;">Größe S</strong>
                                     <span style="font-size:0.75rem; color:#86868b;">H 68 x B 90 x T 45-60 cm</span>
                                 </div>
                                 <span style="font-size:0.85rem; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(smallVariant ? smallVariant.price : 0)}</span>
                             </div>
                             <div class="step-option-card size-card-stacked ${matchingSize === 'Medium' ? 'is-selected' : ''}" data-cover-size-select="Medium" role="button" style="padding:10px 14px; border:1px solid ${matchingSize === 'Medium' ? '#0071e3' : '#d2d2d7'}; border-radius:8px; cursor:pointer; background:#fff; display:flex; justify-content:space-between; align-items:center; box-shadow:none;">
                                 <div style="text-align:left;">
                                     <strong style="font-size:0.85rem; color:#1d1d1f; display:block;">Größe M</strong>
                                     <span style="font-size:0.75rem; color:#86868b;">H 83,5 x B 105 x T 51-66 cm</span>
                                 </div>
                                 <span style="font-size:0.85rem; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(mediumVariant ? mediumVariant.price : 0)}</span>
                             </div>
                             <div class="step-option-card size-card-stacked ${matchingSize === 'Large' ? 'is-selected' : ''}" data-cover-size-select="Large" role="button" style="padding:10px 14px; border:1px solid ${matchingSize === 'Large' ? '#0071e3' : '#d2d2d7'}; border-radius:8px; cursor:pointer; background:#fff; display:flex; justify-content:space-between; align-items:center; box-shadow:none;">
                                 <div style="text-align:left;">
                                     <strong style="font-size:0.85rem; color:#1d1d1f; display:block;">Größe L</strong>
                                     <span style="font-size:0.75rem; color:#86868b;">H 95 x B 110 x T 55-70 cm</span>
                                 </div>
                                 <span style="font-size:0.85rem; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(largeVariant ? largeVariant.price : 0)}</span>
                             </div>
                             <div class="step-option-card size-card-stacked ${matchingSize === 'X-Large' ? 'is-selected' : ''}" data-cover-size-select="X-Large" role="button" style="padding:10px 14px; border:1px solid ${matchingSize === 'X-Large' ? '#0071e3' : '#d2d2d7'}; border-radius:8px; cursor:pointer; background:#fff; display:flex; justify-content:space-between; align-items:center; box-shadow:none;">
                                 <div style="text-align:left;">
                                     <strong style="font-size:0.85rem; color:#1d1d1f; display:block;">Größe XL</strong>
                                     <span style="font-size:0.75rem; color:#86868b;">H 120 x B 131 x T 65-80 cm</span>
                                 </div>
                                 <span style="font-size:0.85rem; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(xlVariant ? xlVariant.price : 0)}</span>
                             </div>
                         </div>
                       `;
                     }

                     accHtml += `
                       <div class="accessory-card ${isSelected ? 'is-selected' : ''}" data-acc-id="${acc.id}" role="button" tabindex="0" aria-pressed="${isSelected}" style="display:flex; flex-direction:column; align-items:flex-start; gap:12px; padding:16px 20px !important;">
                           <div style="display:flex; justify-content:space-between; align-items:center; width:100%;">
                               <span class="accessory-left" style="display:flex; align-items:center; gap:12px;">
                                   <span class="acc-checkbox">
                                       ${isSelected ? '<svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>' : ''}
                                   </span>
                                   <span class="acc-info" style="display:flex; flex-direction:column; text-align:left;">
                                       <strong style="display:flex; align-items:center; gap:8px;">
                                         <span>${acc.title} (${sizeLabel})</span>
                                         <button type="button" class="btn-change-cover-size" data-toggle-cover-sizes style="background:none; border:none; color:#0071e3; cursor:pointer; font-size:0.8rem; padding:0; text-decoration:underline; font-weight:500; margin-left:8px;">Ändern</button>
                                       </strong>
                                       <div class="cover-color-swatches" style="display: flex; gap: 8px; margin-top: 8px;">
                                           <button type="button" class="color-swatch-circle ${this.state.coverColor === 'Weiß' ? 'is-selected' : ''}" style="width: 24px; height: 24px; border-radius: 50%; cursor: pointer; border: 1px solid rgba(0,0,0,0.15); background: #f5f5f7; padding: 0; position: relative;" data-cover-color="Weiß" title="Weiß"></button>
                                           <button type="button" class="color-swatch-circle ${this.state.coverColor === 'Anthrazit' ? 'is-selected' : ''}" style="width: 24px; height: 24px; border-radius: 50%; cursor: pointer; border: 1px solid rgba(0,0,0,0.15); background: #3b3b3b; padding: 0; position: relative;" data-cover-color="Anthrazit" title="Anthrazit"></button>
                                       </div>
                                   </span>
                               </span>
                               <span class="accessory-right" style="display:flex; align-items:center; gap:8px;">
                                   <span class="acc-price">+ ${this.formatMoney(matchedVariant.price)}</span>
                               </span>
                           </div>
                           ${sizeOptionsHtml}
                       </div>
                     `;
                     return;
                   }
                 }

                if(variant) {
                  let isPump = acc.title.toLowerCase().includes('pumpe') || acc.title.toLowerCase().includes('pump');
                  let qty = this.state.selectedAccessories.filter(id => id === acc.id).length;
                  if (isSelected && qty === 0) {
                    qty = 1;
                  }
                  
                  let qtyControlHtml = '';
                  if (isPump && isSelected && this.state.rooms.length > 1) {
                    qtyControlHtml = `
                      <div class="quantity-selector-wrapper" style="display:flex; align-items:center; gap:8px; z-index:10; margin-right: 12px;">
                        <button type="button" class="qty-btn-minus" data-qty-minus="${acc.id}" style="width:28px; height:28px; border-radius:50%; border:1px solid #d2d2d7; background:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; font-weight:600; font-size:1.1rem; color:#1d1d1f; padding:0; line-height:1;">-</button>
                        <span class="qty-display" style="font-weight:600; font-size:0.95rem; width:auto; min-width:32px; text-align:center; color:#1d1d1f;">${qty} Stk.</span>
                        <button type="button" class="qty-btn-plus" data-qty-plus="${acc.id}" style="width:28px; height:28px; border-radius:50%; border:1px solid #d2d2d7; background:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; font-weight:600; font-size:1.1rem; color:#1d1d1f; padding:0; line-height:1;">+</button>
                      </div>
                    `;
                  }

                  accHtml += `
                    <div class="accessory-card ${isSelected ? 'is-selected' : ''}" data-acc-id="${acc.id}" role="button" tabindex="0" aria-pressed="${isSelected}">
                        <span class="accessory-left" style="display:flex; align-items:center; gap:12px;">
                            <span class="acc-checkbox">
                                ${isSelected ? '<svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>' : ''}
                            </span>
                            <span class="acc-info">
                                <strong>${acc.title}</strong>
                            </span>
                        </span>
                        <span class="accessory-right" style="display:flex; align-items:center; gap:8px;">
                            ${qtyControlHtml}
                            <span class="acc-price">+ ${this.formatMoney(isSelected ? parseFloat(variant.price) * qty : parseFloat(variant.price))}</span>
                        </span>
                    </div>
                  `;
                }
            });

            // Group Installationsmaterial
            if (installationItems.length > 0) {
              // Sort alphabetically (natural sort)
              installationItems.sort((a, b) => {
                const titleA = (a.title || '').toLowerCase();
                const titleB = (b.title || '').toLowerCase();
                return titleA.localeCompare(titleB, 'de', { numeric: true });
              });

              let isGroupSelected = installationItems.some(item => this.state.selectedAccessories.includes(item.id));
              let groupTotalPrice = 0;
              installationItems.forEach(item => {
                let qty = this.state.selectedAccessories.filter(id => id === item.id).length;
                if (qty > 0 && item.variants.length > 0) {
                  groupTotalPrice += parseFloat(item.variants[0].price) * qty;
                }
              });

              let installOptionsHtml = '';
              if (this.state.showInstallationOptions) {
                installOptionsHtml = `
                  <div class="install-options-selector-grid" style="display:grid; grid-template-columns:1fr; gap:10px; margin-top:12px; width:100%; border-top:1px solid #e5e5ea; padding-top:12px;">
                `;

                installationItems.forEach(item => {
                  let isItemSel = this.state.selectedAccessories.includes(item.id);
                  let qty = this.state.selectedAccessories.filter(id => id === item.id).length;
                  if (isItemSel && qty === 0) qty = 1;
                  let variant = item.variants[0];
                  if (!variant) return;

                  // Filter out copper pipes that are not needed
                  const title = (item.title || '').toLowerCase().replace(/\s+/g, '');
                  if (title.includes('kupferrohr') || title.includes('rohr')) {
                    if (title.includes('6mm')) {
                      if (this.state.rooms.length === 0) return;
                    } else if (title.includes('10mm')) {
                      let needs10mm = this.state.rooms.some(r => r.kw < 5.0);
                      if (!needs10mm) return;
                    } else if (title.includes('12mm') || title.includes('13mm') || item.handle.includes('13mm')) {
                      let needs12mm = this.state.rooms.some(r => r.kw >= 5.0);
                      if (!needs12mm) return;
                    }
                  }

                  let minQty = this.getAccessoryMinQty(item);
                  if (isItemSel && qty < minQty) {
                    // Update state directly without triggering another render
                    this.state.selectedAccessories = this.state.selectedAccessories.filter(id => id !== item.id);
                    for (let i = 0; i < minQty; i++) {
                      this.state.selectedAccessories.push(item.id);
                    }
                    this.saveState();
                    qty = minQty;
                  }

                  let unit = this.getAccessoryUnit(item);
                  let displayQty = qty;
                  let displayUnit = unit;



                  let qtyControlHtml = '';
                  if (isItemSel) {
                    qtyControlHtml = `
                      <div class="quantity-selector-wrapper" style="display:flex; align-items:center; gap:8px; z-index:10;">
                        <button type="button" class="qty-btn-minus" data-qty-minus="${item.id}" style="width:24px; height:24px; border-radius:50%; border:1px solid #d2d2d7; background:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; font-weight:600; font-size:1rem; color:#1d1d1f; padding:0; line-height:1;">-</button>
                        <span class="qty-display" style="font-weight:600; font-size:0.85rem; width:45px; text-align:center; color:#1d1d1f;">${displayQty} ${displayUnit}</span>
                        <button type="button" class="qty-btn-plus" data-qty-plus="${item.id}" style="width:24px; height:24px; border-radius:50%; border:1px solid #d2d2d7; background:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; font-weight:600; font-size:1rem; color:#1d1d1f; padding:0; line-height:1;">+</button>
                      </div>
                    `;
                  }

                  installOptionsHtml += `
                    <div class="install-sub-card ${isItemSel ? 'is-selected' : ''}" data-install-sub-acc-id="${item.id}" role="button" style="padding:10px 14px; border:1px solid ${isItemSel ? '#0071e3' : '#d2d2d7'}; border-radius:8px; cursor:pointer; background:#fff; display:flex; justify-content:space-between; align-items:center; box-shadow:none; box-sizing:border-box; width:100%;">
                        <div style="display:flex; align-items:center; gap:8px; text-align:left;">
                            <span class="acc-checkbox" style="width:16px; height:16px; border:1px solid ${isItemSel ? '#0071e3' : '#d2d2d7'}; border-radius:4px; display:inline-flex; align-items:center; justify-content:center; background:${isItemSel ? '#0071e3' : 'transparent'}; color:#fff; flex-shrink:0;">
                                ${isItemSel ? '<svg width="10" height="10" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>' : ''}
                            </span>
                            <span style="font-size:0.85rem; color:#1d1d1f; font-weight:500;">${item.title}</span>
                        </div>
                        <div style="display:flex; align-items:center; gap:12px; flex-shrink:0;">
                            ${qtyControlHtml}
                            <span style="font-size:0.85rem; font-weight:600; color:#1d1d1f;">+ ${this.formatMoney(isItemSel ? parseFloat(variant.price) * qty : parseFloat(variant.price))}</span>
                        </div>
                    </div>
                  `;
                });

                installOptionsHtml += `
                  </div>
                `;
              }

              accHtml += `
                <div class="accessory-card ${isGroupSelected ? 'is-selected' : ''}" data-install-material-group role="button" tabindex="0" aria-pressed="${isGroupSelected}" style="display:flex; flex-direction:column; align-items:flex-start; gap:12px; padding:16px 20px !important;">
                    <div style="display:flex; justify-content:space-between; align-items:center; width:100%;">
                        <span class="accessory-left" style="display:flex; align-items:center; gap:12px;">
                            <span class="acc-checkbox">
                                ${isGroupSelected ? '<svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>' : ''}
                            </span>
                            <span class="acc-info" style="display:flex; flex-direction:column; text-align:left;">
                                <strong style="display:flex; align-items:center; gap:8px;">
                                    <span>Installationsmaterial</span>
                                    ${isGroupSelected ? '<button type="button" class="btn-change-install-material" data-toggle-install-material style="background:none; border:none; color:#0071e3; cursor:pointer; font-size:0.8rem; padding:0; text-decoration:underline; font-weight:500; margin-left:8px;">Ändern</button>' : ''}
                                </strong>
                                <span style="font-size:0.8rem; color:#86868b; margin-top:2px;">Kanal, Endstücke, Schläuche & Leitungen</span>
                            </span>
                        </span>
                        <span class="accessory-right" style="display:flex; align-items:center; gap:8px;">
                            <span class="acc-price">${groupTotalPrice > 0 ? '+ ' + this.formatMoney(groupTotalPrice) : ''}</span>
                        </span>
                    </div>
                    ${installOptionsHtml}
                </div>
              `;
            }
            
            accHtml += `</div>`;
            this.accessoriesContainer.innerHTML = accHtml;
        } else {
            this.accessoriesContainer.style.display = 'none';
        }

        // 3. Render Visual Overlay (SVG Isometric Engine)
        if (this.visualizer) {
            this.visualizer.render(this.state.rooms, this.state.matchedOutdoorVariant);
        } else if (this.useStaticImage) {
            // Update static image src based on the first room's color variant image
            const imgEl = this.querySelector('#StaticConfiguratorImage');
            if (imgEl) {
                let variantImg = null;
                if (this.state.rooms.length > 0 && this.state.rooms[0].variantId) {
                    const r = this.state.rooms[0];
                    const model = this.data.indoor_units.find(u => u.id === r.modelId);
                    const variant = model ? model.variants.find(v => v.id === r.variantId) : null;
                    if (variant && variant.image) {
                        variantImg = variant.image;
                    }
                }
                imgEl.src = variantImg || this.staticImageUrl || '';
            }
        }

        // 4.5 Render Montage
        this.renderMontage();

        // 4.6 Render Garantie
        this.renderGarantie();

        // 5. Calculate Total
        this.updateTotals();

        // 5.5 Render Technical Specs
        this.renderTechnicalSpecs();

        // 6. Render Scrollspy Navigation
        this.renderScrollspy();

        // 7. Enforce Visibility Rules based on globalStep (must be run last to override inline styles)
        if (step < 4) {
          if (this.roomsContainer) this.roomsContainer.style.display = 'none';
          if (this.addRoomBtn) this.addRoomBtn.style.display = 'none';
          let warningEl = this.querySelector('#AddRoomWarning');
          if (warningEl) warningEl.style.display = 'none';
          if (this.matchResultEl) this.matchResultEl.style.display = 'none';
          if (this.accessoriesContainer) this.accessoriesContainer.style.display = 'none';
          let montage = this.querySelector('#MontageContainer');
          if (montage) montage.style.display = 'none';
          let garantie = this.querySelector('#GarantieContainer');
          if (garantie) garantie.style.display = 'none';
          if (this.bottomSummaryCard) this.bottomSummaryCard.style.display = 'none';
          let scrollspy = this.querySelector('.configurator-scrollspy');
          if (scrollspy) scrollspy.style.display = 'none';
          
          let canvas = this.querySelector('#VisualizerCanvas');
          if (canvas) {
            let hotspots = canvas.querySelector('#HotspotsContainer');
            if (hotspots) hotspots.style.display = 'none';
          }
          let stickyHeader = this.querySelector('.klimondo-sticky-header');
          if (stickyHeader) stickyHeader.style.display = 'none';
        } else {
          if (this.roomsContainer) this.roomsContainer.style.display = 'block';
          
          let canvas = this.querySelector('#VisualizerCanvas');
          if (canvas) {
            let hotspots = canvas.querySelector('#HotspotsContainer');
            let overlay = canvas.querySelector('.focused-image-overlay');
            let isOverlayHidingHotspots = overlay && overlay.style.background !== 'transparent';
            if (hotspots && !isOverlayHidingHotspots) hotspots.style.display = 'block';
          }
          let stickyHeader = this.querySelector('.klimondo-sticky-header');
          if (stickyHeader) stickyHeader.style.display = 'block';
        }
      }

      renderMontage() {
        let container = this.querySelector('#MontageContainer');
        if (!container) return;
        
        if (this.state.rooms.length === 0 || !this.state.matchedOutdoorVariant) {
            container.style.display = 'none';
            return;
        }
        
        container.style.display = 'block';
        
        if (this.state.montageMeters === -1) {
            this.state.montageMeters = this.state.rooms.length * 5;
        }
        const minLfm = this.state.rooms.length * 3;
        if (this.state.montageMeters < minLfm) {
            this.state.montageMeters = minLfm;
        }
        const maxLfm = this.getMaxLfm(this.state.rooms.length);
        if (this.state.montageMeters > maxLfm) {
            this.state.montageMeters = maxLfm;
        }

        const options = [
           { id: 'keine', title: 'Gerätelieferung', desc: 'Wir liefern die Geräte. Die Installation übernimmst du selbst (mit zertifiziertem Fachbetrieb).' },
           { id: 'komplett', title: 'Komplettmontage', desc: 'Wir übernehmen alles. Montage, Leitungsverlegung und Inbetriebnahme.' },
           { id: 'anschluss', title: 'Anschluss & Inbetriebnahme', desc: 'Du verlegst die Leitungen selbst. Wir schließen alles an und nehmen die Anlage in Betrieb.' },
           { id: 'inbetriebnahme', title: 'Nur Inbetriebnahme', desc: 'Du montierst die Geräte und verlegst die Leitungen. Wir machen nur den finalen Check und die Inbetriebnahme.' }
        ];

        let selectedOpt = options.find(o => o.id === this.state.montageType) || options[0];
        let html = '';

        if (!this.state.montageExpanded) {
            let roomsCount = this.state.rooms.length;
            let optPrice = 0;
            if (this.state.montageType !== 'keine') {
              let vFirst = this.getMontageVariant(this.state.montageType, true);
              let vNext = this.getMontageVariant(this.state.montageType, false);
              let pFirst = vFirst ? vFirst.price : (this.state.montageType === 'komplett' ? 75000 : (this.state.montageType === 'anschluss' ? 70000 : 60000));
              let pNext = vNext ? vNext.price : (this.state.montageType === 'komplett' ? 30000 : (this.state.montageType === 'anschluss' ? 20000 : 15000));
              optPrice = pFirst + (roomsCount - 1) * pNext;
              
              if (this.state.montageType === 'komplett') {
                let vMeter = this.getMontageVariant('laufmeter', false);
                let pMeter = vMeter ? vMeter.price : 10000;
                optPrice += this.state.montageMeters * pMeter;
              }
            }
            const priceLabel = this.state.montageType === 'keine' ? 'Kostenlos' : `+ ${this.formatMoney(optPrice)}`;

            let montageDesc = 'Gerätelieferung ohne Montage';
            if (this.state.montageType === 'komplett') {
              montageDesc = `Komplettmontage (inkl. ${this.state.montageMeters}m Leitung) (${priceLabel})`;
            } else if (this.state.montageType === 'anschluss') {
              montageDesc = `Anschluss & Inbetriebnahme durch Fachpartner (${priceLabel})`;
            } else if (this.state.montageType === 'inbetriebnahme') {
              montageDesc = `Nur Inbetriebnahme durch Fachpartner (${priceLabel})`;
            }

            html = `
              <div class="klimondo-summary-card" style="padding:0 !important; margin:0 0 24px 0 !important; background:none !important; border:none !important; box-shadow:none !important;">
                 <div class="asc-top" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
                    <div class="asc-title-group" style="display:flex; align-items:center; font-weight:600; font-size:1.35rem; color:#1d1d1f;">
                       <strong>Montage & Service. <span style="color:#86868b; font-weight:500;">Deine gewählte Option.</span></strong>
                    </div>
                 </div>
                 <p class="asc-desc" style="font-size:0.85rem; color:#86868b; margin:0 0 8px 0;">Professionelle Montage und Inbetriebnahme durch zertifizierte Fachpartner.</p>
                 
                 <div class="klimondo-selected-summary-box" id="BtnEditMontage">
                    <div class="klimondo-summary-icon">
                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <div class="klimondo-summary-content">
                       <span class="klimondo-summary-title">${selectedOpt.title}</span>
                       <span class="klimondo-summary-desc">${montageDesc}</span>
                    </div>
                    <div class="klimondo-summary-action">
                       Ändern
                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                    </div>
                 </div>
                 
                 ${this.state.montageType !== 'keine' ? `
                   <div class="montage-plz-validator-box" style="background:#fff3cd; border: 1px solid #ffeeba; border-radius:12px; padding:16px; margin-top:12px;">
                     <label for="PlzInput" style="font-weight:600; font-size:0.9rem; color:#856404; display:block; margin-bottom:6px;">Postleitzahl für Montageprüfung:</label>
                     <div style="display:flex; gap:8px;">
                       <input type="text" id="PlzInput" value="${this.state.plz || ''}" placeholder="z.B. 1010" style="padding:8px 12px; border:1px solid #ced4da; border-radius:6px; flex:1; font-size:14px; box-sizing: border-box; width:100%;">
                     </div>
                     <div class="plz-local-feedback" style="margin-top: 8px;"></div>
                   </div>
                 ` : ''}
              </div>
            `;
        } else {
            html = `
              <div class="klimondo-summary-card" style="padding:0 !important; margin:0 0 24px 0 !important; background:none !important; border:none !important; box-shadow:none !important;">
                 <div class="asc-top" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
                    <div class="asc-title-group" style="display:flex; align-items:center; font-weight:600; font-size:1.35rem; color:#1d1d1f;">
                       <strong>Montage & Service. <span style="color:#86868b; font-weight:500;">Wähle die gewünschte Option.</span></strong>
                    </div>
                    <button type="button" class="asc-btn" id="BtnCloseMontage" style="background:none; border:none; color:#0071e3; cursor:pointer; font-weight:600; font-size:0.9rem; display:flex; align-items:center; gap:4px;">Schließen <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg></button>
                 </div>
                 <p class="asc-desc" style="font-size:0.85rem; color:#86868b; margin:0 0 16px 0;">Wähle die gewünschte Montage-Option.</p>
                 <div class="montage-list" style="display:flex; flex-direction:column; gap:10px;">
            `;
            
            let roomsCount = this.state.rooms.length;
            options.forEach(opt => {
               let isSelected = this.state.montageType === opt.id;
               let optPrice = 0;
               if (opt.id !== 'keine') {
                 let vFirst = this.getMontageVariant(opt.id, true);
                 let vNext = this.getMontageVariant(opt.id, false);
                 let pFirst = vFirst ? vFirst.price : (opt.id === 'komplett' ? 75000 : (opt.id === 'anschluss' ? 70000 : 60000));
                 let pNext = vNext ? vNext.price : (opt.id === 'komplett' ? 30000 : (opt.id === 'anschluss' ? 20000 : 15000));
                 optPrice = pFirst + (roomsCount - 1) * pNext;
               }
               let priceLabel = opt.id === 'keine' ? 'Kostenlos' : `+ ${this.formatMoney(optPrice)}`;

               html += `
                 <button type="button" class="montage-card ${isSelected ? 'is-selected' : ''}" data-montage-type="${opt.id}" aria-pressed="${isSelected}">
                    <span class="montage-left">
                       <span class="montage-radio"></span>
                       <span class="montage-info">
                          <strong>${opt.title}</strong>
                          <span class="montage-desc">${opt.desc}</span>
                       </span>
                    </span>
                    <span class="montage-right">
                       <span class="montage-price">${priceLabel}</span>
                    </span>
                 </button>
               `;
               
               if (opt.id === 'komplett' && isSelected) {
                  let vMeter = this.getMontageVariant('laufmeter', false);
                  let pMeter = vMeter ? vMeter.price : 10000;
                  let meterPriceTotal = this.state.montageMeters * pMeter;
                  html += `
                    <div class="montage-meters-container" style="background:#f5f5f7; border-radius:12px; padding:12px; margin-top:4px; display:flex; flex-direction:column; gap:8px;">
                       <div class="meters-header" style="display:flex; justify-content:space-between; font-size:0.85rem; font-weight:600;">
                         <span class="meters-title" style="color:#1d1d1f;">Laufmeter Kältemittelleitung (gesamt)</span>
                         <span class="meters-value" style="color:#0071e3;">${this.state.montageMeters} m (+ ${this.formatMoney(meterPriceTotal)})</span>
                       </div>
                       <input type="range" class="klimondo-slider" min="${this.state.rooms.length * 3}" max="${this.getMaxLfm(this.state.rooms.length)}" value="${this.state.montageMeters}" id="MontageMetersSlider" style="width:100%; height:6px; -webkit-appearance:none; background:#d2d2d7; border-radius:3px; outline:none;">
                       <p style="font-size: 0.75rem; color: #86868b; margin: 0; text-align: center;">${this.formatMoney(pMeter)} pro Meter (inkl. Material & Verlegung)</p>
                    </div>
                  `;
               }
            });
            
            if (this.state.montageType !== 'keine') {
                html += `
                  <div class="montage-plz-validator-box" style="background:#fff3cd; border: 1px solid #ffeeba; border-radius:12px; padding:16px; margin-top:12px;">
                    <label for="PlzInput" style="font-weight:600; font-size:0.9rem; color:#856404; display:block; margin-bottom:6px;">Postleitzahl für Montageprüfung:</label>
                    <div style="display:flex; gap:8px;">
                      <input type="text" id="PlzInput" value="${this.state.plz || ''}" placeholder="z.B. 1010" style="padding:8px 12px; border:1px solid #ced4da; border-radius:6px; flex:1; font-size:14px; box-sizing: border-box; width:100%;">
                    </div>
                    <div class="plz-local-feedback" style="margin-top: 8px;"></div>
                  </div>
                `;
            }
            
            html += `</div></div>`;
        }
        
        container.innerHTML = html;
        
        let btnClose = container.querySelector('#BtnCloseMontage');
        if (btnClose) {
            btnClose.addEventListener('click', () => {
                this.state.montageExpanded = false;
                this.saveState();
                this.render();
            });
        }
        
        container.querySelectorAll('.montage-card').forEach(card => {
           card.addEventListener('click', (e) => {
              let type = e.currentTarget.dataset.montageType;
              if (this.state.montageType !== type) {
                  this.state.montageType = type;
                  this.applyMountAccessoryToState();
                  if (type === 'komplett') {
                      if (this.state.montageMeters === -1) {
                          this.state.montageMeters = this.state.rooms.length * 5;
                      }
                      const minLfm = this.state.rooms.length * 3;
                      if (this.state.montageMeters < minLfm) {
                          this.state.montageMeters = minLfm;
                      }
                      const maxLfm = this.getMaxLfm(this.state.rooms.length);
                      if (this.state.montageMeters > maxLfm) {
                          this.state.montageMeters = maxLfm;
                      }
                  }
                  this.saveState();
                  this.render();
              }
           });
        });
        
        let slider = container.querySelector('#MontageMetersSlider');
        if (slider) {
           let vMeter = this.getMontageVariant('laufmeter', false);
           let pMeter = vMeter ? vMeter.price : 10000;
           slider.addEventListener('input', (e) => {
              let val = parseInt(e.target.value);
              let meterPriceTotal = val * pMeter;
              container.querySelector('.meters-value').textContent = `${val} m (+ ${this.formatMoney(meterPriceTotal)})`;
           });
           slider.addEventListener('change', (e) => {
              let val = parseInt(e.target.value);
              const minLfm = this.state.rooms.length * 3;
              if (val < minLfm) val = minLfm;
              const maxLfm = this.getMaxLfm(this.state.rooms.length);
              if (val > maxLfm) val = maxLfm;
              this.state.montageMeters = val;
              this.saveState();
              this.render();
           });
        }

        let plzInput = container.querySelector('#PlzInput');
        if (plzInput) {
            const updateLocalPlzFeedback = () => {
                let val = plzInput.value.trim();
                let parentBox = plzInput.closest('.montage-plz-validator-box');
                if (!parentBox) return;
                let feedbackEl = parentBox.querySelector('.plz-local-feedback');
                
                if (!val) {
                    parentBox.style.background = '#fff3cd';
                    parentBox.style.borderColor = '#ffeeba';
                    if (feedbackEl) {
                        feedbackEl.innerHTML = '<span style="color:#856404; font-size:0.8rem;">Bitte gib deine Postleitzahl ein.</span>';
                    }
                } else {
                    let plzInt = parseInt(val, 10);
                    let isValidWien = isWienPlz(plzInt);
                    let isValidGraz = isGrazPlz(plzInt);
                    let plzValid = isValidWien || isValidGraz;
                    
                    if (plzValid) {
                        parentBox.style.background = '#e2f0d9';
                        parentBox.style.borderColor = '#c5e0b4';
                        if (feedbackEl) {
                            feedbackEl.innerHTML = '<span style="color:#385723; font-size:0.8rem; font-weight:600;">✓ Montageservice in deiner Region verfügbar.</span>';
                        }
                    } else {
                        parentBox.style.background = '#fce4d6';
                        parentBox.style.borderColor = '#f8cbad';
                        if (feedbackEl) {
                            feedbackEl.innerHTML = '<span style="color:#c65911; font-size:0.8rem; font-weight:600;">✗ Keine Montage in diesem Gebiet möglich (nur Lieferung).</span>';
                        }
                    }
                }
            };

            plzInput.addEventListener('input', (e) => {
                this.state.plz = e.target.value.trim();
                this.saveState();
                this.updateTotals();
                updateLocalPlzFeedback();
            });

            // Run initially
            updateLocalPlzFeedback();
        }
      }

      renderGarantie() {
        let container = this.querySelector('#GarantieContainer');
        if (!container) return;
        
        if (this.state.rooms.length === 0 || !this.state.matchedOutdoorVariant) {
            container.style.display = 'none';
            return;
        }
        
        container.style.display = 'block';

        let baseTotal = 0;
        this.state.rooms.forEach(r => {
            let model = this.data.indoor_units.find(u => u.id === r.modelId);
            let variant = model ? model.variants.find(v => v.id === r.variantId) : null;
            if (variant) baseTotal += variant.price;
        });

        if (this.state.matchedOutdoorVariant) {
            baseTotal += this.state.matchedOutdoorVariant.variant.price;
        }

        let accessories = this.getAccessories();
        if (accessories) {
            this.state.selectedAccessories.forEach(accId => {
                let acc = accessories.find(a => a.id === accId);
                if (acc && acc.variants.length > 0) {
                    let price = acc.variants[0].price;
                    let isCover = (acc.handle === 'abdeckung-aussengerat') || (acc.title && acc.title.toLowerCase().includes('abdeckung')) || acc.id === 16338514444633;
                    if (isCover) {
                        let outdoorDim = this.state.matchedOutdoorVariant ? (this.state.matchedOutdoorVariant.variant.dim || this.resolveOutdoorDimensions(this.state.matchedOutdoorVariant.variant.sku, this.state.matchedOutdoorVariant.title + ' ' + this.state.matchedOutdoorVariant.variant.title)) : null;
                        let matchingSize = this.state.coverSizeOverride || this.getMatchingCoverSize(outdoorDim, this.state.rooms.length);
                        let matchedVariant = this.getCoverVariant(acc, matchingSize, this.state.coverColor);
                        if (matchedVariant) {
                            price = matchedVariant.price;
                        }
                    }
                    baseTotal += price;
                }
            });
        }
        
        let roomsCount = this.state.rooms.length;
        if (roomsCount > 0 && this.state.matchedOutdoorVariant) {
            let mType = this.state.montageType;
            if (mType !== 'keine') {
                let vFirst = this.getMontageVariant(mType, true);
                let vNext = this.getMontageVariant(mType, false);
                let pFirst = vFirst ? vFirst.price : (mType === 'komplett' ? 75000 : (mType === 'anschluss' ? 70000 : 60000));
                let pNext = vNext ? vNext.price : (mType === 'komplett' ? 30000 : (mType === 'anschluss' ? 20000 : 15000));
                baseTotal += pFirst;
                if (roomsCount > 1) {
                    baseTotal += (roomsCount - 1) * pNext;
                }
                if (mType === 'komplett') {
                    let vMeter = this.getMontageVariant('laufmeter', false);
                    let pMeter = vMeter ? vMeter.price : 10000;
                    baseTotal += this.state.montageMeters * pMeter;
                }
            }
        }

        let rawPercent = baseTotal * 0.09;
        let eurVal = rawPercent / 100;
        let roundedEur = Math.round(eurVal / 10) * 10;
        let warrantyPrice = roundedEur * 100;
        let formattedWarrantyPrice = this.formatMoney(warrantyPrice);

        const options = [
           { id: '2_jahre', title: '2 Jahre Gewährleistung', desc: 'Auf verkaufte Produkte bzw. Dienstleistung.', priceLabel: 'kostenlos' },
           { id: '5_jahre', title: '5 Jahre Garantie', desc: 'Auf gelieferte Produkte, keine Arbeitskosten.', priceLabel: `+ ${formattedWarrantyPrice}` }
        ];

        let selectedOpt = options.find(o => o.id === this.state.garantieType) || options[0];
        let html = '';

        if (!this.state.garantieExpanded) {
            let garantieDesc = 'Auf verkaufte Produkte bzw. Dienstleistung';
            if (this.state.garantieType === '5_jahre') {
              garantieDesc = `Auf gelieferte Produkte, keine Arbeitskosten (+ ${formattedWarrantyPrice})`;
            }

            html = `
              <div class="klimondo-summary-card" style="padding:0 !important; margin:0 0 24px 0 !important; background:none !important; border:none !important; box-shadow:none !important;">
                 <div class="asc-top" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
                    <div class="asc-title-group" style="display:flex; align-items:center; font-weight:600; font-size:1.35rem; color:#1d1d1f;">
                       <strong>Garantie. <span style="color:#86868b; font-weight:500;">Deine gewählte Laufzeit.</span></strong>
                    </div>
                 </div>
                 <p class="asc-desc" style="font-size:0.85rem; color:#86868b; margin:0 0 8px 0;">Sichere deine Investition mit einer langfristigen Garantie ab.</p>
                 
                 <div class="klimondo-selected-summary-box" id="BtnEditGarantie">
                    <div class="klimondo-summary-icon">
                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <div class="klimondo-summary-content">
                       <span class="klimondo-summary-title">${selectedOpt.title}</span>
                       <span class="klimondo-summary-desc">${garantieDesc}</span>
                    </div>
                    <div class="klimondo-summary-action">
                       Ändern
                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                    </div>
                 </div>
              </div>
            `;
        } else {
            html = `
              <div class="klimondo-summary-card" style="padding:0 !important; margin:0 0 24px 0 !important; background:none !important; border:none !important; box-shadow:none !important;">
                 <div class="asc-top" style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
                    <div class="asc-title-group" style="display:flex; align-items:center; font-weight:600; font-size:1.35rem; color:#1d1d1f;">
                       <strong>Garantie. <span style="color:#86868b; font-weight:500;">Wähle deine Laufzeit.</span></strong>
                    </div>
                    <button type="button" class="asc-btn" id="BtnCloseGarantie" style="background:none; border:none; color:#0071e3; cursor:pointer; font-weight:600; font-size:0.9rem; display:flex; align-items:center; gap:4px;">Schließen <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg></button>
                 </div>
                 <p class="asc-desc" style="font-size:0.85rem; color:#86868b; margin:0 0 16px 0;">Sichere deine Investition mit einer längeren Garantie ab.</p>
                 <div class="montage-list" style="display:flex; flex-direction:column; gap:10px;">
            `;
            
            options.forEach(opt => {
               let isSelected = this.state.garantieType === opt.id;
               html += `
                 <button type="button" class="montage-card ${isSelected ? 'is-selected' : ''}" data-garantie-type="${opt.id}" aria-pressed="${isSelected}">
                    <span class="montage-left">
                       <span class="montage-radio"></span>
                       <span class="montage-info">
                          <strong>${opt.title}</strong>
                          <span class="montage-desc">${opt.desc}</span>
                       </span>
                    </span>
                    <span class="montage-right">
                       <span class="montage-price">${opt.priceLabel}</span>
                    </span>
                 </button>
               `;
            });
            
            html += `</div></div>`;
        }
        
        container.innerHTML = html;
      }
      renderTechnicalSpecs() {
        const specsSection = document.getElementById('configurator-specs-section');
        const specsGrid = document.getElementById('specs-grid-container');
        if (!specsSection || !specsGrid) return;

        let hasIndoorSelection = false;
        const indoorCardsHtml = [];

        this.state.rooms.forEach((room, index) => {
          let model = this.data.indoor_units.find(u => u.id === room.modelId);
          let variant = model ? model.variants.find(v => v.id === room.variantId) : null;
          
          if (variant) {
            hasIndoorSelection = true;
            let roomName = this.getRoomName(room, index);
            
            let listHtml = '';
            listHtml += `<li><span class="klimondo-specs-label">Modell</span><span class="klimondo-specs-value">${model.brand} ${model.title} (${variant.title})</span></li>`;
            
            const kwVal = room.kw || this.getMaxKwFromSku(variant.sku, variant.title);
            let coolVal = variant.cool ? (variant.cool.toString().toLowerCase().includes('kw') ? variant.cool : variant.cool + ' kW') : (kwVal.toFixed(1) + ' kW');
            listHtml += `<li><span class="klimondo-specs-label">Nom. Kühlleistung</span><span class="klimondo-specs-value">${coolVal}</span></li>`;
            
            if (variant.heat) {
              let heatVal = variant.heat.toString().toLowerCase().includes('kw') ? variant.heat : variant.heat + ' kW';
              listHtml += `<li><span class="klimondo-specs-label">Nom. Heizleistung</span><span class="klimondo-specs-value">${heatVal}</span></li>`;
            }
            if (variant.sound) listHtml += `<li><span class="klimondo-specs-label">Schalldruckpegel</span><span class="klimondo-specs-value">${variant.sound}</span></li>`;
            if (variant.dim) listHtml += `<li><span class="klimondo-specs-label">Abmessungen</span><span class="klimondo-specs-value">${variant.dim}</span></li>`;
            if (variant.weight) {
              let weightVal = variant.weight.toString().toLowerCase().includes('kg') ? variant.weight : variant.weight + ' kg';
              listHtml += `<li><span class="klimondo-specs-label">Gewicht</span><span class="klimondo-specs-value">${weightVal}</span></li>`;
            }
            if (variant.cons) listHtml += `<li><span class="klimondo-specs-label">Jahresverbrauch</span><span class="klimondo-specs-value">${variant.cons}</span></li>`;
            listHtml += `<li><span class="klimondo-specs-label">SKU</span><span class="klimondo-specs-value">${variant.sku}</span></li>`;

            let downloadsHtml = '';
            const pdfData = resolvePdfUrl(variant.pdf_data);
            if (pdfData) {
              downloadsHtml += `<a href="${pdfData}" target="_blank" class="klimondo-specs-download-link">📄 Datenbuch</a>`;
            }
            const pdfManual = resolvePdfUrl(variant.pdf_manual);
            if (pdfManual) {
              downloadsHtml += `<a href="${pdfManual}" target="_blank" class="klimondo-specs-download-link">📘 Bedienungsanleitung</a>`;
            }

            indoorCardsHtml.push(`
              <div class="klimondo-specs-card">
                <div>
                  <h4>Raum ${index + 1}: ${roomName} (${room.size} m²)</h4>
                  <ul class="klimondo-specs-list">
                    ${listHtml}
                  </ul>
                </div>
                ${downloadsHtml ? `<div class="klimondo-specs-downloads">${downloadsHtml}</div>` : ''}
              </div>
            `);
          }
        });

        let outdoorCardHtml = '';
        if (this.state.matchedOutdoorVariant) {
          const cand = this.state.matchedOutdoorVariant;
          const ov = cand.variant;

          let listHtml = '';
          listHtml += `<li><span class="klimondo-specs-label">Modell</span><span class="klimondo-specs-value">${cand.title} (${ov.title.replace(/Leistungsklasse:\s*/i, '').trim()})</span></li>`;
          
          const maxKwVal = ov.maxKw || this.getMaxKwFromSku(ov.sku, ov.title);
          let coolVal = ov.cool ? (ov.cool.toString().toLowerCase().includes('kw') ? ov.cool : ov.cool + ' kW') : (maxKwVal.toFixed(1) + ' kW');
          listHtml += `<li><span class="klimondo-specs-label">Nom. Kühlleistung</span><span class="klimondo-specs-value">${coolVal}</span></li>`;
          
          if (ov.heat) {
            let heatVal = ov.heat.toString().toLowerCase().includes('kw') ? ov.heat : ov.heat + ' kW';
            listHtml += `<li><span class="klimondo-specs-label">Nom. Heizleistung</span><span class="klimondo-specs-value">${heatVal}</span></li>`;
          }
          if (ov.energy) listHtml += `<li><span class="klimondo-specs-label">Effizienzklasse</span><span class="klimondo-specs-value">${ov.energy}</span></li>`;
          if (ov.sound) listHtml += `<li><span class="klimondo-specs-label">Schalldruckpegel</span><span class="klimondo-specs-value">${ov.sound}</span></li>`;
          if (ov.dim) listHtml += `<li><span class="klimondo-specs-label">Abmessungen</span><span class="klimondo-specs-value">${ov.dim}</span></li>`;
          if (ov.weight) {
            let weightVal = ov.weight.toString().toLowerCase().includes('kg') ? ov.weight : ov.weight + ' kg';
            listHtml += `<li><span class="klimondo-specs-label">Gewicht</span><span class="klimondo-specs-value">${weightVal}</span></li>`;
          }
          if (ov.cons) listHtml += `<li><span class="klimondo-specs-label">Jahresverbrauch</span><span class="klimondo-specs-value">${ov.cons}</span></li>`;
          listHtml += `<li><span class="klimondo-specs-label">SKU</span><span class="klimondo-specs-value">${ov.sku || ''}</span></li>`;

          let downloadsHtml = '';
          const pdfData = resolvePdfUrl(ov.pdf_data);
          if (pdfData) {
            downloadsHtml += `<a href="${pdfData}" target="_blank" class="klimondo-specs-download-link">📄 Datenbuch</a>`;
          }
          const pdfManual = resolvePdfUrl(ov.pdf_manual);
          if (pdfManual) {
            downloadsHtml += `<a href="${pdfManual}" target="_blank" class="klimondo-specs-download-link">📘 Bedienungsanleitung</a>`;
          }

          outdoorCardHtml = `
            <div class="klimondo-specs-card" style="border-left: 4px solid #0071e3;">
              <div>
                <h4>Außengerät</h4>
                <ul class="klimondo-specs-list">
                  ${listHtml}
                </ul>
              </div>
              ${downloadsHtml ? `<div class="klimondo-specs-downloads">${downloadsHtml}</div>` : ''}
            </div>
          `;
        }

        if (hasIndoorSelection) {
          specsGrid.innerHTML = indoorCardsHtml.join('') + outdoorCardHtml;
          specsSection.style.display = 'block';
        } else {
          specsSection.style.display = 'none';
        }
      }

      renderScrollspy() {
        let scrollspyContainer = this.querySelector('.configurator-scrollspy');
        if (!scrollspyContainer) {
          scrollspyContainer = document.createElement('div');
          scrollspyContainer.className = 'configurator-scrollspy';
          this.appendChild(scrollspyContainer);
        }
        
        scrollspyContainer.innerHTML = '';
        
        // Define logical sections
        let targets = [
          { id: 'GlobalSettingsContainer', title: '1. Allgemeine Bedingungen' },
          { id: 'RoomsContainer', title: '2. Räume' }
        ];
        
        if (this.matchResultEl && this.matchResultEl.style.display !== 'none') {
           targets.push({ id: 'OutdoorMatchResult', title: '3. Außengerät' });
        }
        
        if (this.accessoriesContainer && this.accessoriesContainer.style.display !== 'none') {
           targets.push({ id: 'AccessoriesContainer', title: '4. Zubehör' });
        }
        
        // Ensure future sections exist, even if empty/hidden initially.
        let montageContainer = this.querySelector('#MontageContainer');
        if (montageContainer && montageContainer.style.display !== 'none') {
           targets.push({ id: 'MontageContainer', title: '5. Montage' });
        }
        
        let garantieContainer = this.querySelector('#GarantieContainer');
        if (garantieContainer && garantieContainer.style.display !== 'none') {
           targets.push({ id: 'GarantieContainer', title: '6. Garantieverlängerung' });
        }

        if (this.scrollspyObserver) {
          this.scrollspyObserver.disconnect();
        }
        
        targets.forEach(t => {
          let targetEl = null;
          if (t.isRoom) {
             targetEl = this.querySelector(`.room-card[data-toggle="${t.roomId}"]`);
          } else {
             targetEl = this.querySelector(`#${t.id}`);
          }
          
          if (targetEl) {
             let dotId = targetEl.id || `ScrollspyTarget_${Math.random().toString(36).substr(2, 9)}`;
             if (!targetEl.id) targetEl.id = dotId;
             
             let dot = document.createElement('div');
             dot.className = 'scrollspy-dot';
             dot.dataset.title = t.title;
             dot.dataset.target = targetEl.id;
             dot.addEventListener('click', () => {
               // Calculate offset to account for sticky header
               const headerOffset = window.innerWidth >= 1024 ? 60 : 100;
               const elementPosition = targetEl.getBoundingClientRect().top;
               const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
               
               window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
               });
             });
             scrollspyContainer.appendChild(dot);
             this.scrollspyObserver.observe(targetEl);
          }
        });
        
        // Default first dot if none active
        if (!scrollspyContainer.querySelector('.is-active') && scrollspyContainer.firstElementChild) {
           scrollspyContainer.firstElementChild.classList.add('is-active');
        }
      }

      compileCartItems() {
        let baseTotal = 0;
        this.state.rooms.forEach(r => {
            let model = this.data.indoor_units.find(u => u.id === r.modelId);
            let variant = model ? model.variants.find(v => v.id === r.variantId) : null;
            if (variant) baseTotal += variant.price;
        });
        if (this.state.matchedOutdoorVariant) {
            baseTotal += this.state.matchedOutdoorVariant.variant.price;
        }
        let localAccs = this.getAccessories();
        if (localAccs) {
            this.state.selectedAccessories.forEach(accId => {
                let acc = localAccs.find(a => a.id === accId);
                if (acc && acc.variants.length > 0) {
                    let price = acc.variants[0].price;
                    let isCover = (acc.handle === 'abdeckung-aussengerat') || (acc.title && acc.title.toLowerCase().includes('abdeckung')) || acc.id === 16338514444633;
                    if (isCover) {
                        let outdoorDim = this.state.matchedOutdoorVariant ? (this.state.matchedOutdoorVariant.variant.dim || this.resolveOutdoorDimensions(this.state.matchedOutdoorVariant.variant.sku, this.state.matchedOutdoorVariant.title + ' ' + this.state.matchedOutdoorVariant.variant.title)) : null;
                        let matchingSize = this.state.coverSizeOverride || this.getMatchingCoverSize(outdoorDim, this.state.rooms.length);
                        let matchedVariant = this.getCoverVariant(acc, matchingSize, this.state.coverColor);
                        if (matchedVariant) {
                            price = matchedVariant.price;
                        }
                    }
                    baseTotal += price;
                }
            });
        }
        let localRoomsCount = this.state.rooms.length;
        if (localRoomsCount > 0 && this.state.matchedOutdoorVariant) {
            let mType = this.state.montageType;
            if (mType !== 'keine') {
                let vFirst = this.getMontageVariant(mType, true);
                let vNext = this.getMontageVariant(mType, false);
                let pFirst = vFirst ? vFirst.price : (mType === 'komplett' ? 75000 : (mType === 'anschluss' ? 70000 : 60000));
                let pNext = vNext ? vNext.price : (mType === 'komplett' ? 30000 : (mType === 'anschluss' ? 20000 : 15000));
                baseTotal += pFirst;
                if (localRoomsCount > 1) {
                    baseTotal += (localRoomsCount - 1) * pNext;
                }
                if (mType === 'komplett') {
                    if (this.state.montageMeters === -1) {
                        this.state.montageMeters = localRoomsCount * 5;
                    }
                    const minLfm = localRoomsCount * 3;
                    if (this.state.montageMeters < minLfm) {
                        this.state.montageMeters = minLfm;
                    }
                    const maxLfm = this.getMaxLfm(localRoomsCount);
                    if (this.state.montageMeters > maxLfm) {
                        this.state.montageMeters = maxLfm;
                    }
                    let vMeter = this.getMontageVariant('laufmeter', false);
                    let pMeter = vMeter ? vMeter.price : 10000;
                    baseTotal += this.state.montageMeters * pMeter;
                }
            }
        }

        let properties = {};
        let rawPercent = baseTotal * 0.09;
        let eurVal = rawPercent / 100;
        let roundedEur = Math.round(eurVal / 10) * 10;
        properties['Garantie'] = this.state.garantieType === '5_jahre' ? `5 Jahre Garantie (+ € ${roundedEur},-)` : '2 Jahre Gewährleistung (kostenlos)';
        
        let mType = this.state.montageType;
        properties['Montage & Service'] = mType === 'komplett' ? `Komplettmontage (inkl. ${this.state.montageMeters} m Leitung)` : (mType === 'anschluss' ? 'Anschluss & Inbetriebnahme' : (mType === 'inbetriebnahme' ? 'Nur Inbetriebnahme' : 'Gerätelieferung'));
        if (mType !== 'keine' && this.state.plz) {
            properties['Montage-PLZ'] = this.state.plz;
        }

        this.state.rooms.forEach((r, idx) => {
            let model = this.data.indoor_units.find(u => u.id === r.modelId);
            let variant = model ? model.variants.find(v => v.id === r.variantId) : null;
            if (variant) {
                let name = r.customName || `Raum ${idx + 1}`;
                properties[name] = `${r.size} m² - ${model.title} (${variant.title}) / SKU: ${variant.sku || ''}`;
            }
        });

        let items = [];
        
        // Add Outdoor Unit
        items.push({
            id: this.state.matchedOutdoorVariant.variant.id,
            quantity: 1,
            properties: properties
        });

        // Add Indoor Units
        this.state.rooms.forEach(r => {
            if (r.variantId) {
                // Group identical variants
                let existing = items.find(i => i.id === r.variantId);
                if (existing) {
                    existing.quantity += 1;
                } else {
                    items.push({
                        id: r.variantId,
                        quantity: 1
                    });
                }
            }
        });

        // Add Accessories
        let accessories = this.getAccessories();
        if (accessories) {
            let accCounts = {};
            this.state.selectedAccessories.forEach(accId => {
                accCounts[accId] = (accCounts[accId] || 0) + 1;
            });
            Object.entries(accCounts).forEach(([accId, qty]) => {
                let acc = accessories.find(a => a.id === parseInt(accId));
                if (acc && acc.variants.length > 0 && qty > 0) {
                    let varId = acc.variants[0].id;
                    let isCover = (acc.handle === 'abdeckung-aussengerat') || (acc.title && acc.title.toLowerCase().includes('abdeckung')) || acc.id === 16338514444633;
                    if (isCover) {
                        let outdoorDim = this.state.matchedOutdoorVariant ? (this.state.matchedOutdoorVariant.variant.dim || this.resolveOutdoorDimensions(this.state.matchedOutdoorVariant.variant.sku, this.state.matchedOutdoorVariant.title + ' ' + this.state.matchedOutdoorVariant.variant.title)) : null;
                        let matchingSize = this.state.coverSizeOverride || this.getMatchingCoverSize(outdoorDim, this.state.rooms.length);
                        let matchedVariant = this.getCoverVariant(acc, matchingSize, this.state.coverColor);
                        if (matchedVariant) {
                            varId = matchedVariant.id;
                        }
                    }
                    items.push({
                        id: varId,
                        quantity: qty
                    });
                }
            });
        }
        
        // Add Montage
        let roomsCount = this.state.rooms.length;
        if (roomsCount > 0 && this.state.montageType && this.state.montageType !== 'keine') {
            let mType = this.state.montageType;
            let vFirst = this.getMontageVariant(mType, true);
            let vNext = this.getMontageVariant(mType, false);
            
            if (vFirst) items.push({ id: vFirst.id, quantity: 1 });
            if (vNext && roomsCount > 1) items.push({ id: vNext.id, quantity: roomsCount - 1 });
            
            if (mType === 'komplett') {
                let vMeter = this.getMontageVariant('laufmeter', false);
                if (vMeter && this.state.montageMeters > 0) {
                    items.push({ id: vMeter.id, quantity: this.state.montageMeters });
                }
            }
        }
        return { items, properties };
      }

      addToCart() {
        if (!this.state.matchedOutdoorVariant) return;

        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = 'Wird geladen...';
        if (this.bottomAddToCartBtn) {
          this.bottomAddToCartBtn.disabled = true;
          this.bottomAddToCartBtn.textContent = 'Wird geladen...';
        }
        this.errorEl.style.display = 'none';
        if (this.bottomErrorEl) {
          this.bottomErrorEl.style.display = 'none';
        }

        const { items } = this.compileCartItems();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(response => {
            if (!response.ok) throw new Error('Fehler beim Hinzufügen');
            return response.json();
        })
        .then(() => {
            window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(err => {
            console.error(err);
            const errMsg = 'Fehler beim Hinzufügen zum Warenkorb. Bitte überprüfe die Bestände.';
            this.errorEl.textContent = errMsg;
            this.errorEl.style.display = 'block';
            if (this.bottomErrorEl) {
                this.bottomErrorEl.textContent = errMsg;
                this.bottomErrorEl.style.display = 'block';
            }
            this.addToCartBtn.disabled = false;
            this.addToCartBtn.textContent = 'In den Warenkorb';
            if (this.bottomAddToCartBtn) {
                this.bottomAddToCartBtn.disabled = false;
                this.bottomAddToCartBtn.textContent = 'In den Warenkorb';
            }
        });
      }

      async requestQuote() {
        if (!this.state.matchedOutdoorVariant) return;

        this.addToCartBtn.disabled = true;
        if (this.requestQuoteBtn) {
          this.requestQuoteBtn.disabled = true;
          this.requestQuoteBtn.textContent = 'Leite zur Anfrage weiter...';
        }
        if (this.bottomAddToCartBtn) this.bottomAddToCartBtn.disabled = true;
        if (this.bottomRequestQuoteBtn) {
          this.bottomRequestQuoteBtn.disabled = true;
          this.bottomRequestQuoteBtn.textContent = 'Leite zur Anfrage weiter...';
        }

        const { items } = this.compileCartItems();

        try {
          await fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' });
          
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { checkout_type: 'quote' } })
          });
          
          window.location.href = window.Shopify.routes.root + 'checkout';
        } catch (err) {
          console.error(err);
          const errMsg = 'Fehler beim Erstellen des Angebots. Bitte versuche es erneut.';
          this.errorEl.textContent = errMsg;
          this.errorEl.style.display = 'block';
          if (this.bottomErrorEl) {
              this.bottomErrorEl.textContent = errMsg;
              this.bottomErrorEl.style.display = 'block';
          }
          this.addToCartBtn.disabled = false;
          if (this.requestQuoteBtn) {
            this.requestQuoteBtn.disabled = false;
            this.requestQuoteBtn.textContent = 'Als Angebot anfordern';
          }
          if (this.bottomAddToCartBtn) this.bottomAddToCartBtn.disabled = false;
          if (this.bottomRequestQuoteBtn) {
            this.bottomRequestQuoteBtn.disabled = false;
            this.bottomRequestQuoteBtn.textContent = 'Als Angebot anfordern';
          }
        }
      }
    }
  );
}
